/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.1.3.0 (NJsonSchema v10.0.27.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

export class EstimateHistoryClient {
  private instance: AxiosInstance;
  private baseUrl: string;
  protected jsonParseReviver:
    | ((key: string, value: any) => any)
    | undefined = undefined;

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    this.instance = instance ? instance : axios.create();
    this.baseUrl = baseUrl ? baseUrl : "";
  }

  estimates_GetEstimates(
    opts: ODataQueryOptionsOfEstimate | null,
    dto: string | null | undefined,
    activeEstimates: boolean | undefined,
    hideExcludedEstimates: boolean | undefined
  ): Promise<EstimateSummary[]> {
    let url_ = this.baseUrl + "/api/estimates?";
    if (dto !== undefined) url_ += "dto=" + encodeURIComponent("" + dto) + "&";
    if (activeEstimates === null)
      throw new Error("The parameter 'activeEstimates' cannot be null.");
    else if (activeEstimates !== undefined)
      url_ +=
        "activeEstimates=" + encodeURIComponent("" + activeEstimates) + "&";
    if (hideExcludedEstimates === null)
      throw new Error("The parameter 'hideExcludedEstimates' cannot be null.");
    else if (hideExcludedEstimates !== undefined)
      url_ +=
        "hideExcludedEstimates=" +
        encodeURIComponent("" + hideExcludedEstimates) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(opts);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "GET",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processEstimates_GetEstimates(_response);
    });
  }

  protected processEstimates_GetEstimates(
    response: AxiosResponse
  ): Promise<EstimateSummary[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(EstimateSummary.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<EstimateSummary[]>(<any>null);
  }

  estimates_GetEstimate(
    id: string,
    dto: string | null | undefined
  ): Promise<EstimateSummaryExtended> {
    let url_ = this.baseUrl + "/api/estimates/{id}?";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (dto !== undefined) url_ += "dto=" + encodeURIComponent("" + dto) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processEstimates_GetEstimate(_response);
    });
  }

  protected processEstimates_GetEstimate(
    response: AxiosResponse
  ): Promise<EstimateSummaryExtended> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = EstimateSummaryExtended.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<EstimateSummaryExtended>(<any>null);
  }

  estimates_GetEstimateBlob(id: string): Promise<FileResponse> {
    let url_ = this.baseUrl + "/api/estimates/download/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processEstimates_GetEstimateBlob(_response);
    });
  }

  protected processEstimates_GetEstimateBlob(
    response: AxiosResponse
  ): Promise<FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse>(<any>null);
  }

  estimates_PutEstimate(id: string, estimate: Estimate): Promise<void> {
    let url_ = this.baseUrl + "/api/estimates/{id}/{estimate}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    if (estimate === undefined || estimate === null)
      throw new Error("The parameter 'estimate' must be defined.");
    url_ = url_.replace("{estimate}", encodeURIComponent("" + estimate));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "PUT",
      url: url_,
      headers: {}
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processEstimates_PutEstimate(_response);
    });
  }

  protected processEstimates_PutEstimate(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  estimates_PostExcluded(
    estimateToSet: EstimateExcluded | null
  ): Promise<Estimate> {
    let url_ = this.baseUrl + "/api/estimates/excluded";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(estimateToSet);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processEstimates_PostExcluded(_response);
    });
  }

  protected processEstimates_PostExcluded(
    response: AxiosResponse
  ): Promise<Estimate> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = Estimate.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<Estimate>(<any>null);
  }

  estimates_DeleteEstimateById(id: string): Promise<DeleteEstimateViewModel> {
    let url_ = this.baseUrl + "/api/estimates/delete/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processEstimates_DeleteEstimateById(_response);
    });
  }

  protected processEstimates_DeleteEstimateById(
    response: AxiosResponse
  ): Promise<DeleteEstimateViewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DeleteEstimateViewModel.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<DeleteEstimateViewModel>(<any>null);
  }

  estimates_DeleteEstimateByCode(
    code: string | null
  ): Promise<DeleteEstimateViewModel> {
    let url_ = this.baseUrl + "/api/estimates/delete?";
    if (code === undefined)
      throw new Error("The parameter 'code' must be defined.");
    else url_ += "code=" + encodeURIComponent("" + code) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processEstimates_DeleteEstimateByCode(_response);
    });
  }

  protected processEstimates_DeleteEstimateByCode(
    response: AxiosResponse
  ): Promise<DeleteEstimateViewModel> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = DeleteEstimateViewModel.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<DeleteEstimateViewModel>(<any>null);
  }

  estimates_DoesEstimateCodesExist(
    codes: string[] | null | undefined,
    searchActiveEstimates: boolean | undefined
  ): Promise<EstimateExistViewModel[]> {
    let url_ = this.baseUrl + "/api/estimates/exist?";
    if (codes !== undefined)
      codes &&
        codes.forEach(item => {
          url_ += "codes=" + encodeURIComponent("" + item) + "&";
        });
    if (searchActiveEstimates === null)
      throw new Error("The parameter 'searchActiveEstimates' cannot be null.");
    else if (searchActiveEstimates !== undefined)
      url_ +=
        "searchActiveEstimates=" +
        encodeURIComponent("" + searchActiveEstimates) +
        "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processEstimates_DoesEstimateCodesExist(_response);
    });
  }

  protected processEstimates_DoesEstimateCodesExist(
    response: AxiosResponse
  ): Promise<EstimateExistViewModel[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(EstimateExistViewModel.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<EstimateExistViewModel[]>(<any>null);
  }

  estimates_GetEstimateIndex(
    opts: ODataQueryOptionsOfEstimate | null,
    code: string | null
  ): Promise<EstimateIndex> {
    let url_ = this.baseUrl + "/api/estimates/estimateindex?";
    if (code === undefined)
      throw new Error("The parameter 'code' must be defined.");
    else url_ += "code=" + encodeURIComponent("" + code) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(opts);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "GET",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processEstimates_GetEstimateIndex(_response);
    });
  }

  protected processEstimates_GetEstimateIndex(
    response: AxiosResponse
  ): Promise<EstimateIndex> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = EstimateIndex.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<EstimateIndex>(<any>null);
  }

  estimates_GetEstimateBackupHash(estimateId: string): Promise<string> {
    let url_ = this.baseUrl + "/api/estimates/hash?";
    if (estimateId === undefined || estimateId === null)
      throw new Error(
        "The parameter 'estimateId' must be defined and cannot be null."
      );
    else url_ += "estimateId=" + encodeURIComponent("" + estimateId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processEstimates_GetEstimateBackupHash(_response);
    });
  }

  protected processEstimates_GetEstimateBackupHash(
    response: AxiosResponse
  ): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = resultData200 !== undefined ? resultData200 : <any>null;
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<string>(<any>null);
  }

  insightsEstimates_GetEstimate(
    opts: ODataQueryOptionsOfEstimateFlattened | null,
    liveEstimates: boolean | undefined
  ): Promise<EstimateFlattened[]> {
    let url_ = this.baseUrl + "/api/insights/estimates?";
    if (liveEstimates === null)
      throw new Error("The parameter 'liveEstimates' cannot be null.");
    else if (liveEstimates !== undefined)
      url_ += "liveEstimates=" + encodeURIComponent("" + liveEstimates) + "&";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(opts);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "GET",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processInsightsEstimates_GetEstimate(_response);
    });
  }

  protected processInsightsEstimates_GetEstimate(
    response: AxiosResponse
  ): Promise<EstimateFlattened[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(EstimateFlattened.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<EstimateFlattened[]>(<any>null);
  }

  insightsEstimates_GetReportsForEstimate(
    estimateId: string
  ): Promise<ReportsDto> {
    let url_ = this.baseUrl + "/api/insights/estimates/reports?";
    if (estimateId === undefined || estimateId === null)
      throw new Error(
        "The parameter 'estimateId' must be defined and cannot be null."
      );
    else url_ += "estimateId=" + encodeURIComponent("" + estimateId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processInsightsEstimates_GetReportsForEstimate(_response);
    });
  }

  protected processInsightsEstimates_GetReportsForEstimate(
    response: AxiosResponse
  ): Promise<ReportsDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = ReportsDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<ReportsDto>(<any>null);
  }

  insightsEstimates_GetUniqueEstimateFilters(): Promise<UniqueEstimateFilters> {
    let url_ = this.baseUrl + "/api/insights/estimates/filters";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processInsightsEstimates_GetUniqueEstimateFilters(_response);
    });
  }

  protected processInsightsEstimates_GetUniqueEstimateFilters(
    response: AxiosResponse
  ): Promise<UniqueEstimateFilters> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = UniqueEstimateFilters.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<UniqueEstimateFilters>(<any>null);
  }

  insightsEstimates_PostExcluded(
    estimateToSet: EstimateExcluded | null
  ): Promise<Estimate> {
    let url_ = this.baseUrl + "/api/insights/estimates/excluded";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(estimateToSet);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processInsightsEstimates_PostExcluded(_response);
    });
  }

  protected processInsightsEstimates_PostExcluded(
    response: AxiosResponse
  ): Promise<Estimate> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = Estimate.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<Estimate>(<any>null);
  }

  quoteFolders_GetQuoteFolders(
    estimateId: string | null | undefined
  ): Promise<QuoteFolderSummaryDto[]> {
    let url_ = this.baseUrl + "/api/v1/quoteFolders?";
    if (estimateId !== undefined)
      url_ += "estimateId=" + encodeURIComponent("" + estimateId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteFolders_GetQuoteFolders(_response);
    });
  }

  protected processQuoteFolders_GetQuoteFolders(
    response: AxiosResponse
  ): Promise<QuoteFolderSummaryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(QuoteFolderSummaryDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<QuoteFolderSummaryDto[]>(<any>null);
  }

  quoteFolders_CreateQuoteFolder(): Promise<FileResponse | null> {
    let url_ = this.baseUrl + "/api/v1/quoteFolders";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      responseType: "blob",
      method: "POST",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteFolders_CreateQuoteFolder(_response);
    });
  }

  protected processQuoteFolders_CreateQuoteFolder(
    response: AxiosResponse
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  quoteFolders_GetQuoteFolder(id: string): Promise<QuoteFolderDto> {
    let url_ = this.baseUrl + "/api/v1/quoteFolders/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteFolders_GetQuoteFolder(_response);
    });
  }

  protected processQuoteFolders_GetQuoteFolder(
    response: AxiosResponse
  ): Promise<QuoteFolderDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuoteFolderDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<QuoteFolderDto>(<any>null);
  }

  quoteFolders_UpdateQuoteFolder(id: string): Promise<FileResponse | null> {
    let url_ = this.baseUrl + "/api/v1/quoteFolders/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      responseType: "blob",
      method: "PUT",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteFolders_UpdateQuoteFolder(_response);
    });
  }

  protected processQuoteFolders_UpdateQuoteFolder(
    response: AxiosResponse
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  quoteFolders_DeleteQuoteFolder(id: string): Promise<FileResponse | null> {
    let url_ = this.baseUrl + "/api/v1/quoteFolders/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      responseType: "blob",
      method: "DELETE",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteFolders_DeleteQuoteFolder(_response);
    });
  }

  protected processQuoteFolders_DeleteQuoteFolder(
    response: AxiosResponse
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  quoteFolders_GetQuoteFoldersDetails(
    estimateId: string | null | undefined
  ): Promise<QuoteFolderDto[]> {
    let url_ = this.baseUrl + "/api/v1/quoteFolders/details?";
    if (estimateId !== undefined)
      url_ += "estimateId=" + encodeURIComponent("" + estimateId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteFolders_GetQuoteFoldersDetails(_response);
    });
  }

  protected processQuoteFolders_GetQuoteFoldersDetails(
    response: AxiosResponse
  ): Promise<QuoteFolderDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(QuoteFolderDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<QuoteFolderDto[]>(<any>null);
  }

  quoteMasters_GetQuoteMasterByEstimateCode(
    estimateCode: string
  ): Promise<QuoteMasterDto> {
    let url_ = this.baseUrl + "/api/v1/quoteMasters/{estimateCode}";
    if (estimateCode === undefined || estimateCode === null)
      throw new Error("The parameter 'estimateCode' must be defined.");
    url_ = url_.replace(
      "{estimateCode}",
      encodeURIComponent("" + estimateCode)
    );
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteMasters_GetQuoteMasterByEstimateCode(_response);
    });
  }

  protected processQuoteMasters_GetQuoteMasterByEstimateCode(
    response: AxiosResponse
  ): Promise<QuoteMasterDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuoteMasterDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<QuoteMasterDto>(<any>null);
  }

  quoteMasters_SyncQuotesMaster(
    model: QuoteMasterDto | null
  ): Promise<GenericResponse> {
    let url_ = this.baseUrl + "/api/v1/quoteMasters";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(model);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteMasters_SyncQuotesMaster(_response);
    });
  }

  protected processQuoteMasters_SyncQuotesMaster(
    response: AxiosResponse
  ): Promise<GenericResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = GenericResponse.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<GenericResponse>(<any>null);
  }

  quotes_GetQuotes(): Promise<FileResponse | null> {
    let url_ = this.baseUrl + "/api/v1/quotes";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuotes_GetQuotes(_response);
    });
  }

  protected processQuotes_GetQuotes(
    response: AxiosResponse
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  quotes_CreateQuote(): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/quotes";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "POST",
      url: url_,
      headers: {}
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuotes_CreateQuote(_response);
    });
  }

  protected processQuotes_CreateQuote(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  quotes_GetQuote(id: string): Promise<FileResponse | null> {
    let url_ = this.baseUrl + "/api/v1/quotes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuotes_GetQuote(_response);
    });
  }

  protected processQuotes_GetQuote(
    response: AxiosResponse
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  quotes_UpdateQuote(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/quotes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "PUT",
      url: url_,
      headers: {}
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuotes_UpdateQuote(_response);
    });
  }

  protected processQuotes_UpdateQuote(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  quotes_DeleteQuote(id: string): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/quotes/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {}
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuotes_DeleteQuote(_response);
    });
  }

  protected processQuotes_DeleteQuote(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  quotes_AcceptQuote(dto: AcceptQuoteDto | null): Promise<FileResponse | null> {
    let url_ = this.baseUrl + "/api/v1/quotes/accept";
    url_ = url_.replace(/[?&]$/, "");

    const content_ = JSON.stringify(dto);

    let options_ = <AxiosRequestConfig>{
      data: content_,
      responseType: "blob",
      method: "POST",
      url: url_,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuotes_AcceptQuote(_response);
    });
  }

  protected processQuotes_AcceptQuote(
    response: AxiosResponse
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }

  quoteVendors_GetVendors(
    code: string | null | undefined,
    estimateId: string | null | undefined,
    folderId: string | null | undefined
  ): Promise<QuoteVendorSummaryDto[]> {
    let url_ = this.baseUrl + "/api/v1/quoteVendors?";
    if (code !== undefined)
      url_ += "code=" + encodeURIComponent("" + code) + "&";
    if (estimateId !== undefined)
      url_ += "estimateId=" + encodeURIComponent("" + estimateId) + "&";
    if (folderId !== undefined)
      url_ += "folderId=" + encodeURIComponent("" + folderId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteVendors_GetVendors(_response);
    });
  }

  protected processQuoteVendors_GetVendors(
    response: AxiosResponse
  ): Promise<QuoteVendorSummaryDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(QuoteVendorSummaryDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<QuoteVendorSummaryDto[]>(<any>null);
  }

  quoteVendors_CreateVendor(): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/quoteVendors";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "POST",
      url: url_,
      headers: {}
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteVendors_CreateVendor(_response);
    });
  }

  protected processQuoteVendors_CreateVendor(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  quoteVendors_UpdateVendor(): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/quoteVendors";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "PUT",
      url: url_,
      headers: {}
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteVendors_UpdateVendor(_response);
    });
  }

  protected processQuoteVendors_UpdateVendor(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  quoteVendors_DeleteVendor(): Promise<void> {
    let url_ = this.baseUrl + "/api/v1/quoteVendors";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "DELETE",
      url: url_,
      headers: {}
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteVendors_DeleteVendor(_response);
    });
  }

  protected processQuoteVendors_DeleteVendor(
    response: AxiosResponse
  ): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 204) {
      const _responseText = response.data;
      return Promise.resolve<void>(<any>null);
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<void>(<any>null);
  }

  quoteVendors_GetVendor(id: string): Promise<QuoteVendorDto> {
    let url_ = this.baseUrl + "/api/v1/quoteVendors/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteVendors_GetVendor(_response);
    });
  }

  protected processQuoteVendors_GetVendor(
    response: AxiosResponse
  ): Promise<QuoteVendorDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      result200 = QuoteVendorDto.fromJS(resultData200);
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<QuoteVendorDto>(<any>null);
  }

  quoteMasters_GetEstimatesPriceSyncStatus(): Promise<EstimateSyncStatusDto[]> {
    let url_ = this.baseUrl + "/api/v1/quoteMasters/lastsyncedprices";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processQuoteMasters_GetEstimatesPriceSyncStatus(_response);
    });
  }

  protected processQuoteMasters_GetEstimatesPriceSyncStatus(
    response: AxiosResponse
  ): Promise<EstimateSyncStatusDto[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data;
      let result200: any = null;
      let resultData200 = _responseText;
      if (Array.isArray(resultData200)) {
        result200 = [] as any;
        for (let item of resultData200)
          result200!.push(EstimateSyncStatusDto.fromJS(item));
      }
      return result200;
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<EstimateSyncStatusDto[]>(<any>null);
  }

  storageReports_GetReport(
    estimateId: string,
    reportType: string | null
  ): Promise<FileResponse | null> {
    let url_ = this.baseUrl + "/api/v1/storage/reports?";
    if (estimateId === undefined || estimateId === null)
      throw new Error(
        "The parameter 'estimateId' must be defined and cannot be null."
      );
    else url_ += "estimateId=" + encodeURIComponent("" + estimateId) + "&";
    if (reportType === undefined)
      throw new Error("The parameter 'reportType' must be defined.");
    else url_ += "reportType=" + encodeURIComponent("" + reportType) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_ = <AxiosRequestConfig>{
      responseType: "blob",
      method: "GET",
      url: url_,
      headers: {
        Accept: "application/json"
      }
    };

    return this.instance.request(options_).then((_response: AxiosResponse) => {
      return this.processStorageReports_GetReport(_response);
    });
  }

  protected processStorageReports_GetReport(
    response: AxiosResponse
  ): Promise<FileResponse | null> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k];
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers
        ? response.headers["content-disposition"]
        : undefined;
      const fileNameMatch = contentDisposition
        ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
        : undefined;
      const fileName =
        fileNameMatch && fileNameMatch.length > 1
          ? fileNameMatch[1]
          : undefined;
      return Promise.resolve({
        fileName: fileName,
        status: status,
        data: response.data as Blob,
        headers: _headers
      });
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data;
      return throwException(
        "An unexpected server error occurred.",
        status,
        _responseText,
        _headers
      );
    }
    return Promise.resolve<FileResponse | null>(<any>null);
  }
}

export class EstimateSummary implements IEstimateSummary {
  id!: string;
  code!: string;
  name!: string;
  processedStatus!: StatusCode;
  processedStatusFailureCode!: ProcessedEstimateFailureCode;
  estimateVersion?: string | undefined;
  bid_Date?: Date | undefined;
  start_Date?: Date | undefined;
  review_Date?: Date | undefined;
  created_Date?: Date | undefined;
  modified_Date?: Date | undefined;
  uploaded_Datetime?: Date | undefined;
  isExcludedEstimate!: boolean;

  constructor(data?: IEstimateSummary) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.code = _data["code"];
      this.name = _data["name"];
      this.processedStatus = _data["processedStatus"];
      this.processedStatusFailureCode = _data["processedStatusFailureCode"];
      this.estimateVersion = _data["estimateVersion"];
      this.bid_Date = _data["bid_Date"]
        ? new Date(_data["bid_Date"].toString())
        : <any>undefined;
      this.start_Date = _data["start_Date"]
        ? new Date(_data["start_Date"].toString())
        : <any>undefined;
      this.review_Date = _data["review_Date"]
        ? new Date(_data["review_Date"].toString())
        : <any>undefined;
      this.created_Date = _data["created_Date"]
        ? new Date(_data["created_Date"].toString())
        : <any>undefined;
      this.modified_Date = _data["modified_Date"]
        ? new Date(_data["modified_Date"].toString())
        : <any>undefined;
      this.uploaded_Datetime = _data["uploaded_Datetime"]
        ? new Date(_data["uploaded_Datetime"].toString())
        : <any>undefined;
      this.isExcludedEstimate = _data["isExcludedEstimate"];
    }
  }

  static fromJS(data: any): EstimateSummary {
    data = typeof data === "object" ? data : {};
    let result = new EstimateSummary();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["code"] = this.code;
    data["name"] = this.name;
    data["processedStatus"] = this.processedStatus;
    data["processedStatusFailureCode"] = this.processedStatusFailureCode;
    data["estimateVersion"] = this.estimateVersion;
    data["bid_Date"] = this.bid_Date
      ? this.bid_Date.toISOString()
      : <any>undefined;
    data["start_Date"] = this.start_Date
      ? this.start_Date.toISOString()
      : <any>undefined;
    data["review_Date"] = this.review_Date
      ? this.review_Date.toISOString()
      : <any>undefined;
    data["created_Date"] = this.created_Date
      ? this.created_Date.toISOString()
      : <any>undefined;
    data["modified_Date"] = this.modified_Date
      ? this.modified_Date.toISOString()
      : <any>undefined;
    data["uploaded_Datetime"] = this.uploaded_Datetime
      ? this.uploaded_Datetime.toISOString()
      : <any>undefined;
    data["isExcludedEstimate"] = this.isExcludedEstimate;
    return data;
  }
}

export interface IEstimateSummary {
  id: string;
  code: string;
  name: string;
  processedStatus: StatusCode;
  processedStatusFailureCode: ProcessedEstimateFailureCode;
  estimateVersion?: string | undefined;
  bid_Date?: Date | undefined;
  start_Date?: Date | undefined;
  review_Date?: Date | undefined;
  created_Date?: Date | undefined;
  modified_Date?: Date | undefined;
  uploaded_Datetime?: Date | undefined;
  isExcludedEstimate: boolean;
}

export enum StatusCode {
  Queued = 0,
  Processing = 1,
  Success = 2,
  Failure = 3,
  QueuedLarge = 4,
  TooLarge = 5
}

export enum ProcessedEstimateFailureCode {
  None = 0,
  Unknown = 1,
  BlobStorage = 2,
  ExtractEstimateData = 3,
  SaveEstimateData = 4,
  Attachments = 5,
  ConcurrencyCheck = 6,
  EstimateNotFound = 7,
  UpdateEstimateData = 8,
  Reports = 9,
  EstimateUpload = 10
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip, and $count. */
export class ODataQueryOptions implements IODataQueryOptions {
  /** Gets the given ODataQueryContext */
  context?: ODataQueryContext | undefined;
  /** Gets the request message associated with this instance. */
  request?: HttpRequestMessage | undefined;
  /** Gets the raw string of all the OData query options */
  rawValues?: ODataRawQueryOptions | undefined;
  /** Gets the SelectExpandQueryOption. */
  selectExpand?: SelectExpandQueryOption | undefined;
  apply?: ApplyQueryOption | undefined;
  /** Gets the FilterQueryOption. */
  filter?: FilterQueryOption | undefined;
  /** Gets the OrderByQueryOption. */
  orderBy?: OrderByQueryOption | undefined;
  /** Gets the SkipQueryOption. */
  skip?: SkipQueryOption | undefined;
  /** Gets the TopQueryOption. */
  top?: TopQueryOption | undefined;
  /** Gets the CountQueryOption. */
  count?: CountQueryOption | undefined;
  /** Gets or sets the query validator. */
  validator?: ODataQueryValidator | undefined;
  /** Gets the ETag from IfMatch header. */
  ifMatch?: ETag | undefined;
  /** Gets the ETag from IfNoneMatch header. */
  ifNoneMatch?: ETag | undefined;

  constructor(data?: IODataQueryOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.context = _data["context"]
        ? ODataQueryContext.fromJS(_data["context"])
        : <any>undefined;
      this.request = _data["request"]
        ? HttpRequestMessage.fromJS(_data["request"])
        : <any>undefined;
      this.rawValues = _data["rawValues"]
        ? ODataRawQueryOptions.fromJS(_data["rawValues"])
        : <any>undefined;
      this.selectExpand = _data["selectExpand"]
        ? SelectExpandQueryOption.fromJS(_data["selectExpand"])
        : <any>undefined;
      this.apply = _data["apply"]
        ? ApplyQueryOption.fromJS(_data["apply"])
        : <any>undefined;
      this.filter = _data["filter"]
        ? FilterQueryOption.fromJS(_data["filter"])
        : <any>undefined;
      this.orderBy = _data["orderBy"]
        ? OrderByQueryOption.fromJS(_data["orderBy"])
        : <any>undefined;
      this.skip = _data["skip"]
        ? SkipQueryOption.fromJS(_data["skip"])
        : <any>undefined;
      this.top = _data["top"]
        ? TopQueryOption.fromJS(_data["top"])
        : <any>undefined;
      this.count = _data["count"]
        ? CountQueryOption.fromJS(_data["count"])
        : <any>undefined;
      this.validator = _data["validator"]
        ? ODataQueryValidator.fromJS(_data["validator"])
        : <any>undefined;
      this.ifMatch = _data["ifMatch"]
        ? ETag.fromJS(_data["ifMatch"])
        : <any>undefined;
      this.ifNoneMatch = _data["ifNoneMatch"]
        ? ETag.fromJS(_data["ifNoneMatch"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ODataQueryOptions {
    data = typeof data === "object" ? data : {};
    let result = new ODataQueryOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["context"] = this.context ? this.context.toJSON() : <any>undefined;
    data["request"] = this.request ? this.request.toJSON() : <any>undefined;
    data["rawValues"] = this.rawValues
      ? this.rawValues.toJSON()
      : <any>undefined;
    data["selectExpand"] = this.selectExpand
      ? this.selectExpand.toJSON()
      : <any>undefined;
    data["apply"] = this.apply ? this.apply.toJSON() : <any>undefined;
    data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
    data["orderBy"] = this.orderBy ? this.orderBy.toJSON() : <any>undefined;
    data["skip"] = this.skip ? this.skip.toJSON() : <any>undefined;
    data["top"] = this.top ? this.top.toJSON() : <any>undefined;
    data["count"] = this.count ? this.count.toJSON() : <any>undefined;
    data["validator"] = this.validator
      ? this.validator.toJSON()
      : <any>undefined;
    data["ifMatch"] = this.ifMatch ? this.ifMatch.toJSON() : <any>undefined;
    data["ifNoneMatch"] = this.ifNoneMatch
      ? this.ifNoneMatch.toJSON()
      : <any>undefined;
    return data;
  }
}

/** This defines a composite OData query options that can be used to perform query composition. Currently this only supports $filter, $orderby, $top, $skip, and $count. */
export interface IODataQueryOptions {
  /** Gets the given ODataQueryContext */
  context?: ODataQueryContext | undefined;
  /** Gets the request message associated with this instance. */
  request?: HttpRequestMessage | undefined;
  /** Gets the raw string of all the OData query options */
  rawValues?: ODataRawQueryOptions | undefined;
  /** Gets the SelectExpandQueryOption. */
  selectExpand?: SelectExpandQueryOption | undefined;
  apply?: ApplyQueryOption | undefined;
  /** Gets the FilterQueryOption. */
  filter?: FilterQueryOption | undefined;
  /** Gets the OrderByQueryOption. */
  orderBy?: OrderByQueryOption | undefined;
  /** Gets the SkipQueryOption. */
  skip?: SkipQueryOption | undefined;
  /** Gets the TopQueryOption. */
  top?: TopQueryOption | undefined;
  /** Gets the CountQueryOption. */
  count?: CountQueryOption | undefined;
  /** Gets or sets the query validator. */
  validator?: ODataQueryValidator | undefined;
  /** Gets the ETag from IfMatch header. */
  ifMatch?: ETag | undefined;
  /** Gets the ETag from IfNoneMatch header. */
  ifNoneMatch?: ETag | undefined;
}

export class ODataQueryOptionsOfEstimate extends ODataQueryOptions
  implements IODataQueryOptionsOfEstimate {
  ifMatch?: ETagOfEstimate | undefined;
  ifNoneMatch?: ETagOfEstimate | undefined;

  constructor(data?: IODataQueryOptionsOfEstimate) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.ifMatch = _data["ifMatch"]
        ? ETagOfEstimate.fromJS(_data["ifMatch"])
        : <any>undefined;
      this.ifNoneMatch = _data["ifNoneMatch"]
        ? ETagOfEstimate.fromJS(_data["ifNoneMatch"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ODataQueryOptionsOfEstimate {
    data = typeof data === "object" ? data : {};
    let result = new ODataQueryOptionsOfEstimate();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["ifMatch"] = this.ifMatch ? this.ifMatch.toJSON() : <any>undefined;
    data["ifNoneMatch"] = this.ifNoneMatch
      ? this.ifNoneMatch.toJSON()
      : <any>undefined;
    super.toJSON(data);
    return data;
  }
}

export interface IODataQueryOptionsOfEstimate extends IODataQueryOptions {
  ifMatch?: ETagOfEstimate | undefined;
  ifNoneMatch?: ETagOfEstimate | undefined;
}

export class DynamicObject implements IDynamicObject {
  constructor(data?: IDynamicObject) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): DynamicObject {
    data = typeof data === "object" ? data : {};
    let result = new DynamicObject();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

export interface IDynamicObject {}

/** The ETag parsed from request. */
export class ETag extends DynamicObject implements IETag {
  item?: any | undefined;
  /** Gets or sets whether the ETag is well-formed. */
  isWellFormed!: boolean;
  /** Gets or sets an entity type of the ETag. */
  entityType?: string | undefined;
  /** Gets or sets whether the ETag is corresponding to "*". */
  isAny!: boolean;
  isIfNoneMatch!: boolean;
  concurrencyProperties?: { [key: string]: any } | undefined;

  constructor(data?: IETag) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.item = _data["item"];
      this.isWellFormed = _data["isWellFormed"];
      this.entityType = _data["entityType"];
      this.isAny = _data["isAny"];
      this.isIfNoneMatch = _data["isIfNoneMatch"];
      if (_data["concurrencyProperties"]) {
        this.concurrencyProperties = {} as any;
        for (let key in _data["concurrencyProperties"]) {
          if (_data["concurrencyProperties"].hasOwnProperty(key))
            this.concurrencyProperties![key] =
              _data["concurrencyProperties"][key];
        }
      }
    }
  }

  static fromJS(data: any): ETag {
    data = typeof data === "object" ? data : {};
    let result = new ETag();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["item"] = this.item;
    data["isWellFormed"] = this.isWellFormed;
    data["entityType"] = this.entityType;
    data["isAny"] = this.isAny;
    data["isIfNoneMatch"] = this.isIfNoneMatch;
    if (this.concurrencyProperties) {
      data["concurrencyProperties"] = {};
      for (let key in this.concurrencyProperties) {
        if (this.concurrencyProperties.hasOwnProperty(key))
          data["concurrencyProperties"][key] = this.concurrencyProperties[key];
      }
    }
    super.toJSON(data);
    return data;
  }
}

/** The ETag parsed from request. */
export interface IETag extends IDynamicObject {
  item?: any | undefined;
  /** Gets or sets whether the ETag is well-formed. */
  isWellFormed: boolean;
  /** Gets or sets an entity type of the ETag. */
  entityType?: string | undefined;
  /** Gets or sets whether the ETag is corresponding to "*". */
  isAny: boolean;
  isIfNoneMatch: boolean;
  concurrencyProperties?: { [key: string]: any } | undefined;
}

export class ETagOfEstimate extends ETag implements IETagOfEstimate {
  constructor(data?: IETagOfEstimate) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): ETagOfEstimate {
    data = typeof data === "object" ? data : {};
    let result = new ETagOfEstimate();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IETagOfEstimate extends IETag {}

/** This defines some context information used to perform query composition. */
export class ODataQueryContext implements IODataQueryContext {
  defaultQuerySettings?: DefaultQuerySettings | undefined;
  /** Gets the given IEdmModel that contains the EntitySet. */
  model?: IEdmModel | undefined;
  /** Gets the IEdmType of the element. */
  elementType?: IEdmType | undefined;
  /** Gets the IEdmNavigationSource that contains the element. */
  navigationSource?: IEdmNavigationSource | undefined;
  /** Gets the CLR type of the element. */
  elementClrType?: string | undefined;
  /** Gets the ODataPath. */
  path?: ODataPath | undefined;
  requestContainer?: IServiceProvider | undefined;

  constructor(data?: IODataQueryContext) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.defaultQuerySettings = _data["defaultQuerySettings"]
        ? DefaultQuerySettings.fromJS(_data["defaultQuerySettings"])
        : <any>undefined;
      this.model = _data["model"]
        ? IEdmModel.fromJS(_data["model"])
        : <any>undefined;
      this.elementType = _data["elementType"]
        ? IEdmType.fromJS(_data["elementType"])
        : <any>undefined;
      this.navigationSource = _data["navigationSource"]
        ? IEdmNavigationSource.fromJS(_data["navigationSource"])
        : <any>undefined;
      this.elementClrType = _data["elementClrType"];
      this.path = _data["path"]
        ? ODataPath.fromJS(_data["path"])
        : <any>undefined;
      this.requestContainer = _data["requestContainer"]
        ? IServiceProvider.fromJS(_data["requestContainer"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ODataQueryContext {
    data = typeof data === "object" ? data : {};
    let result = new ODataQueryContext();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["defaultQuerySettings"] = this.defaultQuerySettings
      ? this.defaultQuerySettings.toJSON()
      : <any>undefined;
    data["model"] = this.model ? this.model.toJSON() : <any>undefined;
    data["elementType"] = this.elementType
      ? this.elementType.toJSON()
      : <any>undefined;
    data["navigationSource"] = this.navigationSource
      ? this.navigationSource.toJSON()
      : <any>undefined;
    data["elementClrType"] = this.elementClrType;
    data["path"] = this.path ? this.path.toJSON() : <any>undefined;
    data["requestContainer"] = this.requestContainer
      ? this.requestContainer.toJSON()
      : <any>undefined;
    return data;
  }
}

/** This defines some context information used to perform query composition. */
export interface IODataQueryContext {
  defaultQuerySettings?: DefaultQuerySettings | undefined;
  /** Gets the given IEdmModel that contains the EntitySet. */
  model?: IEdmModel | undefined;
  /** Gets the IEdmType of the element. */
  elementType?: IEdmType | undefined;
  /** Gets the IEdmNavigationSource that contains the element. */
  navigationSource?: IEdmNavigationSource | undefined;
  /** Gets the CLR type of the element. */
  elementClrType?: string | undefined;
  /** Gets the ODataPath. */
  path?: ODataPath | undefined;
  requestContainer?: IServiceProvider | undefined;
}

export class DefaultQuerySettings implements IDefaultQuerySettings {
  enableExpand!: boolean;
  enableSelect!: boolean;
  enableCount!: boolean;
  enableOrderBy!: boolean;
  enableFilter!: boolean;
  maxTop?: number | undefined;

  constructor(data?: IDefaultQuerySettings) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.enableExpand = _data["enableExpand"];
      this.enableSelect = _data["enableSelect"];
      this.enableCount = _data["enableCount"];
      this.enableOrderBy = _data["enableOrderBy"];
      this.enableFilter = _data["enableFilter"];
      this.maxTop = _data["maxTop"];
    }
  }

  static fromJS(data: any): DefaultQuerySettings {
    data = typeof data === "object" ? data : {};
    let result = new DefaultQuerySettings();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["enableExpand"] = this.enableExpand;
    data["enableSelect"] = this.enableSelect;
    data["enableCount"] = this.enableCount;
    data["enableOrderBy"] = this.enableOrderBy;
    data["enableFilter"] = this.enableFilter;
    data["maxTop"] = this.maxTop;
    return data;
  }
}

export interface IDefaultQuerySettings {
  enableExpand: boolean;
  enableSelect: boolean;
  enableCount: boolean;
  enableOrderBy: boolean;
  enableFilter: boolean;
  maxTop?: number | undefined;
}

/** Semantic representation of an EDM model. */
export abstract class IEdmModel implements IIEdmModel {
  /** Gets the collection of schema elements that are contained in this model. */
  schemaElements?: IEdmSchemaElement[] | undefined;
  /** Gets the collection of vocabulary annotations that are contained in this model. */
  vocabularyAnnotations?: IEdmVocabularyAnnotation[] | undefined;
  /** Gets the collection of models referred to by this model (mainly by the this.References). */
  referencedModels?: IEdmModel[] | undefined;
  /** Gets the collection of namespaces that schema elements use contained in this model. */
  declaredNamespaces?: string[] | undefined;
  /** Gets the model's annotations manager. */
  directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager | undefined;
  /** Gets the only one entity container of the model. */
  entityContainer?: IEdmEntityContainer | undefined;

  constructor(data?: IIEdmModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["schemaElements"])) {
        this.schemaElements = [] as any;
        for (let item of _data["schemaElements"])
          this.schemaElements!.push(IEdmSchemaElement.fromJS(item));
      }
      if (Array.isArray(_data["vocabularyAnnotations"])) {
        this.vocabularyAnnotations = [] as any;
        for (let item of _data["vocabularyAnnotations"])
          this.vocabularyAnnotations!.push(
            IEdmVocabularyAnnotation.fromJS(item)
          );
      }
      if (Array.isArray(_data["referencedModels"])) {
        this.referencedModels = [] as any;
        for (let item of _data["referencedModels"])
          this.referencedModels!.push(IEdmModel.fromJS(item));
      }
      if (Array.isArray(_data["declaredNamespaces"])) {
        this.declaredNamespaces = [] as any;
        for (let item of _data["declaredNamespaces"])
          this.declaredNamespaces!.push(item);
      }
      this.directValueAnnotationsManager = _data[
        "directValueAnnotationsManager"
      ]
        ? IEdmDirectValueAnnotationsManager.fromJS(
            _data["directValueAnnotationsManager"]
          )
        : <any>undefined;
      this.entityContainer = _data["entityContainer"]
        ? IEdmEntityContainer.fromJS(_data["entityContainer"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): IEdmModel {
    data = typeof data === "object" ? data : {};
    throw new Error("The abstract class 'IEdmModel' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.schemaElements)) {
      data["schemaElements"] = [];
      for (let item of this.schemaElements)
        data["schemaElements"].push(item.toJSON());
    }
    if (Array.isArray(this.vocabularyAnnotations)) {
      data["vocabularyAnnotations"] = [];
      for (let item of this.vocabularyAnnotations)
        data["vocabularyAnnotations"].push(item.toJSON());
    }
    if (Array.isArray(this.referencedModels)) {
      data["referencedModels"] = [];
      for (let item of this.referencedModels)
        data["referencedModels"].push(item.toJSON());
    }
    if (Array.isArray(this.declaredNamespaces)) {
      data["declaredNamespaces"] = [];
      for (let item of this.declaredNamespaces)
        data["declaredNamespaces"].push(item);
    }
    data["directValueAnnotationsManager"] = this.directValueAnnotationsManager
      ? this.directValueAnnotationsManager.toJSON()
      : <any>undefined;
    data["entityContainer"] = this.entityContainer
      ? this.entityContainer.toJSON()
      : <any>undefined;
    return data;
  }
}

/** Semantic representation of an EDM model. */
export interface IIEdmModel {
  /** Gets the collection of schema elements that are contained in this model. */
  schemaElements?: IEdmSchemaElement[] | undefined;
  /** Gets the collection of vocabulary annotations that are contained in this model. */
  vocabularyAnnotations?: IEdmVocabularyAnnotation[] | undefined;
  /** Gets the collection of models referred to by this model (mainly by the this.References). */
  referencedModels?: IEdmModel[] | undefined;
  /** Gets the collection of namespaces that schema elements use contained in this model. */
  declaredNamespaces?: string[] | undefined;
  /** Gets the model's annotations manager. */
  directValueAnnotationsManager?: IEdmDirectValueAnnotationsManager | undefined;
  /** Gets the only one entity container of the model. */
  entityContainer?: IEdmEntityContainer | undefined;
}

/** Common base interface for all named children of EDM schema. */
export abstract class IEdmSchemaElement implements IIEdmSchemaElement {
  /** Gets the kind of this schema element. */
  schemaElementKind!: EdmSchemaElementKind;
  /** Gets the namespace this schema element belongs to. */
  namespace?: string | undefined;

  constructor(data?: IIEdmSchemaElement) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.schemaElementKind = _data["schemaElementKind"];
      this.namespace = _data["namespace"];
    }
  }

  static fromJS(data: any): IEdmSchemaElement {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmSchemaElement' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["schemaElementKind"] = this.schemaElementKind;
    data["namespace"] = this.namespace;
    return data;
  }
}

/** Common base interface for all named children of EDM schema. */
export interface IIEdmSchemaElement {
  /** Gets the kind of this schema element. */
  schemaElementKind: EdmSchemaElementKind;
  /** Gets the namespace this schema element belongs to. */
  namespace?: string | undefined;
}

/** Defines EDM schema element types. */
export enum EdmSchemaElementKind {
  None = 0,
  TypeDefinition = 1,
  Term = 2,
  Action = 3,
  EntityContainer = 4,
  Function = 5
}

/** Represents an EDM vocabulary annotation. */
export abstract class IEdmVocabularyAnnotation
  implements IIEdmVocabularyAnnotation {
  /** Gets the qualifier used to discriminate between multiple bindings of the same property or type. */
  qualifier?: string | undefined;
  /** Gets the term bound by the annotation. */
  term?: IEdmTerm | undefined;
  /** Gets the element the annotation applies to. */
  target?: IEdmVocabularyAnnotatable | undefined;
  /** Gets the expression producing the value of the annotation. */
  value?: IEdmExpression | undefined;

  constructor(data?: IIEdmVocabularyAnnotation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.qualifier = _data["qualifier"];
      this.term = _data["term"]
        ? IEdmTerm.fromJS(_data["term"])
        : <any>undefined;
      this.target = _data["target"]
        ? IEdmVocabularyAnnotatable.fromJS(_data["target"])
        : <any>undefined;
      this.value = _data["value"]
        ? IEdmExpression.fromJS(_data["value"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): IEdmVocabularyAnnotation {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmVocabularyAnnotation' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["qualifier"] = this.qualifier;
    data["term"] = this.term ? this.term.toJSON() : <any>undefined;
    data["target"] = this.target ? this.target.toJSON() : <any>undefined;
    data["value"] = this.value ? this.value.toJSON() : <any>undefined;
    return data;
  }
}

/** Represents an EDM vocabulary annotation. */
export interface IIEdmVocabularyAnnotation {
  /** Gets the qualifier used to discriminate between multiple bindings of the same property or type. */
  qualifier?: string | undefined;
  /** Gets the term bound by the annotation. */
  term?: IEdmTerm | undefined;
  /** Gets the element the annotation applies to. */
  target?: IEdmVocabularyAnnotatable | undefined;
  /** Gets the expression producing the value of the annotation. */
  value?: IEdmExpression | undefined;
}

/** Represents an EDM term. */
export abstract class IEdmTerm implements IIEdmTerm {
  /** Gets the type of this term. */
  type?: IEdmTypeReference | undefined;
  /** Gets the AppliesTo of this term. */
  appliesTo?: string | undefined;
  /** Gets the DefaultValue of this term. */
  defaultValue?: string | undefined;

  constructor(data?: IIEdmTerm) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data["type"]
        ? IEdmTypeReference.fromJS(_data["type"])
        : <any>undefined;
      this.appliesTo = _data["appliesTo"];
      this.defaultValue = _data["defaultValue"];
    }
  }

  static fromJS(data: any): IEdmTerm {
    data = typeof data === "object" ? data : {};
    throw new Error("The abstract class 'IEdmTerm' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["type"] = this.type ? this.type.toJSON() : <any>undefined;
    data["appliesTo"] = this.appliesTo;
    data["defaultValue"] = this.defaultValue;
    return data;
  }
}

/** Represents an EDM term. */
export interface IIEdmTerm {
  /** Gets the type of this term. */
  type?: IEdmTypeReference | undefined;
  /** Gets the AppliesTo of this term. */
  appliesTo?: string | undefined;
  /** Gets the DefaultValue of this term. */
  defaultValue?: string | undefined;
}

/** Represents a references to a type. */
export abstract class IEdmTypeReference implements IIEdmTypeReference {
  /** Gets a value indicating whether this type is nullable. */
  isNullable!: boolean;
  /** Gets the definition to which this type refers. */
  definition?: IEdmType | undefined;

  constructor(data?: IIEdmTypeReference) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isNullable = _data["isNullable"];
      this.definition = _data["definition"]
        ? IEdmType.fromJS(_data["definition"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): IEdmTypeReference {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmTypeReference' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["isNullable"] = this.isNullable;
    data["definition"] = this.definition
      ? this.definition.toJSON()
      : <any>undefined;
    return data;
  }
}

/** Represents a references to a type. */
export interface IIEdmTypeReference {
  /** Gets a value indicating whether this type is nullable. */
  isNullable: boolean;
  /** Gets the definition to which this type refers. */
  definition?: IEdmType | undefined;
}

/** Represents the definition of an EDM type. */
export abstract class IEdmType implements IIEdmType {
  /** Gets the kind of this type. */
  typeKind!: EdmTypeKind;

  constructor(data?: IIEdmType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.typeKind = _data["typeKind"];
    }
  }

  static fromJS(data: any): IEdmType {
    data = typeof data === "object" ? data : {};
    throw new Error("The abstract class 'IEdmType' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["typeKind"] = this.typeKind;
    return data;
  }
}

/** Represents the definition of an EDM type. */
export interface IIEdmType {
  /** Gets the kind of this type. */
  typeKind: EdmTypeKind;
}

/** Defines EDM metatypes. */
export enum EdmTypeKind {
  None = 0,
  Primitive = 1,
  Entity = 2,
  Complex = 3,
  Collection = 4,
  EntityReference = 5,
  Enum = 6,
  TypeDefinition = 7,
  Untyped = 8
}

/** Represents an element that can be targeted by Vocabulary Annotations */
export abstract class IEdmVocabularyAnnotatable
  implements IIEdmVocabularyAnnotatable {
  constructor(data?: IIEdmVocabularyAnnotatable) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): IEdmVocabularyAnnotatable {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmVocabularyAnnotatable' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Represents an element that can be targeted by Vocabulary Annotations */
export interface IIEdmVocabularyAnnotatable {}

/** Represents an EDM expression. */
export abstract class IEdmExpression implements IIEdmExpression {
  /** Gets the kind of this expression. */
  expressionKind!: EdmExpressionKind;

  constructor(data?: IIEdmExpression) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.expressionKind = _data["expressionKind"];
    }
  }

  static fromJS(data: any): IEdmExpression {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmExpression' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["expressionKind"] = this.expressionKind;
    return data;
  }
}

/** Represents an EDM expression. */
export interface IIEdmExpression {
  /** Gets the kind of this expression. */
  expressionKind: EdmExpressionKind;
}

/** Defines EDM expression kinds. */
export enum EdmExpressionKind {
  None = 0,
  BinaryConstant = 1,
  BooleanConstant = 2,
  DateTimeOffsetConstant = 3,
  DecimalConstant = 4,
  FloatingConstant = 5,
  GuidConstant = 6,
  IntegerConstant = 7,
  StringConstant = 8,
  DurationConstant = 9,
  Null = 10,
  Record = 11,
  Collection = 12,
  Path = 13,
  If = 14,
  Cast = 15,
  IsType = 16,
  FunctionApplication = 17,
  LabeledExpressionReference = 18,
  Labeled = 19,
  PropertyPath = 20,
  NavigationPropertyPath = 21,
  DateConstant = 22,
  TimeOfDayConstant = 23,
  EnumMember = 24
}

/** Manages getting and setting direct annotations on EDM elements. */
export abstract class IEdmDirectValueAnnotationsManager
  implements IIEdmDirectValueAnnotationsManager {
  constructor(data?: IIEdmDirectValueAnnotationsManager) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): IEdmDirectValueAnnotationsManager {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmDirectValueAnnotationsManager' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Manages getting and setting direct annotations on EDM elements. */
export interface IIEdmDirectValueAnnotationsManager {}

/** Represents an EDM entity container. */
export abstract class IEdmEntityContainer implements IIEdmEntityContainer {
  /** Gets a collection of the elements of this entity container. */
  elements?: IEdmEntityContainerElement[] | undefined;

  constructor(data?: IIEdmEntityContainer) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["elements"])) {
        this.elements = [] as any;
        for (let item of _data["elements"])
          this.elements!.push(IEdmEntityContainerElement.fromJS(item));
      }
    }
  }

  static fromJS(data: any): IEdmEntityContainer {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmEntityContainer' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.elements)) {
      data["elements"] = [];
      for (let item of this.elements) data["elements"].push(item.toJSON());
    }
    return data;
  }
}

/** Represents an EDM entity container. */
export interface IIEdmEntityContainer {
  /** Gets a collection of the elements of this entity container. */
  elements?: IEdmEntityContainerElement[] | undefined;
}

/** Represents the common elements of all EDM entity container elements. */
export abstract class IEdmEntityContainerElement
  implements IIEdmEntityContainerElement {
  /** Gets the kind of element of this container element. */
  containerElementKind!: EdmContainerElementKind;
  /** Gets the container that contains this element. */
  container?: IEdmEntityContainer | undefined;

  constructor(data?: IIEdmEntityContainerElement) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.containerElementKind = _data["containerElementKind"];
      this.container = _data["container"]
        ? IEdmEntityContainer.fromJS(_data["container"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): IEdmEntityContainerElement {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmEntityContainerElement' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["containerElementKind"] = this.containerElementKind;
    data["container"] = this.container
      ? this.container.toJSON()
      : <any>undefined;
    return data;
  }
}

/** Represents the common elements of all EDM entity container elements. */
export interface IIEdmEntityContainerElement {
  /** Gets the kind of element of this container element. */
  containerElementKind: EdmContainerElementKind;
  /** Gets the container that contains this element. */
  container?: IEdmEntityContainer | undefined;
}

/** Defines EDM container element types. */
export enum EdmContainerElementKind {
  None = 0,
  EntitySet = 1,
  ActionImport = 2,
  FunctionImport = 3,
  Singleton = 4
}

/** Represents an EDM navigation source. */
export abstract class IEdmNavigationSource implements IIEdmNavigationSource {
  /** Gets the navigation property bindings of this navigation source. */
  navigationPropertyBindings?: IEdmNavigationPropertyBinding[] | undefined;
  /** Gets the path of this navigation source. */
  path?: IEdmPathExpression | undefined;
  /** Gets the type of this navigation source. */
  type?: IEdmType | undefined;

  constructor(data?: IIEdmNavigationSource) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["navigationPropertyBindings"])) {
        this.navigationPropertyBindings = [] as any;
        for (let item of _data["navigationPropertyBindings"])
          this.navigationPropertyBindings!.push(
            IEdmNavigationPropertyBinding.fromJS(item)
          );
      }
      this.path = _data["path"]
        ? IEdmPathExpression.fromJS(_data["path"])
        : <any>undefined;
      this.type = _data["type"]
        ? IEdmType.fromJS(_data["type"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): IEdmNavigationSource {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmNavigationSource' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.navigationPropertyBindings)) {
      data["navigationPropertyBindings"] = [];
      for (let item of this.navigationPropertyBindings)
        data["navigationPropertyBindings"].push(item.toJSON());
    }
    data["path"] = this.path ? this.path.toJSON() : <any>undefined;
    data["type"] = this.type ? this.type.toJSON() : <any>undefined;
    return data;
  }
}

/** Represents an EDM navigation source. */
export interface IIEdmNavigationSource {
  /** Gets the navigation property bindings of this navigation source. */
  navigationPropertyBindings?: IEdmNavigationPropertyBinding[] | undefined;
  /** Gets the path of this navigation source. */
  path?: IEdmPathExpression | undefined;
  /** Gets the type of this navigation source. */
  type?: IEdmType | undefined;
}

/** Represents a binding from an EDM navigation property to a navigation source. */
export abstract class IEdmNavigationPropertyBinding
  implements IIEdmNavigationPropertyBinding {
  /** Gets the navigation property. */
  navigationProperty?: IEdmNavigationProperty | undefined;
  /** Gets the target navigation source. */
  target?: IEdmNavigationSource | undefined;
  /** Get the path that a navigation property targets. */
  path?: IEdmPathExpression | undefined;

  constructor(data?: IIEdmNavigationPropertyBinding) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.navigationProperty = _data["navigationProperty"]
        ? IEdmNavigationProperty.fromJS(_data["navigationProperty"])
        : <any>undefined;
      this.target = _data["target"]
        ? IEdmNavigationSource.fromJS(_data["target"])
        : <any>undefined;
      this.path = _data["path"]
        ? IEdmPathExpression.fromJS(_data["path"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): IEdmNavigationPropertyBinding {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmNavigationPropertyBinding' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["navigationProperty"] = this.navigationProperty
      ? this.navigationProperty.toJSON()
      : <any>undefined;
    data["target"] = this.target ? this.target.toJSON() : <any>undefined;
    data["path"] = this.path ? this.path.toJSON() : <any>undefined;
    return data;
  }
}

/** Represents a binding from an EDM navigation property to a navigation source. */
export interface IIEdmNavigationPropertyBinding {
  /** Gets the navigation property. */
  navigationProperty?: IEdmNavigationProperty | undefined;
  /** Gets the target navigation source. */
  target?: IEdmNavigationSource | undefined;
  /** Get the path that a navigation property targets. */
  path?: IEdmPathExpression | undefined;
}

/** Represents an EDM navigation property. */
export abstract class IEdmNavigationProperty
  implements IIEdmNavigationProperty {
  /** Gets the partner of this navigation property. */
  partner?: IEdmNavigationProperty | undefined;
  /** Gets the action to execute on the deletion of this end of a bidirectional association. */
  onDelete!: EdmOnDeleteAction;
  /** Gets a value indicating whether the navigation target is contained inside the navigation source. */
  containsTarget!: boolean;
  /** Gets the referential constraint for this navigation, returning null if this is the principal end or if there is no referential constraint. */
  referentialConstraint?: IEdmReferentialConstraint | undefined;

  constructor(data?: IIEdmNavigationProperty) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.partner = _data["partner"]
        ? IEdmNavigationProperty.fromJS(_data["partner"])
        : <any>undefined;
      this.onDelete = _data["onDelete"];
      this.containsTarget = _data["containsTarget"];
      this.referentialConstraint = _data["referentialConstraint"]
        ? IEdmReferentialConstraint.fromJS(_data["referentialConstraint"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): IEdmNavigationProperty {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmNavigationProperty' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["partner"] = this.partner ? this.partner.toJSON() : <any>undefined;
    data["onDelete"] = this.onDelete;
    data["containsTarget"] = this.containsTarget;
    data["referentialConstraint"] = this.referentialConstraint
      ? this.referentialConstraint.toJSON()
      : <any>undefined;
    return data;
  }
}

/** Represents an EDM navigation property. */
export interface IIEdmNavigationProperty {
  /** Gets the partner of this navigation property. */
  partner?: IEdmNavigationProperty | undefined;
  /** Gets the action to execute on the deletion of this end of a bidirectional association. */
  onDelete: EdmOnDeleteAction;
  /** Gets a value indicating whether the navigation target is contained inside the navigation source. */
  containsTarget: boolean;
  /** Gets the referential constraint for this navigation, returning null if this is the principal end or if there is no referential constraint. */
  referentialConstraint?: IEdmReferentialConstraint | undefined;
}

/** Enumerates the actions EDM can apply on deletes. */
export enum EdmOnDeleteAction {
  None = 0,
  Cascade = 1
}

/** Represents an EDM referential constraint on a navigation property. */
export abstract class IEdmReferentialConstraint
  implements IIEdmReferentialConstraint {
  /** Gets the set of property pairs from the referential constraint. No particular ordering should be assumed. */
  propertyPairs?: EdmReferentialConstraintPropertyPair[] | undefined;

  constructor(data?: IIEdmReferentialConstraint) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["propertyPairs"])) {
        this.propertyPairs = [] as any;
        for (let item of _data["propertyPairs"])
          this.propertyPairs!.push(
            EdmReferentialConstraintPropertyPair.fromJS(item)
          );
      }
    }
  }

  static fromJS(data: any): IEdmReferentialConstraint {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmReferentialConstraint' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.propertyPairs)) {
      data["propertyPairs"] = [];
      for (let item of this.propertyPairs)
        data["propertyPairs"].push(item.toJSON());
    }
    return data;
  }
}

/** Represents an EDM referential constraint on a navigation property. */
export interface IIEdmReferentialConstraint {
  /** Gets the set of property pairs from the referential constraint. No particular ordering should be assumed. */
  propertyPairs?: EdmReferentialConstraintPropertyPair[] | undefined;
}

/** Represents a pair of properties as part of a referential constraint. */
export class EdmReferentialConstraintPropertyPair
  implements IEdmReferentialConstraintPropertyPair {
  /** The local or dependent property in the referential constraint property pair. Will never be null. */
  dependentProperty?: IEdmStructuralProperty | undefined;
  /** The foreign or principal property in the referential constraint property pair. Will never be null. */
  principalProperty?: IEdmStructuralProperty | undefined;

  constructor(data?: IEdmReferentialConstraintPropertyPair) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dependentProperty = _data["dependentProperty"]
        ? IEdmStructuralProperty.fromJS(_data["dependentProperty"])
        : <any>undefined;
      this.principalProperty = _data["principalProperty"]
        ? IEdmStructuralProperty.fromJS(_data["principalProperty"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): EdmReferentialConstraintPropertyPair {
    data = typeof data === "object" ? data : {};
    let result = new EdmReferentialConstraintPropertyPair();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dependentProperty"] = this.dependentProperty
      ? this.dependentProperty.toJSON()
      : <any>undefined;
    data["principalProperty"] = this.principalProperty
      ? this.principalProperty.toJSON()
      : <any>undefined;
    return data;
  }
}

/** Represents a pair of properties as part of a referential constraint. */
export interface IEdmReferentialConstraintPropertyPair {
  /** The local or dependent property in the referential constraint property pair. Will never be null. */
  dependentProperty?: IEdmStructuralProperty | undefined;
  /** The foreign or principal property in the referential constraint property pair. Will never be null. */
  principalProperty?: IEdmStructuralProperty | undefined;
}

/** Represents an EDM structural (i.e. non-navigation) property. */
export abstract class IEdmStructuralProperty
  implements IIEdmStructuralProperty {
  /** Gets the default value of this property. */
  defaultValueString?: string | undefined;

  constructor(data?: IIEdmStructuralProperty) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.defaultValueString = _data["defaultValueString"];
    }
  }

  static fromJS(data: any): IEdmStructuralProperty {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmStructuralProperty' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["defaultValueString"] = this.defaultValueString;
    return data;
  }
}

/** Represents an EDM structural (i.e. non-navigation) property. */
export interface IIEdmStructuralProperty {
  /** Gets the default value of this property. */
  defaultValueString?: string | undefined;
}

/** Represents an EDM path expression. */
export abstract class IEdmPathExpression implements IIEdmPathExpression {
  /** Gets the path segments as a decomposed qualified name. "A.B/C/D.E" is { "A.B", "C", "D.E" }. */
  pathSegments?: string[] | undefined;
  /** Gets the path string, like "A.B/C/D.E". */
  path?: string | undefined;

  constructor(data?: IIEdmPathExpression) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["pathSegments"])) {
        this.pathSegments = [] as any;
        for (let item of _data["pathSegments"]) this.pathSegments!.push(item);
      }
      this.path = _data["path"];
    }
  }

  static fromJS(data: any): IEdmPathExpression {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IEdmPathExpression' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.pathSegments)) {
      data["pathSegments"] = [];
      for (let item of this.pathSegments) data["pathSegments"].push(item);
    }
    data["path"] = this.path;
    return data;
  }
}

/** Represents an EDM path expression. */
export interface IIEdmPathExpression {
  /** Gets the path segments as a decomposed qualified name. "A.B/C/D.E" is { "A.B", "C", "D.E" }. */
  pathSegments?: string[] | undefined;
  /** Gets the path string, like "A.B/C/D.E". */
  path?: string | undefined;
}

/** Provides an object representation for an OData path with additional information about the EDM type and entity set for the path. */
export class ODataPath implements IODataPath {
  /** Gets or sets the EDM type of the path. */
  edmType?: IEdmType | undefined;
  /** Gets or sets the navigation source of the path. */
  navigationSource?: IEdmNavigationSource | undefined;
  /** Gets the path segments for the OData path. */
  segments?: ODataPathSegment[] | undefined;
  /** Gets the path template describing the types of segments in the path. */
  pathTemplate?: string | undefined;

  constructor(data?: IODataPath) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.edmType = _data["edmType"]
        ? IEdmType.fromJS(_data["edmType"])
        : <any>undefined;
      this.navigationSource = _data["navigationSource"]
        ? IEdmNavigationSource.fromJS(_data["navigationSource"])
        : <any>undefined;
      if (Array.isArray(_data["segments"])) {
        this.segments = [] as any;
        for (let item of _data["segments"])
          this.segments!.push(ODataPathSegment.fromJS(item));
      }
      this.pathTemplate = _data["pathTemplate"];
    }
  }

  static fromJS(data: any): ODataPath {
    data = typeof data === "object" ? data : {};
    let result = new ODataPath();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["edmType"] = this.edmType ? this.edmType.toJSON() : <any>undefined;
    data["navigationSource"] = this.navigationSource
      ? this.navigationSource.toJSON()
      : <any>undefined;
    if (Array.isArray(this.segments)) {
      data["segments"] = [];
      for (let item of this.segments) data["segments"].push(item.toJSON());
    }
    data["pathTemplate"] = this.pathTemplate;
    return data;
  }
}

/** Provides an object representation for an OData path with additional information about the EDM type and entity set for the path. */
export interface IODataPath {
  /** Gets or sets the EDM type of the path. */
  edmType?: IEdmType | undefined;
  /** Gets or sets the navigation source of the path. */
  navigationSource?: IEdmNavigationSource | undefined;
  /** Gets the path segments for the OData path. */
  segments?: ODataPathSegment[] | undefined;
  /** Gets the path template describing the types of segments in the path. */
  pathTemplate?: string | undefined;
}

/** The semantic representation of a segment in a path. */
export abstract class ODataPathSegment implements IODataPathSegment {
  /** Returns the identifier for this segment i.e. string part without the keys. */
  identifier?: string | undefined;

  constructor(data?: IODataPathSegment) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.identifier = _data["identifier"];
    }
  }

  static fromJS(data: any): ODataPathSegment {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'ODataPathSegment' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["identifier"] = this.identifier;
    return data;
  }
}

/** The semantic representation of a segment in a path. */
export interface IODataPathSegment {
  /** Returns the identifier for this segment i.e. string part without the keys. */
  identifier?: string | undefined;
}

export abstract class IServiceProvider implements IIServiceProvider {
  constructor(data?: IIServiceProvider) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): IServiceProvider {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'IServiceProvider' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

export interface IIServiceProvider {}

export class HttpRequestMessage implements IHttpRequestMessage {
  version?: Version | undefined;
  content?: HttpContent | undefined;
  method?: HttpMethod | undefined;
  requestUri?: string | undefined;
  headers?: HttpRequestHeaders | undefined;
  properties?: { [key: string]: any } | undefined;

  constructor(data?: IHttpRequestMessage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.version = _data["version"]
        ? Version.fromJS(_data["version"])
        : <any>undefined;
      this.content = _data["content"]
        ? HttpContent.fromJS(_data["content"])
        : <any>undefined;
      this.method = _data["method"]
        ? HttpMethod.fromJS(_data["method"])
        : <any>undefined;
      this.requestUri = _data["requestUri"];
      this.headers = _data["headers"]
        ? HttpRequestHeaders.fromJS(_data["headers"])
        : <any>undefined;
      if (_data["properties"]) {
        this.properties = {} as any;
        for (let key in _data["properties"]) {
          if (_data["properties"].hasOwnProperty(key))
            this.properties![key] = _data["properties"][key];
        }
      }
    }
  }

  static fromJS(data: any): HttpRequestMessage {
    data = typeof data === "object" ? data : {};
    let result = new HttpRequestMessage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["version"] = this.version ? this.version.toJSON() : <any>undefined;
    data["content"] = this.content ? this.content.toJSON() : <any>undefined;
    data["method"] = this.method ? this.method.toJSON() : <any>undefined;
    data["requestUri"] = this.requestUri;
    data["headers"] = this.headers ? this.headers.toJSON() : <any>undefined;
    if (this.properties) {
      data["properties"] = {};
      for (let key in this.properties) {
        if (this.properties.hasOwnProperty(key))
          data["properties"][key] = this.properties[key];
      }
    }
    return data;
  }
}

export interface IHttpRequestMessage {
  version?: Version | undefined;
  content?: HttpContent | undefined;
  method?: HttpMethod | undefined;
  requestUri?: string | undefined;
  headers?: HttpRequestHeaders | undefined;
  properties?: { [key: string]: any } | undefined;
}

export class Version implements IVersion {
  major!: number;
  minor!: number;
  build!: number;
  revision!: number;
  majorRevision!: number;
  minorRevision!: number;

  constructor(data?: IVersion) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.major = _data["major"];
      this.minor = _data["minor"];
      this.build = _data["build"];
      this.revision = _data["revision"];
      this.majorRevision = _data["majorRevision"];
      this.minorRevision = _data["minorRevision"];
    }
  }

  static fromJS(data: any): Version {
    data = typeof data === "object" ? data : {};
    let result = new Version();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["major"] = this.major;
    data["minor"] = this.minor;
    data["build"] = this.build;
    data["revision"] = this.revision;
    data["majorRevision"] = this.majorRevision;
    data["minorRevision"] = this.minorRevision;
    return data;
  }
}

export interface IVersion {
  major: number;
  minor: number;
  build: number;
  revision: number;
  majorRevision: number;
  minorRevision: number;
}

export abstract class HttpContent implements IHttpContent {
  headers?: HttpContentHeaders | undefined;

  constructor(data?: IHttpContent) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.headers = _data["headers"]
        ? HttpContentHeaders.fromJS(_data["headers"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): HttpContent {
    data = typeof data === "object" ? data : {};
    throw new Error("The abstract class 'HttpContent' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["headers"] = this.headers ? this.headers.toJSON() : <any>undefined;
    return data;
  }
}

export interface IHttpContent {
  headers?: HttpContentHeaders | undefined;
}

export class Anonymous implements IAnonymous {
  allow?: string[] | undefined;
  contentDisposition?: ContentDispositionHeaderValue | undefined;
  contentEncoding?: string[] | undefined;
  contentLanguage?: string[] | undefined;
  contentLength?: number | undefined;
  contentLocation?: string | undefined;
  contentMD5?: string | undefined;
  contentRange?: ContentRangeHeaderValue | undefined;
  contentType?: MediaTypeHeaderValue | undefined;
  expires?: Date | undefined;
  lastModified?: Date | undefined;

  constructor(data?: IAnonymous) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["allow"])) {
        this.allow = [] as any;
        for (let item of _data["allow"]) this.allow!.push(item);
      }
      this.contentDisposition = _data["contentDisposition"]
        ? ContentDispositionHeaderValue.fromJS(_data["contentDisposition"])
        : <any>undefined;
      if (Array.isArray(_data["contentEncoding"])) {
        this.contentEncoding = [] as any;
        for (let item of _data["contentEncoding"])
          this.contentEncoding!.push(item);
      }
      if (Array.isArray(_data["contentLanguage"])) {
        this.contentLanguage = [] as any;
        for (let item of _data["contentLanguage"])
          this.contentLanguage!.push(item);
      }
      this.contentLength = _data["contentLength"];
      this.contentLocation = _data["contentLocation"];
      this.contentMD5 = _data["contentMD5"];
      this.contentRange = _data["contentRange"]
        ? ContentRangeHeaderValue.fromJS(_data["contentRange"])
        : <any>undefined;
      this.contentType = _data["contentType"]
        ? MediaTypeHeaderValue.fromJS(_data["contentType"])
        : <any>undefined;
      this.expires = _data["expires"]
        ? new Date(_data["expires"].toString())
        : <any>undefined;
      this.lastModified = _data["lastModified"]
        ? new Date(_data["lastModified"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): Anonymous {
    data = typeof data === "object" ? data : {};
    let result = new Anonymous();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.allow)) {
      data["allow"] = [];
      for (let item of this.allow) data["allow"].push(item);
    }
    data["contentDisposition"] = this.contentDisposition
      ? this.contentDisposition.toJSON()
      : <any>undefined;
    if (Array.isArray(this.contentEncoding)) {
      data["contentEncoding"] = [];
      for (let item of this.contentEncoding) data["contentEncoding"].push(item);
    }
    if (Array.isArray(this.contentLanguage)) {
      data["contentLanguage"] = [];
      for (let item of this.contentLanguage) data["contentLanguage"].push(item);
    }
    data["contentLength"] = this.contentLength;
    data["contentLocation"] = this.contentLocation;
    data["contentMD5"] = this.contentMD5;
    data["contentRange"] = this.contentRange
      ? this.contentRange.toJSON()
      : <any>undefined;
    data["contentType"] = this.contentType
      ? this.contentType.toJSON()
      : <any>undefined;
    data["expires"] = this.expires
      ? this.expires.toISOString()
      : <any>undefined;
    data["lastModified"] = this.lastModified
      ? this.lastModified.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IAnonymous {
  allow?: string[] | undefined;
  contentDisposition?: ContentDispositionHeaderValue | undefined;
  contentEncoding?: string[] | undefined;
  contentLanguage?: string[] | undefined;
  contentLength?: number | undefined;
  contentLocation?: string | undefined;
  contentMD5?: string | undefined;
  contentRange?: ContentRangeHeaderValue | undefined;
  contentType?: MediaTypeHeaderValue | undefined;
  expires?: Date | undefined;
  lastModified?: Date | undefined;
}

export class HttpContentHeaders extends Anonymous
  implements IHttpContentHeaders {
  constructor(data?: IHttpContentHeaders) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): HttpContentHeaders {
    data = typeof data === "object" ? data : {};
    let result = new HttpContentHeaders();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IHttpContentHeaders extends IAnonymous {}

export class ContentDispositionHeaderValue
  implements IContentDispositionHeaderValue {
  dispositionType?: string | undefined;
  parameters?: NameValueHeaderValue[] | undefined;
  name?: string | undefined;
  fileName?: string | undefined;
  fileNameStar?: string | undefined;
  creationDate?: Date | undefined;
  modificationDate?: Date | undefined;
  readDate?: Date | undefined;
  size?: number | undefined;

  constructor(data?: IContentDispositionHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.dispositionType = _data["dispositionType"];
      if (Array.isArray(_data["parameters"])) {
        this.parameters = [] as any;
        for (let item of _data["parameters"])
          this.parameters!.push(NameValueHeaderValue.fromJS(item));
      }
      this.name = _data["name"];
      this.fileName = _data["fileName"];
      this.fileNameStar = _data["fileNameStar"];
      this.creationDate = _data["creationDate"]
        ? new Date(_data["creationDate"].toString())
        : <any>undefined;
      this.modificationDate = _data["modificationDate"]
        ? new Date(_data["modificationDate"].toString())
        : <any>undefined;
      this.readDate = _data["readDate"]
        ? new Date(_data["readDate"].toString())
        : <any>undefined;
      this.size = _data["size"];
    }
  }

  static fromJS(data: any): ContentDispositionHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new ContentDispositionHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["dispositionType"] = this.dispositionType;
    if (Array.isArray(this.parameters)) {
      data["parameters"] = [];
      for (let item of this.parameters) data["parameters"].push(item.toJSON());
    }
    data["name"] = this.name;
    data["fileName"] = this.fileName;
    data["fileNameStar"] = this.fileNameStar;
    data["creationDate"] = this.creationDate
      ? this.creationDate.toISOString()
      : <any>undefined;
    data["modificationDate"] = this.modificationDate
      ? this.modificationDate.toISOString()
      : <any>undefined;
    data["readDate"] = this.readDate
      ? this.readDate.toISOString()
      : <any>undefined;
    data["size"] = this.size;
    return data;
  }
}

export interface IContentDispositionHeaderValue {
  dispositionType?: string | undefined;
  parameters?: NameValueHeaderValue[] | undefined;
  name?: string | undefined;
  fileName?: string | undefined;
  fileNameStar?: string | undefined;
  creationDate?: Date | undefined;
  modificationDate?: Date | undefined;
  readDate?: Date | undefined;
  size?: number | undefined;
}

export class NameValueHeaderValue implements INameValueHeaderValue {
  name?: string | undefined;
  value?: string | undefined;

  constructor(data?: INameValueHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): NameValueHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new NameValueHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["value"] = this.value;
    return data;
  }
}

export interface INameValueHeaderValue {
  name?: string | undefined;
  value?: string | undefined;
}

export class ContentRangeHeaderValue implements IContentRangeHeaderValue {
  unit?: string | undefined;
  from?: number | undefined;
  to?: number | undefined;
  length?: number | undefined;
  hasLength!: boolean;
  hasRange!: boolean;

  constructor(data?: IContentRangeHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.unit = _data["unit"];
      this.from = _data["from"];
      this.to = _data["to"];
      this.length = _data["length"];
      this.hasLength = _data["hasLength"];
      this.hasRange = _data["hasRange"];
    }
  }

  static fromJS(data: any): ContentRangeHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new ContentRangeHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["unit"] = this.unit;
    data["from"] = this.from;
    data["to"] = this.to;
    data["length"] = this.length;
    data["hasLength"] = this.hasLength;
    data["hasRange"] = this.hasRange;
    return data;
  }
}

export interface IContentRangeHeaderValue {
  unit?: string | undefined;
  from?: number | undefined;
  to?: number | undefined;
  length?: number | undefined;
  hasLength: boolean;
  hasRange: boolean;
}

export class MediaTypeHeaderValue implements IMediaTypeHeaderValue {
  charSet?: string | undefined;
  parameters?: NameValueHeaderValue[] | undefined;
  mediaType?: string | undefined;

  constructor(data?: IMediaTypeHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.charSet = _data["charSet"];
      if (Array.isArray(_data["parameters"])) {
        this.parameters = [] as any;
        for (let item of _data["parameters"])
          this.parameters!.push(NameValueHeaderValue.fromJS(item));
      }
      this.mediaType = _data["mediaType"];
    }
  }

  static fromJS(data: any): MediaTypeHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new MediaTypeHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["charSet"] = this.charSet;
    if (Array.isArray(this.parameters)) {
      data["parameters"] = [];
      for (let item of this.parameters) data["parameters"].push(item.toJSON());
    }
    data["mediaType"] = this.mediaType;
    return data;
  }
}

export interface IMediaTypeHeaderValue {
  charSet?: string | undefined;
  parameters?: NameValueHeaderValue[] | undefined;
  mediaType?: string | undefined;
}

export class KeyValuePairOfStringAndIEnumerableOfString
  implements IKeyValuePairOfStringAndIEnumerableOfString {
  key?: string | undefined;
  value?: string[] | undefined;

  constructor(data?: IKeyValuePairOfStringAndIEnumerableOfString) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.key = _data["key"];
      if (Array.isArray(_data["value"])) {
        this.value = [] as any;
        for (let item of _data["value"]) this.value!.push(item);
      }
    }
  }

  static fromJS(data: any): KeyValuePairOfStringAndIEnumerableOfString {
    data = typeof data === "object" ? data : {};
    let result = new KeyValuePairOfStringAndIEnumerableOfString();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["key"] = this.key;
    if (Array.isArray(this.value)) {
      data["value"] = [];
      for (let item of this.value) data["value"].push(item);
    }
    return data;
  }
}

export interface IKeyValuePairOfStringAndIEnumerableOfString {
  key?: string | undefined;
  value?: string[] | undefined;
}

export class HttpMethod implements IHttpMethod {
  method?: string | undefined;

  constructor(data?: IHttpMethod) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.method = _data["method"];
    }
  }

  static fromJS(data: any): HttpMethod {
    data = typeof data === "object" ? data : {};
    let result = new HttpMethod();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["method"] = this.method;
    return data;
  }
}

export interface IHttpMethod {
  method?: string | undefined;
}

export class Anonymous2 implements IAnonymous2 {
  accept?: MediaTypeWithQualityHeaderValue[] | undefined;
  acceptCharset?: StringWithQualityHeaderValue[] | undefined;
  acceptEncoding?: StringWithQualityHeaderValue[] | undefined;
  acceptLanguage?: StringWithQualityHeaderValue[] | undefined;
  authorization?: AuthenticationHeaderValue | undefined;
  expect?: NameValueWithParametersHeaderValue[] | undefined;
  expectContinue?: boolean | undefined;
  from?: string | undefined;
  host?: string | undefined;
  ifMatch?: EntityTagHeaderValue[] | undefined;
  ifModifiedSince?: Date | undefined;
  ifNoneMatch?: EntityTagHeaderValue[] | undefined;
  ifRange?: RangeConditionHeaderValue | undefined;
  ifUnmodifiedSince?: Date | undefined;
  maxForwards?: number | undefined;
  proxyAuthorization?: AuthenticationHeaderValue | undefined;
  range?: RangeHeaderValue | undefined;
  referrer?: string | undefined;
  te?: TransferCodingWithQualityHeaderValue[] | undefined;
  userAgent?: ProductInfoHeaderValue[] | undefined;
  cacheControl?: CacheControlHeaderValue | undefined;
  connection?: string[] | undefined;
  connectionClose?: boolean | undefined;
  date?: Date | undefined;
  pragma?: NameValueHeaderValue[] | undefined;
  trailer?: string[] | undefined;
  transferEncoding?: TransferCodingHeaderValue[] | undefined;
  transferEncodingChunked?: boolean | undefined;
  upgrade?: ProductHeaderValue[] | undefined;
  via?: ViaHeaderValue[] | undefined;
  warning?: WarningHeaderValue[] | undefined;

  constructor(data?: IAnonymous2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["accept"])) {
        this.accept = [] as any;
        for (let item of _data["accept"])
          this.accept!.push(MediaTypeWithQualityHeaderValue.fromJS(item));
      }
      if (Array.isArray(_data["acceptCharset"])) {
        this.acceptCharset = [] as any;
        for (let item of _data["acceptCharset"])
          this.acceptCharset!.push(StringWithQualityHeaderValue.fromJS(item));
      }
      if (Array.isArray(_data["acceptEncoding"])) {
        this.acceptEncoding = [] as any;
        for (let item of _data["acceptEncoding"])
          this.acceptEncoding!.push(StringWithQualityHeaderValue.fromJS(item));
      }
      if (Array.isArray(_data["acceptLanguage"])) {
        this.acceptLanguage = [] as any;
        for (let item of _data["acceptLanguage"])
          this.acceptLanguage!.push(StringWithQualityHeaderValue.fromJS(item));
      }
      this.authorization = _data["authorization"]
        ? AuthenticationHeaderValue.fromJS(_data["authorization"])
        : <any>undefined;
      if (Array.isArray(_data["expect"])) {
        this.expect = [] as any;
        for (let item of _data["expect"])
          this.expect!.push(NameValueWithParametersHeaderValue.fromJS(item));
      }
      this.expectContinue = _data["expectContinue"];
      this.from = _data["from"];
      this.host = _data["host"];
      if (Array.isArray(_data["ifMatch"])) {
        this.ifMatch = [] as any;
        for (let item of _data["ifMatch"])
          this.ifMatch!.push(EntityTagHeaderValue.fromJS(item));
      }
      this.ifModifiedSince = _data["ifModifiedSince"]
        ? new Date(_data["ifModifiedSince"].toString())
        : <any>undefined;
      if (Array.isArray(_data["ifNoneMatch"])) {
        this.ifNoneMatch = [] as any;
        for (let item of _data["ifNoneMatch"])
          this.ifNoneMatch!.push(EntityTagHeaderValue.fromJS(item));
      }
      this.ifRange = _data["ifRange"]
        ? RangeConditionHeaderValue.fromJS(_data["ifRange"])
        : <any>undefined;
      this.ifUnmodifiedSince = _data["ifUnmodifiedSince"]
        ? new Date(_data["ifUnmodifiedSince"].toString())
        : <any>undefined;
      this.maxForwards = _data["maxForwards"];
      this.proxyAuthorization = _data["proxyAuthorization"]
        ? AuthenticationHeaderValue.fromJS(_data["proxyAuthorization"])
        : <any>undefined;
      this.range = _data["range"]
        ? RangeHeaderValue.fromJS(_data["range"])
        : <any>undefined;
      this.referrer = _data["referrer"];
      if (Array.isArray(_data["te"])) {
        this.te = [] as any;
        for (let item of _data["te"])
          this.te!.push(TransferCodingWithQualityHeaderValue.fromJS(item));
      }
      if (Array.isArray(_data["userAgent"])) {
        this.userAgent = [] as any;
        for (let item of _data["userAgent"])
          this.userAgent!.push(ProductInfoHeaderValue.fromJS(item));
      }
      this.cacheControl = _data["cacheControl"]
        ? CacheControlHeaderValue.fromJS(_data["cacheControl"])
        : <any>undefined;
      if (Array.isArray(_data["connection"])) {
        this.connection = [] as any;
        for (let item of _data["connection"]) this.connection!.push(item);
      }
      this.connectionClose = _data["connectionClose"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
      if (Array.isArray(_data["pragma"])) {
        this.pragma = [] as any;
        for (let item of _data["pragma"])
          this.pragma!.push(NameValueHeaderValue.fromJS(item));
      }
      if (Array.isArray(_data["trailer"])) {
        this.trailer = [] as any;
        for (let item of _data["trailer"]) this.trailer!.push(item);
      }
      if (Array.isArray(_data["transferEncoding"])) {
        this.transferEncoding = [] as any;
        for (let item of _data["transferEncoding"])
          this.transferEncoding!.push(TransferCodingHeaderValue.fromJS(item));
      }
      this.transferEncodingChunked = _data["transferEncodingChunked"];
      if (Array.isArray(_data["upgrade"])) {
        this.upgrade = [] as any;
        for (let item of _data["upgrade"])
          this.upgrade!.push(ProductHeaderValue.fromJS(item));
      }
      if (Array.isArray(_data["via"])) {
        this.via = [] as any;
        for (let item of _data["via"])
          this.via!.push(ViaHeaderValue.fromJS(item));
      }
      if (Array.isArray(_data["warning"])) {
        this.warning = [] as any;
        for (let item of _data["warning"])
          this.warning!.push(WarningHeaderValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): Anonymous2 {
    data = typeof data === "object" ? data : {};
    let result = new Anonymous2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.accept)) {
      data["accept"] = [];
      for (let item of this.accept) data["accept"].push(item.toJSON());
    }
    if (Array.isArray(this.acceptCharset)) {
      data["acceptCharset"] = [];
      for (let item of this.acceptCharset)
        data["acceptCharset"].push(item.toJSON());
    }
    if (Array.isArray(this.acceptEncoding)) {
      data["acceptEncoding"] = [];
      for (let item of this.acceptEncoding)
        data["acceptEncoding"].push(item.toJSON());
    }
    if (Array.isArray(this.acceptLanguage)) {
      data["acceptLanguage"] = [];
      for (let item of this.acceptLanguage)
        data["acceptLanguage"].push(item.toJSON());
    }
    data["authorization"] = this.authorization
      ? this.authorization.toJSON()
      : <any>undefined;
    if (Array.isArray(this.expect)) {
      data["expect"] = [];
      for (let item of this.expect) data["expect"].push(item.toJSON());
    }
    data["expectContinue"] = this.expectContinue;
    data["from"] = this.from;
    data["host"] = this.host;
    if (Array.isArray(this.ifMatch)) {
      data["ifMatch"] = [];
      for (let item of this.ifMatch) data["ifMatch"].push(item.toJSON());
    }
    data["ifModifiedSince"] = this.ifModifiedSince
      ? this.ifModifiedSince.toISOString()
      : <any>undefined;
    if (Array.isArray(this.ifNoneMatch)) {
      data["ifNoneMatch"] = [];
      for (let item of this.ifNoneMatch)
        data["ifNoneMatch"].push(item.toJSON());
    }
    data["ifRange"] = this.ifRange ? this.ifRange.toJSON() : <any>undefined;
    data["ifUnmodifiedSince"] = this.ifUnmodifiedSince
      ? this.ifUnmodifiedSince.toISOString()
      : <any>undefined;
    data["maxForwards"] = this.maxForwards;
    data["proxyAuthorization"] = this.proxyAuthorization
      ? this.proxyAuthorization.toJSON()
      : <any>undefined;
    data["range"] = this.range ? this.range.toJSON() : <any>undefined;
    data["referrer"] = this.referrer;
    if (Array.isArray(this.te)) {
      data["te"] = [];
      for (let item of this.te) data["te"].push(item.toJSON());
    }
    if (Array.isArray(this.userAgent)) {
      data["userAgent"] = [];
      for (let item of this.userAgent) data["userAgent"].push(item.toJSON());
    }
    data["cacheControl"] = this.cacheControl
      ? this.cacheControl.toJSON()
      : <any>undefined;
    if (Array.isArray(this.connection)) {
      data["connection"] = [];
      for (let item of this.connection) data["connection"].push(item);
    }
    data["connectionClose"] = this.connectionClose;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    if (Array.isArray(this.pragma)) {
      data["pragma"] = [];
      for (let item of this.pragma) data["pragma"].push(item.toJSON());
    }
    if (Array.isArray(this.trailer)) {
      data["trailer"] = [];
      for (let item of this.trailer) data["trailer"].push(item);
    }
    if (Array.isArray(this.transferEncoding)) {
      data["transferEncoding"] = [];
      for (let item of this.transferEncoding)
        data["transferEncoding"].push(item.toJSON());
    }
    data["transferEncodingChunked"] = this.transferEncodingChunked;
    if (Array.isArray(this.upgrade)) {
      data["upgrade"] = [];
      for (let item of this.upgrade) data["upgrade"].push(item.toJSON());
    }
    if (Array.isArray(this.via)) {
      data["via"] = [];
      for (let item of this.via) data["via"].push(item.toJSON());
    }
    if (Array.isArray(this.warning)) {
      data["warning"] = [];
      for (let item of this.warning) data["warning"].push(item.toJSON());
    }
    return data;
  }
}

export interface IAnonymous2 {
  accept?: MediaTypeWithQualityHeaderValue[] | undefined;
  acceptCharset?: StringWithQualityHeaderValue[] | undefined;
  acceptEncoding?: StringWithQualityHeaderValue[] | undefined;
  acceptLanguage?: StringWithQualityHeaderValue[] | undefined;
  authorization?: AuthenticationHeaderValue | undefined;
  expect?: NameValueWithParametersHeaderValue[] | undefined;
  expectContinue?: boolean | undefined;
  from?: string | undefined;
  host?: string | undefined;
  ifMatch?: EntityTagHeaderValue[] | undefined;
  ifModifiedSince?: Date | undefined;
  ifNoneMatch?: EntityTagHeaderValue[] | undefined;
  ifRange?: RangeConditionHeaderValue | undefined;
  ifUnmodifiedSince?: Date | undefined;
  maxForwards?: number | undefined;
  proxyAuthorization?: AuthenticationHeaderValue | undefined;
  range?: RangeHeaderValue | undefined;
  referrer?: string | undefined;
  te?: TransferCodingWithQualityHeaderValue[] | undefined;
  userAgent?: ProductInfoHeaderValue[] | undefined;
  cacheControl?: CacheControlHeaderValue | undefined;
  connection?: string[] | undefined;
  connectionClose?: boolean | undefined;
  date?: Date | undefined;
  pragma?: NameValueHeaderValue[] | undefined;
  trailer?: string[] | undefined;
  transferEncoding?: TransferCodingHeaderValue[] | undefined;
  transferEncodingChunked?: boolean | undefined;
  upgrade?: ProductHeaderValue[] | undefined;
  via?: ViaHeaderValue[] | undefined;
  warning?: WarningHeaderValue[] | undefined;
}

export class HttpRequestHeaders extends Anonymous2
  implements IHttpRequestHeaders {
  constructor(data?: IHttpRequestHeaders) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): HttpRequestHeaders {
    data = typeof data === "object" ? data : {};
    let result = new HttpRequestHeaders();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IHttpRequestHeaders extends IAnonymous2 {}

export class MediaTypeWithQualityHeaderValue extends MediaTypeHeaderValue
  implements IMediaTypeWithQualityHeaderValue {
  quality?: number | undefined;

  constructor(data?: IMediaTypeWithQualityHeaderValue) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.quality = _data["quality"];
    }
  }

  static fromJS(data: any): MediaTypeWithQualityHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new MediaTypeWithQualityHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["quality"] = this.quality;
    super.toJSON(data);
    return data;
  }
}

export interface IMediaTypeWithQualityHeaderValue
  extends IMediaTypeHeaderValue {
  quality?: number | undefined;
}

export class StringWithQualityHeaderValue
  implements IStringWithQualityHeaderValue {
  value?: string | undefined;
  quality?: number | undefined;

  constructor(data?: IStringWithQualityHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
      this.quality = _data["quality"];
    }
  }

  static fromJS(data: any): StringWithQualityHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new StringWithQualityHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["value"] = this.value;
    data["quality"] = this.quality;
    return data;
  }
}

export interface IStringWithQualityHeaderValue {
  value?: string | undefined;
  quality?: number | undefined;
}

export class AuthenticationHeaderValue implements IAuthenticationHeaderValue {
  scheme?: string | undefined;
  parameter?: string | undefined;

  constructor(data?: IAuthenticationHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.scheme = _data["scheme"];
      this.parameter = _data["parameter"];
    }
  }

  static fromJS(data: any): AuthenticationHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new AuthenticationHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["scheme"] = this.scheme;
    data["parameter"] = this.parameter;
    return data;
  }
}

export interface IAuthenticationHeaderValue {
  scheme?: string | undefined;
  parameter?: string | undefined;
}

export class NameValueWithParametersHeaderValue extends NameValueHeaderValue
  implements INameValueWithParametersHeaderValue {
  parameters?: NameValueHeaderValue[] | undefined;

  constructor(data?: INameValueWithParametersHeaderValue) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      if (Array.isArray(_data["parameters"])) {
        this.parameters = [] as any;
        for (let item of _data["parameters"])
          this.parameters!.push(NameValueHeaderValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): NameValueWithParametersHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new NameValueWithParametersHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.parameters)) {
      data["parameters"] = [];
      for (let item of this.parameters) data["parameters"].push(item.toJSON());
    }
    super.toJSON(data);
    return data;
  }
}

export interface INameValueWithParametersHeaderValue
  extends INameValueHeaderValue {
  parameters?: NameValueHeaderValue[] | undefined;
}

export class EntityTagHeaderValue implements IEntityTagHeaderValue {
  tag?: string | undefined;
  isWeak!: boolean;

  constructor(data?: IEntityTagHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tag = _data["tag"];
      this.isWeak = _data["isWeak"];
    }
  }

  static fromJS(data: any): EntityTagHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new EntityTagHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["tag"] = this.tag;
    data["isWeak"] = this.isWeak;
    return data;
  }
}

export interface IEntityTagHeaderValue {
  tag?: string | undefined;
  isWeak: boolean;
}

export class RangeConditionHeaderValue implements IRangeConditionHeaderValue {
  date?: Date | undefined;
  entityTag?: EntityTagHeaderValue | undefined;

  constructor(data?: IRangeConditionHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
      this.entityTag = _data["entityTag"]
        ? EntityTagHeaderValue.fromJS(_data["entityTag"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): RangeConditionHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new RangeConditionHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    data["entityTag"] = this.entityTag
      ? this.entityTag.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IRangeConditionHeaderValue {
  date?: Date | undefined;
  entityTag?: EntityTagHeaderValue | undefined;
}

export class RangeHeaderValue implements IRangeHeaderValue {
  unit?: string | undefined;
  ranges?: RangeItemHeaderValue[] | undefined;

  constructor(data?: IRangeHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.unit = _data["unit"];
      if (Array.isArray(_data["ranges"])) {
        this.ranges = [] as any;
        for (let item of _data["ranges"])
          this.ranges!.push(RangeItemHeaderValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RangeHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new RangeHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["unit"] = this.unit;
    if (Array.isArray(this.ranges)) {
      data["ranges"] = [];
      for (let item of this.ranges) data["ranges"].push(item.toJSON());
    }
    return data;
  }
}

export interface IRangeHeaderValue {
  unit?: string | undefined;
  ranges?: RangeItemHeaderValue[] | undefined;
}

export class RangeItemHeaderValue implements IRangeItemHeaderValue {
  from?: number | undefined;
  to?: number | undefined;

  constructor(data?: IRangeItemHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.from = _data["from"];
      this.to = _data["to"];
    }
  }

  static fromJS(data: any): RangeItemHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new RangeItemHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["from"] = this.from;
    data["to"] = this.to;
    return data;
  }
}

export interface IRangeItemHeaderValue {
  from?: number | undefined;
  to?: number | undefined;
}

export class TransferCodingHeaderValue implements ITransferCodingHeaderValue {
  value?: string | undefined;
  parameters?: NameValueHeaderValue[] | undefined;

  constructor(data?: ITransferCodingHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data["value"];
      if (Array.isArray(_data["parameters"])) {
        this.parameters = [] as any;
        for (let item of _data["parameters"])
          this.parameters!.push(NameValueHeaderValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TransferCodingHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new TransferCodingHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["value"] = this.value;
    if (Array.isArray(this.parameters)) {
      data["parameters"] = [];
      for (let item of this.parameters) data["parameters"].push(item.toJSON());
    }
    return data;
  }
}

export interface ITransferCodingHeaderValue {
  value?: string | undefined;
  parameters?: NameValueHeaderValue[] | undefined;
}

export class TransferCodingWithQualityHeaderValue
  extends TransferCodingHeaderValue
  implements ITransferCodingWithQualityHeaderValue {
  quality?: number | undefined;

  constructor(data?: ITransferCodingWithQualityHeaderValue) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.quality = _data["quality"];
    }
  }

  static fromJS(data: any): TransferCodingWithQualityHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new TransferCodingWithQualityHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["quality"] = this.quality;
    super.toJSON(data);
    return data;
  }
}

export interface ITransferCodingWithQualityHeaderValue
  extends ITransferCodingHeaderValue {
  quality?: number | undefined;
}

export class ProductInfoHeaderValue implements IProductInfoHeaderValue {
  product?: ProductHeaderValue | undefined;
  comment?: string | undefined;

  constructor(data?: IProductInfoHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.product = _data["product"]
        ? ProductHeaderValue.fromJS(_data["product"])
        : <any>undefined;
      this.comment = _data["comment"];
    }
  }

  static fromJS(data: any): ProductInfoHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new ProductInfoHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["product"] = this.product ? this.product.toJSON() : <any>undefined;
    data["comment"] = this.comment;
    return data;
  }
}

export interface IProductInfoHeaderValue {
  product?: ProductHeaderValue | undefined;
  comment?: string | undefined;
}

export class ProductHeaderValue implements IProductHeaderValue {
  name?: string | undefined;
  version?: string | undefined;

  constructor(data?: IProductHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.version = _data["version"];
    }
  }

  static fromJS(data: any): ProductHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new ProductHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["version"] = this.version;
    return data;
  }
}

export interface IProductHeaderValue {
  name?: string | undefined;
  version?: string | undefined;
}

export class CacheControlHeaderValue implements ICacheControlHeaderValue {
  noCache!: boolean;
  noCacheHeaders?: string[] | undefined;
  noStore!: boolean;
  maxAge?: string | undefined;
  sharedMaxAge?: string | undefined;
  maxStale!: boolean;
  maxStaleLimit?: string | undefined;
  minFresh?: string | undefined;
  noTransform!: boolean;
  onlyIfCached!: boolean;
  public!: boolean;
  private!: boolean;
  privateHeaders?: string[] | undefined;
  mustRevalidate!: boolean;
  proxyRevalidate!: boolean;
  extensions?: NameValueHeaderValue[] | undefined;

  constructor(data?: ICacheControlHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.noCache = _data["noCache"];
      if (Array.isArray(_data["noCacheHeaders"])) {
        this.noCacheHeaders = [] as any;
        for (let item of _data["noCacheHeaders"])
          this.noCacheHeaders!.push(item);
      }
      this.noStore = _data["noStore"];
      this.maxAge = _data["maxAge"];
      this.sharedMaxAge = _data["sharedMaxAge"];
      this.maxStale = _data["maxStale"];
      this.maxStaleLimit = _data["maxStaleLimit"];
      this.minFresh = _data["minFresh"];
      this.noTransform = _data["noTransform"];
      this.onlyIfCached = _data["onlyIfCached"];
      this.public = _data["public"];
      this.private = _data["private"];
      if (Array.isArray(_data["privateHeaders"])) {
        this.privateHeaders = [] as any;
        for (let item of _data["privateHeaders"])
          this.privateHeaders!.push(item);
      }
      this.mustRevalidate = _data["mustRevalidate"];
      this.proxyRevalidate = _data["proxyRevalidate"];
      if (Array.isArray(_data["extensions"])) {
        this.extensions = [] as any;
        for (let item of _data["extensions"])
          this.extensions!.push(NameValueHeaderValue.fromJS(item));
      }
    }
  }

  static fromJS(data: any): CacheControlHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new CacheControlHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["noCache"] = this.noCache;
    if (Array.isArray(this.noCacheHeaders)) {
      data["noCacheHeaders"] = [];
      for (let item of this.noCacheHeaders) data["noCacheHeaders"].push(item);
    }
    data["noStore"] = this.noStore;
    data["maxAge"] = this.maxAge;
    data["sharedMaxAge"] = this.sharedMaxAge;
    data["maxStale"] = this.maxStale;
    data["maxStaleLimit"] = this.maxStaleLimit;
    data["minFresh"] = this.minFresh;
    data["noTransform"] = this.noTransform;
    data["onlyIfCached"] = this.onlyIfCached;
    data["public"] = this.public;
    data["private"] = this.private;
    if (Array.isArray(this.privateHeaders)) {
      data["privateHeaders"] = [];
      for (let item of this.privateHeaders) data["privateHeaders"].push(item);
    }
    data["mustRevalidate"] = this.mustRevalidate;
    data["proxyRevalidate"] = this.proxyRevalidate;
    if (Array.isArray(this.extensions)) {
      data["extensions"] = [];
      for (let item of this.extensions) data["extensions"].push(item.toJSON());
    }
    return data;
  }
}

export interface ICacheControlHeaderValue {
  noCache: boolean;
  noCacheHeaders?: string[] | undefined;
  noStore: boolean;
  maxAge?: string | undefined;
  sharedMaxAge?: string | undefined;
  maxStale: boolean;
  maxStaleLimit?: string | undefined;
  minFresh?: string | undefined;
  noTransform: boolean;
  onlyIfCached: boolean;
  public: boolean;
  private: boolean;
  privateHeaders?: string[] | undefined;
  mustRevalidate: boolean;
  proxyRevalidate: boolean;
  extensions?: NameValueHeaderValue[] | undefined;
}

export class ViaHeaderValue implements IViaHeaderValue {
  protocolName?: string | undefined;
  protocolVersion?: string | undefined;
  receivedBy?: string | undefined;
  comment?: string | undefined;

  constructor(data?: IViaHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.protocolName = _data["protocolName"];
      this.protocolVersion = _data["protocolVersion"];
      this.receivedBy = _data["receivedBy"];
      this.comment = _data["comment"];
    }
  }

  static fromJS(data: any): ViaHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new ViaHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["protocolName"] = this.protocolName;
    data["protocolVersion"] = this.protocolVersion;
    data["receivedBy"] = this.receivedBy;
    data["comment"] = this.comment;
    return data;
  }
}

export interface IViaHeaderValue {
  protocolName?: string | undefined;
  protocolVersion?: string | undefined;
  receivedBy?: string | undefined;
  comment?: string | undefined;
}

export class WarningHeaderValue implements IWarningHeaderValue {
  code!: number;
  agent?: string | undefined;
  text?: string | undefined;
  date?: Date | undefined;

  constructor(data?: IWarningHeaderValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.agent = _data["agent"];
      this.text = _data["text"];
      this.date = _data["date"]
        ? new Date(_data["date"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): WarningHeaderValue {
    data = typeof data === "object" ? data : {};
    let result = new WarningHeaderValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["agent"] = this.agent;
    data["text"] = this.text;
    data["date"] = this.date ? this.date.toISOString() : <any>undefined;
    return data;
  }
}

export interface IWarningHeaderValue {
  code: number;
  agent?: string | undefined;
  text?: string | undefined;
  date?: Date | undefined;
}

/** Represents the raw query values in the string format from the incoming request. */
export class ODataRawQueryOptions implements IODataRawQueryOptions {
  /** Gets the raw $filter query value from the incoming request Uri if exists. */
  filter?: string | undefined;
  apply?: string | undefined;
  /** Gets the raw $orderby query value from the incoming request Uri if exists. */
  orderBy?: string | undefined;
  /** Gets the raw $top query value from the incoming request Uri if exists. */
  top?: string | undefined;
  /** Gets the raw $skip query value from the incoming request Uri if exists. */
  skip?: string | undefined;
  /** Gets the raw $select query value from the incoming request Uri if exists. */
  select?: string | undefined;
  /** Gets the raw $expand query value from the incoming request Uri if exists. */
  expand?: string | undefined;
  /** Gets the raw $count query value from the incoming request Uri if exists. */
  count?: string | undefined;
  /** Gets the raw $format query value from the incoming request Uri if exists. */
  format?: string | undefined;
  /** Gets the raw $skiptoken query value from the incoming request Uri if exists. */
  skipToken?: string | undefined;
  deltaToken?: string | undefined;

  constructor(data?: IODataRawQueryOptions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.filter = _data["filter"];
      this.apply = _data["apply"];
      this.orderBy = _data["orderBy"];
      this.top = _data["top"];
      this.skip = _data["skip"];
      this.select = _data["select"];
      this.expand = _data["expand"];
      this.count = _data["count"];
      this.format = _data["format"];
      this.skipToken = _data["skipToken"];
      this.deltaToken = _data["deltaToken"];
    }
  }

  static fromJS(data: any): ODataRawQueryOptions {
    data = typeof data === "object" ? data : {};
    let result = new ODataRawQueryOptions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["filter"] = this.filter;
    data["apply"] = this.apply;
    data["orderBy"] = this.orderBy;
    data["top"] = this.top;
    data["skip"] = this.skip;
    data["select"] = this.select;
    data["expand"] = this.expand;
    data["count"] = this.count;
    data["format"] = this.format;
    data["skipToken"] = this.skipToken;
    data["deltaToken"] = this.deltaToken;
    return data;
  }
}

/** Represents the raw query values in the string format from the incoming request. */
export interface IODataRawQueryOptions {
  /** Gets the raw $filter query value from the incoming request Uri if exists. */
  filter?: string | undefined;
  apply?: string | undefined;
  /** Gets the raw $orderby query value from the incoming request Uri if exists. */
  orderBy?: string | undefined;
  /** Gets the raw $top query value from the incoming request Uri if exists. */
  top?: string | undefined;
  /** Gets the raw $skip query value from the incoming request Uri if exists. */
  skip?: string | undefined;
  /** Gets the raw $select query value from the incoming request Uri if exists. */
  select?: string | undefined;
  /** Gets the raw $expand query value from the incoming request Uri if exists. */
  expand?: string | undefined;
  /** Gets the raw $count query value from the incoming request Uri if exists. */
  count?: string | undefined;
  /** Gets the raw $format query value from the incoming request Uri if exists. */
  format?: string | undefined;
  /** Gets the raw $skiptoken query value from the incoming request Uri if exists. */
  skipToken?: string | undefined;
  deltaToken?: string | undefined;
}

/** Represents the OData $select and $expand query options. */
export class SelectExpandQueryOption implements ISelectExpandQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets the raw $select value. */
  rawSelect?: string | undefined;
  /** Gets the raw $expand value. */
  rawExpand?: string | undefined;
  /** Gets or sets the $select and $expand query validator. */
  validator?: SelectExpandQueryValidator | undefined;
  /** Gets the parsed SelectExpandClause for this query option. */
  selectExpandClause?: SelectExpandClause | undefined;
  /** Gets or sets the number of levels that a top level $expand=NavigationProperty($levels=max) will be expanded. This value will decrease by one with each nesting level in the $expand clause. For example, with a property value 5, the following query $expand=A($expand=B($expand=C($levels=max))) will be interpreted as $expand=A($expand=B($expand=C($levels=3))). If the query gets validated, the MaxExpansionDepth value must be greater than or equal to this value. */
  levelsMaxLiteralExpansionDepth!: number;

  constructor(data?: ISelectExpandQueryOption) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.context = _data["context"]
        ? ODataQueryContext.fromJS(_data["context"])
        : <any>undefined;
      this.rawSelect = _data["rawSelect"];
      this.rawExpand = _data["rawExpand"];
      this.validator = _data["validator"]
        ? SelectExpandQueryValidator.fromJS(_data["validator"])
        : <any>undefined;
      this.selectExpandClause = _data["selectExpandClause"]
        ? SelectExpandClause.fromJS(_data["selectExpandClause"])
        : <any>undefined;
      this.levelsMaxLiteralExpansionDepth =
        _data["levelsMaxLiteralExpansionDepth"];
    }
  }

  static fromJS(data: any): SelectExpandQueryOption {
    data = typeof data === "object" ? data : {};
    let result = new SelectExpandQueryOption();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["context"] = this.context ? this.context.toJSON() : <any>undefined;
    data["rawSelect"] = this.rawSelect;
    data["rawExpand"] = this.rawExpand;
    data["validator"] = this.validator
      ? this.validator.toJSON()
      : <any>undefined;
    data["selectExpandClause"] = this.selectExpandClause
      ? this.selectExpandClause.toJSON()
      : <any>undefined;
    data[
      "levelsMaxLiteralExpansionDepth"
    ] = this.levelsMaxLiteralExpansionDepth;
    return data;
  }
}

/** Represents the OData $select and $expand query options. */
export interface ISelectExpandQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets the raw $select value. */
  rawSelect?: string | undefined;
  /** Gets the raw $expand value. */
  rawExpand?: string | undefined;
  /** Gets or sets the $select and $expand query validator. */
  validator?: SelectExpandQueryValidator | undefined;
  /** Gets the parsed SelectExpandClause for this query option. */
  selectExpandClause?: SelectExpandClause | undefined;
  /** Gets or sets the number of levels that a top level $expand=NavigationProperty($levels=max) will be expanded. This value will decrease by one with each nesting level in the $expand clause. For example, with a property value 5, the following query $expand=A($expand=B($expand=C($levels=max))) will be interpreted as $expand=A($expand=B($expand=C($levels=3))). If the query gets validated, the MaxExpansionDepth value must be greater than or equal to this value. */
  levelsMaxLiteralExpansionDepth: number;
}

/** Represents a validator used to validate a SelectExpandQueryOption based on the ODataValidationSettings. */
export class SelectExpandQueryValidator implements ISelectExpandQueryValidator {
  constructor(data?: ISelectExpandQueryValidator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): SelectExpandQueryValidator {
    data = typeof data === "object" ? data : {};
    let result = new SelectExpandQueryValidator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Represents a validator used to validate a SelectExpandQueryOption based on the ODataValidationSettings. */
export interface ISelectExpandQueryValidator {}

/** Class representing the combined semantic meaning of any select or expand clauses in the uri. */
export class SelectExpandClause implements ISelectExpandClause {
  /** Gets the selected properties and operations. */
  selectedItems?: SelectItem[] | undefined;
  /** Gets a flag indicating that everything at this level has been selected. */
  allSelected!: boolean;

  constructor(data?: ISelectExpandClause) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["selectedItems"])) {
        this.selectedItems = [] as any;
        for (let item of _data["selectedItems"])
          this.selectedItems!.push(SelectItem.fromJS(item));
      }
      this.allSelected = _data["allSelected"];
    }
  }

  static fromJS(data: any): SelectExpandClause {
    data = typeof data === "object" ? data : {};
    let result = new SelectExpandClause();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.selectedItems)) {
      data["selectedItems"] = [];
      for (let item of this.selectedItems)
        data["selectedItems"].push(item.toJSON());
    }
    data["allSelected"] = this.allSelected;
    return data;
  }
}

/** Class representing the combined semantic meaning of any select or expand clauses in the uri. */
export interface ISelectExpandClause {
  /** Gets the selected properties and operations. */
  selectedItems?: SelectItem[] | undefined;
  /** Gets a flag indicating that everything at this level has been selected. */
  allSelected: boolean;
}

/** An item that has been selected by the query at the current level of the tree. */
export abstract class SelectItem implements ISelectItem {
  constructor(data?: ISelectItem) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): SelectItem {
    data = typeof data === "object" ? data : {};
    throw new Error("The abstract class 'SelectItem' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** An item that has been selected by the query at the current level of the tree. */
export interface ISelectItem {}

export class ApplyQueryOption implements IApplyQueryOption {
  context?: ODataQueryContext | undefined;
  resultClrType?: string | undefined;
  applyClause?: ApplyClause | undefined;
  rawValue?: string | undefined;

  constructor(data?: IApplyQueryOption) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.context = _data["context"]
        ? ODataQueryContext.fromJS(_data["context"])
        : <any>undefined;
      this.resultClrType = _data["resultClrType"];
      this.applyClause = _data["applyClause"]
        ? ApplyClause.fromJS(_data["applyClause"])
        : <any>undefined;
      this.rawValue = _data["rawValue"];
    }
  }

  static fromJS(data: any): ApplyQueryOption {
    data = typeof data === "object" ? data : {};
    let result = new ApplyQueryOption();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["context"] = this.context ? this.context.toJSON() : <any>undefined;
    data["resultClrType"] = this.resultClrType;
    data["applyClause"] = this.applyClause
      ? this.applyClause.toJSON()
      : <any>undefined;
    data["rawValue"] = this.rawValue;
    return data;
  }
}

export interface IApplyQueryOption {
  context?: ODataQueryContext | undefined;
  resultClrType?: string | undefined;
  applyClause?: ApplyClause | undefined;
  rawValue?: string | undefined;
}

/** Represents the set of transformations to perform as part of $apply. */
export class ApplyClause implements IApplyClause {
  /** The collection of transformations to perform. */
  transformations?: TransformationNode[] | undefined;

  constructor(data?: IApplyClause) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["transformations"])) {
        this.transformations = [] as any;
        for (let item of _data["transformations"])
          this.transformations!.push(TransformationNode.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ApplyClause {
    data = typeof data === "object" ? data : {};
    let result = new ApplyClause();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.transformations)) {
      data["transformations"] = [];
      for (let item of this.transformations)
        data["transformations"].push(item.toJSON());
    }
    return data;
  }
}

/** Represents the set of transformations to perform as part of $apply. */
export interface IApplyClause {
  /** The collection of transformations to perform. */
  transformations?: TransformationNode[] | undefined;
}

/** Base class for all transformation nodes. */
export abstract class TransformationNode implements ITransformationNode {
  constructor(data?: ITransformationNode) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): TransformationNode {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'TransformationNode' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Base class for all transformation nodes. */
export interface ITransformationNode {}

/** This defines a $filter OData query option for querying. */
export class FilterQueryOption implements IFilterQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets or sets the Filter Query Validator */
  validator?: FilterQueryValidator | undefined;
  /** Gets the parsed FilterClause for this query option. */
  filterClause?: FilterClause | undefined;
  /** Gets the raw $filter value. */
  rawValue?: string | undefined;

  constructor(data?: IFilterQueryOption) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.context = _data["context"]
        ? ODataQueryContext.fromJS(_data["context"])
        : <any>undefined;
      this.validator = _data["validator"]
        ? FilterQueryValidator.fromJS(_data["validator"])
        : <any>undefined;
      this.filterClause = _data["filterClause"]
        ? FilterClause.fromJS(_data["filterClause"])
        : <any>undefined;
      this.rawValue = _data["rawValue"];
    }
  }

  static fromJS(data: any): FilterQueryOption {
    data = typeof data === "object" ? data : {};
    let result = new FilterQueryOption();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["context"] = this.context ? this.context.toJSON() : <any>undefined;
    data["validator"] = this.validator
      ? this.validator.toJSON()
      : <any>undefined;
    data["filterClause"] = this.filterClause
      ? this.filterClause.toJSON()
      : <any>undefined;
    data["rawValue"] = this.rawValue;
    return data;
  }
}

/** This defines a $filter OData query option for querying. */
export interface IFilterQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets or sets the Filter Query Validator */
  validator?: FilterQueryValidator | undefined;
  /** Gets the parsed FilterClause for this query option. */
  filterClause?: FilterClause | undefined;
  /** Gets the raw $filter value. */
  rawValue?: string | undefined;
}

/** Represents a validator used to validate a FilterQueryOption based on the ODataValidationSettings. */
export class FilterQueryValidator implements IFilterQueryValidator {
  constructor(data?: IFilterQueryValidator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): FilterQueryValidator {
    data = typeof data === "object" ? data : {};
    let result = new FilterQueryValidator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Represents a validator used to validate a FilterQueryOption based on the ODataValidationSettings. */
export interface IFilterQueryValidator {}

/** The result of parsing a $filter query option. */
export class FilterClause implements IFilterClause {
  /** Gets the filter expression - this should evaluate to a single boolean value. */
  expression?: SingleValueNode | undefined;
  /** Gets the parameter for the expression which represents a single value from the collection. */
  rangeVariable?: RangeVariable | undefined;
  /** Gets the type of item returned by this clause. */
  itemType?: IEdmTypeReference | undefined;

  constructor(data?: IFilterClause) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.expression = _data["expression"]
        ? SingleValueNode.fromJS(_data["expression"])
        : <any>undefined;
      this.rangeVariable = _data["rangeVariable"]
        ? RangeVariable.fromJS(_data["rangeVariable"])
        : <any>undefined;
      this.itemType = _data["itemType"]
        ? IEdmTypeReference.fromJS(_data["itemType"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): FilterClause {
    data = typeof data === "object" ? data : {};
    let result = new FilterClause();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["expression"] = this.expression
      ? this.expression.toJSON()
      : <any>undefined;
    data["rangeVariable"] = this.rangeVariable
      ? this.rangeVariable.toJSON()
      : <any>undefined;
    data["itemType"] = this.itemType ? this.itemType.toJSON() : <any>undefined;
    return data;
  }
}

/** The result of parsing a $filter query option. */
export interface IFilterClause {
  /** Gets the filter expression - this should evaluate to a single boolean value. */
  expression?: SingleValueNode | undefined;
  /** Gets the parameter for the expression which represents a single value from the collection. */
  rangeVariable?: RangeVariable | undefined;
  /** Gets the type of item returned by this clause. */
  itemType?: IEdmTypeReference | undefined;
}

/** Base class for all semantic metadata bound nodes. */
export abstract class QueryNode implements IQueryNode {
  constructor(data?: IQueryNode) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): QueryNode {
    data = typeof data === "object" ? data : {};
    throw new Error("The abstract class 'QueryNode' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Base class for all semantic metadata bound nodes. */
export interface IQueryNode {}

/** Base class for all semantic metadata bound nodes which represent a single composable value. */
export abstract class SingleValueNode extends QueryNode
  implements ISingleValueNode {
  /** Gets the kind of this node. */
  kind!: QueryNodeKind;

  constructor(data?: ISingleValueNode) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.kind = _data["kind"];
    }
  }

  static fromJS(data: any): SingleValueNode {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'SingleValueNode' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["kind"] = this.kind;
    super.toJSON(data);
    return data;
  }
}

/** Base class for all semantic metadata bound nodes which represent a single composable value. */
export interface ISingleValueNode extends IQueryNode {
  /** Gets the kind of this node. */
  kind: QueryNodeKind;
}

/** Public enumeration of kinds of query nodes. A subset of InternalQueryNodeKind */
export enum QueryNodeKind {
  None = 0,
  Constant = 1,
  Convert = 2,
  NonResourceRangeVariableReference = 3,
  BinaryOperator = 4,
  UnaryOperator = 5,
  SingleValuePropertyAccess = 6,
  CollectionPropertyAccess = 7,
  SingleValueFunctionCall = 8,
  Any = 9,
  CollectionNavigationNode = 10,
  SingleNavigationNode = 11,
  SingleValueOpenPropertyAccess = 12,
  SingleResourceCast = 13,
  All = 14,
  CollectionResourceCast = 15,
  ResourceRangeVariableReference = 16,
  SingleResourceFunctionCall = 17,
  CollectionFunctionCall = 18,
  CollectionResourceFunctionCall = 19,
  NamedFunctionParameter = 20,
  ParameterAlias = 21,
  EntitySet = 22,
  KeyLookup = 23,
  SearchTerm = 24,
  CollectionOpenPropertyAccess = 25,
  CollectionComplexNode = 26,
  SingleComplexNode = 27,
  Count = 28
}

/** A RangeVariable, which represents an iterator variable either over a collection, either of entities or not. Exists outside of the main SemanticAST, but hooked in via a RangeVariableReferenceNode (either Non-Entity or Entity). */
export abstract class RangeVariable implements IRangeVariable {
  constructor(data?: IRangeVariable) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): RangeVariable {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'RangeVariable' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** A RangeVariable, which represents an iterator variable either over a collection, either of entities or not. Exists outside of the main SemanticAST, but hooked in via a RangeVariableReferenceNode (either Non-Entity or Entity). */
export interface IRangeVariable {}

/** This defines a $orderby OData query option for querying. */
export class OrderByQueryOption implements IOrderByQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets the mutable list of OrderByPropertyNode instances for this query option. */
  orderByNodes?: OrderByNode[] | undefined;
  /** Gets the raw $orderby value. */
  rawValue?: string | undefined;
  /** Gets or sets the OrderBy Query Validator. */
  validator?: OrderByQueryValidator | undefined;
  /** Gets the parsed OrderByClause for this query option. */
  orderByClause?: OrderByClause | undefined;

  constructor(data?: IOrderByQueryOption) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.context = _data["context"]
        ? ODataQueryContext.fromJS(_data["context"])
        : <any>undefined;
      if (Array.isArray(_data["orderByNodes"])) {
        this.orderByNodes = [] as any;
        for (let item of _data["orderByNodes"])
          this.orderByNodes!.push(OrderByNode.fromJS(item));
      }
      this.rawValue = _data["rawValue"];
      this.validator = _data["validator"]
        ? OrderByQueryValidator.fromJS(_data["validator"])
        : <any>undefined;
      this.orderByClause = _data["orderByClause"]
        ? OrderByClause.fromJS(_data["orderByClause"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): OrderByQueryOption {
    data = typeof data === "object" ? data : {};
    let result = new OrderByQueryOption();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["context"] = this.context ? this.context.toJSON() : <any>undefined;
    if (Array.isArray(this.orderByNodes)) {
      data["orderByNodes"] = [];
      for (let item of this.orderByNodes)
        data["orderByNodes"].push(item.toJSON());
    }
    data["rawValue"] = this.rawValue;
    data["validator"] = this.validator
      ? this.validator.toJSON()
      : <any>undefined;
    data["orderByClause"] = this.orderByClause
      ? this.orderByClause.toJSON()
      : <any>undefined;
    return data;
  }
}

/** This defines a $orderby OData query option for querying. */
export interface IOrderByQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets the mutable list of OrderByPropertyNode instances for this query option. */
  orderByNodes?: OrderByNode[] | undefined;
  /** Gets the raw $orderby value. */
  rawValue?: string | undefined;
  /** Gets or sets the OrderBy Query Validator. */
  validator?: OrderByQueryValidator | undefined;
  /** Gets the parsed OrderByClause for this query option. */
  orderByClause?: OrderByClause | undefined;
}

/** Represents a single order by expression in the $orderby clause. */
export abstract class OrderByNode implements IOrderByNode {
  /** Gets the OrderByDirection for the current node. */
  direction!: OrderByDirection;

  constructor(data?: IOrderByNode) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.direction = _data["direction"];
    }
  }

  static fromJS(data: any): OrderByNode {
    data = typeof data === "object" ? data : {};
    throw new Error("The abstract class 'OrderByNode' cannot be instantiated.");
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["direction"] = this.direction;
    return data;
  }
}

/** Represents a single order by expression in the $orderby clause. */
export interface IOrderByNode {
  /** Gets the OrderByDirection for the current node. */
  direction: OrderByDirection;
}

/** Enumeration of order by directions. */
export enum OrderByDirection {
  Ascending = 0,
  Descending = 1
}

/** Represents a validator used to validate an OrderByQueryOption based on the ODataValidationSettings. */
export class OrderByQueryValidator implements IOrderByQueryValidator {
  constructor(data?: IOrderByQueryValidator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): OrderByQueryValidator {
    data = typeof data === "object" ? data : {};
    let result = new OrderByQueryValidator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Represents a validator used to validate an OrderByQueryOption based on the ODataValidationSettings. */
export interface IOrderByQueryValidator {}

/** Represents the result of parsing the $orderby query option. */
export class OrderByClause implements IOrderByClause {
  /** Gets the next orderby to perform after performing this orderby, can be null in the case of only a single orderby expression. */
  thenBy?: OrderByClause | undefined;
  /** Gets the order-by expression. */
  expression?: SingleValueNode | undefined;
  /** Gets the direction to order. */
  direction!: OrderByDirection;
  /** Gets the rangeVariable for the expression which represents a single value from the collection we iterate over. */
  rangeVariable?: RangeVariable | undefined;
  /** Gets the type of a single item from the collection returned after ordering. */
  itemType?: IEdmTypeReference | undefined;

  constructor(data?: IOrderByClause) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.thenBy = _data["thenBy"]
        ? OrderByClause.fromJS(_data["thenBy"])
        : <any>undefined;
      this.expression = _data["expression"]
        ? SingleValueNode.fromJS(_data["expression"])
        : <any>undefined;
      this.direction = _data["direction"];
      this.rangeVariable = _data["rangeVariable"]
        ? RangeVariable.fromJS(_data["rangeVariable"])
        : <any>undefined;
      this.itemType = _data["itemType"]
        ? IEdmTypeReference.fromJS(_data["itemType"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): OrderByClause {
    data = typeof data === "object" ? data : {};
    let result = new OrderByClause();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["thenBy"] = this.thenBy ? this.thenBy.toJSON() : <any>undefined;
    data["expression"] = this.expression
      ? this.expression.toJSON()
      : <any>undefined;
    data["direction"] = this.direction;
    data["rangeVariable"] = this.rangeVariable
      ? this.rangeVariable.toJSON()
      : <any>undefined;
    data["itemType"] = this.itemType ? this.itemType.toJSON() : <any>undefined;
    return data;
  }
}

/** Represents the result of parsing the $orderby query option. */
export interface IOrderByClause {
  /** Gets the next orderby to perform after performing this orderby, can be null in the case of only a single orderby expression. */
  thenBy?: OrderByClause | undefined;
  /** Gets the order-by expression. */
  expression?: SingleValueNode | undefined;
  /** Gets the direction to order. */
  direction: OrderByDirection;
  /** Gets the rangeVariable for the expression which represents a single value from the collection we iterate over. */
  rangeVariable?: RangeVariable | undefined;
  /** Gets the type of a single item from the collection returned after ordering. */
  itemType?: IEdmTypeReference | undefined;
}

/** This defines a $skip OData query option for querying. */
export class SkipQueryOption implements ISkipQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets the raw $skip value. */
  rawValue?: string | undefined;
  /** Gets the value of the $skip as a parsed integer. */
  value!: number;
  /** Gets or sets the Skip Query Validator. */
  validator?: SkipQueryValidator | undefined;

  constructor(data?: ISkipQueryOption) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.context = _data["context"]
        ? ODataQueryContext.fromJS(_data["context"])
        : <any>undefined;
      this.rawValue = _data["rawValue"];
      this.value = _data["value"];
      this.validator = _data["validator"]
        ? SkipQueryValidator.fromJS(_data["validator"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): SkipQueryOption {
    data = typeof data === "object" ? data : {};
    let result = new SkipQueryOption();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["context"] = this.context ? this.context.toJSON() : <any>undefined;
    data["rawValue"] = this.rawValue;
    data["value"] = this.value;
    data["validator"] = this.validator
      ? this.validator.toJSON()
      : <any>undefined;
    return data;
  }
}

/** This defines a $skip OData query option for querying. */
export interface ISkipQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets the raw $skip value. */
  rawValue?: string | undefined;
  /** Gets the value of the $skip as a parsed integer. */
  value: number;
  /** Gets or sets the Skip Query Validator. */
  validator?: SkipQueryValidator | undefined;
}

/** Represents a validator used to validate a SkipQueryOption based on the ODataValidationSettings. */
export class SkipQueryValidator implements ISkipQueryValidator {
  constructor(data?: ISkipQueryValidator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): SkipQueryValidator {
    data = typeof data === "object" ? data : {};
    let result = new SkipQueryValidator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Represents a validator used to validate a SkipQueryOption based on the ODataValidationSettings. */
export interface ISkipQueryValidator {}

/** This defines a $top OData query option for querying. */
export class TopQueryOption implements ITopQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets the raw $top value. */
  rawValue?: string | undefined;
  /** Gets the value of the $top as a parsed integer. */
  value!: number;
  /** Gets or sets the Top Query Validator. */
  validator?: TopQueryValidator | undefined;

  constructor(data?: ITopQueryOption) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.context = _data["context"]
        ? ODataQueryContext.fromJS(_data["context"])
        : <any>undefined;
      this.rawValue = _data["rawValue"];
      this.value = _data["value"];
      this.validator = _data["validator"]
        ? TopQueryValidator.fromJS(_data["validator"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): TopQueryOption {
    data = typeof data === "object" ? data : {};
    let result = new TopQueryOption();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["context"] = this.context ? this.context.toJSON() : <any>undefined;
    data["rawValue"] = this.rawValue;
    data["value"] = this.value;
    data["validator"] = this.validator
      ? this.validator.toJSON()
      : <any>undefined;
    return data;
  }
}

/** This defines a $top OData query option for querying. */
export interface ITopQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets the raw $top value. */
  rawValue?: string | undefined;
  /** Gets the value of the $top as a parsed integer. */
  value: number;
  /** Gets or sets the Top Query Validator. */
  validator?: TopQueryValidator | undefined;
}

/** Represents a validator used to validate a TopQueryOption based on the ODataValidationSettings. */
export class TopQueryValidator implements ITopQueryValidator {
  constructor(data?: ITopQueryValidator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): TopQueryValidator {
    data = typeof data === "object" ? data : {};
    let result = new TopQueryValidator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Represents a validator used to validate a TopQueryOption based on the ODataValidationSettings. */
export interface ITopQueryValidator {}

/** Represents the value of the $count query option and exposes a way to retrieve the number of entities that satisfy a query. */
export class CountQueryOption implements ICountQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets the raw $count value. */
  rawValue?: string | undefined;
  /** Gets the value of the $count in a parsed form. */
  value!: boolean;
  /** Gets or sets the $count query validator. */
  validator?: CountQueryValidator | undefined;

  constructor(data?: ICountQueryOption) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.context = _data["context"]
        ? ODataQueryContext.fromJS(_data["context"])
        : <any>undefined;
      this.rawValue = _data["rawValue"];
      this.value = _data["value"];
      this.validator = _data["validator"]
        ? CountQueryValidator.fromJS(_data["validator"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CountQueryOption {
    data = typeof data === "object" ? data : {};
    let result = new CountQueryOption();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["context"] = this.context ? this.context.toJSON() : <any>undefined;
    data["rawValue"] = this.rawValue;
    data["value"] = this.value;
    data["validator"] = this.validator
      ? this.validator.toJSON()
      : <any>undefined;
    return data;
  }
}

/** Represents the value of the $count query option and exposes a way to retrieve the number of entities that satisfy a query. */
export interface ICountQueryOption {
  /** Gets the given ODataQueryContext. */
  context?: ODataQueryContext | undefined;
  /** Gets the raw $count value. */
  rawValue?: string | undefined;
  /** Gets the value of the $count in a parsed form. */
  value: boolean;
  /** Gets or sets the $count query validator. */
  validator?: CountQueryValidator | undefined;
}

/** Represents a validator used to validate a CountQueryOption based on the ODataValidationSettings. */
export class CountQueryValidator implements ICountQueryValidator {
  constructor(data?: ICountQueryValidator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): CountQueryValidator {
    data = typeof data === "object" ? data : {};
    let result = new CountQueryValidator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Represents a validator used to validate a CountQueryOption based on the ODataValidationSettings. */
export interface ICountQueryValidator {}

/** Represents a validator used to validate OData queries based on the ODataValidationSettings. */
export class ODataQueryValidator implements IODataQueryValidator {
  constructor(data?: IODataQueryValidator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {}

  static fromJS(data: any): ODataQueryValidator {
    data = typeof data === "object" ? data : {};
    let result = new ODataQueryValidator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    return data;
  }
}

/** Represents a validator used to validate OData queries based on the ODataValidationSettings. */
export interface IODataQueryValidator {}

export class EstimateSummaryExtended extends EstimateSummary
  implements IEstimateSummaryExtended {
  blobUrl?: string | undefined;
  description?: string | undefined;
  filter1?: string | undefined;
  filter2?: string | undefined;
  filter3?: string | undefined;
  filter4?: string | undefined;
  filter5?: string | undefined;
  filter6?: string | undefined;
  address?: string | undefined;
  resp_Estimator?: string | undefined;
  tot_Cost!: number;
  bid_Amount!: number;
  status?: string | undefined;
  owner?: string | undefined;
  wc_State?: string | undefined;
  project_Name?: string | undefined;
  project_Number?: string | undefined;
  type_Work?: string | undefined;
  availableReports?: ReportViewModel[] | undefined;

  constructor(data?: IEstimateSummaryExtended) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.blobUrl = _data["blobUrl"];
      this.description = _data["description"];
      this.filter1 = _data["filter1"];
      this.filter2 = _data["filter2"];
      this.filter3 = _data["filter3"];
      this.filter4 = _data["filter4"];
      this.filter5 = _data["filter5"];
      this.filter6 = _data["filter6"];
      this.address = _data["address"];
      this.resp_Estimator = _data["resp_Estimator"];
      this.tot_Cost = _data["tot_Cost"];
      this.bid_Amount = _data["bid_Amount"];
      this.status = _data["status"];
      this.owner = _data["owner"];
      this.wc_State = _data["wc_State"];
      this.project_Name = _data["project_Name"];
      this.project_Number = _data["project_Number"];
      this.type_Work = _data["type_Work"];
      if (Array.isArray(_data["availableReports"])) {
        this.availableReports = [] as any;
        for (let item of _data["availableReports"])
          this.availableReports!.push(ReportViewModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): EstimateSummaryExtended {
    data = typeof data === "object" ? data : {};
    let result = new EstimateSummaryExtended();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["blobUrl"] = this.blobUrl;
    data["description"] = this.description;
    data["filter1"] = this.filter1;
    data["filter2"] = this.filter2;
    data["filter3"] = this.filter3;
    data["filter4"] = this.filter4;
    data["filter5"] = this.filter5;
    data["filter6"] = this.filter6;
    data["address"] = this.address;
    data["resp_Estimator"] = this.resp_Estimator;
    data["tot_Cost"] = this.tot_Cost;
    data["bid_Amount"] = this.bid_Amount;
    data["status"] = this.status;
    data["owner"] = this.owner;
    data["wc_State"] = this.wc_State;
    data["project_Name"] = this.project_Name;
    data["project_Number"] = this.project_Number;
    data["type_Work"] = this.type_Work;
    if (Array.isArray(this.availableReports)) {
      data["availableReports"] = [];
      for (let item of this.availableReports)
        data["availableReports"].push(item.toJSON());
    }
    super.toJSON(data);
    return data;
  }
}

export interface IEstimateSummaryExtended extends IEstimateSummary {
  blobUrl?: string | undefined;
  description?: string | undefined;
  filter1?: string | undefined;
  filter2?: string | undefined;
  filter3?: string | undefined;
  filter4?: string | undefined;
  filter5?: string | undefined;
  filter6?: string | undefined;
  address?: string | undefined;
  resp_Estimator?: string | undefined;
  tot_Cost: number;
  bid_Amount: number;
  status?: string | undefined;
  owner?: string | undefined;
  wc_State?: string | undefined;
  project_Name?: string | undefined;
  project_Number?: string | undefined;
  type_Work?: string | undefined;
  availableReports?: ReportViewModel[] | undefined;
}

export class ReportViewModel implements IReportViewModel {
  estimateId!: string;
  type!: ReportType;
  createdAt!: Date;
  reportName?: string | undefined;
  displayName?: string | undefined;

  constructor(data?: IReportViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.estimateId = _data["estimateId"];
      this.type = _data["type"];
      this.createdAt = _data["createdAt"]
        ? new Date(_data["createdAt"].toString())
        : <any>undefined;
      this.reportName = _data["reportName"];
      this.displayName = _data["displayName"];
    }
  }

  static fromJS(data: any): ReportViewModel {
    data = typeof data === "object" ? data : {};
    let result = new ReportViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["estimateId"] = this.estimateId;
    data["type"] = this.type;
    data["createdAt"] = this.createdAt
      ? this.createdAt.toISOString()
      : <any>undefined;
    data["reportName"] = this.reportName;
    data["displayName"] = this.displayName;
    return data;
  }
}

export interface IReportViewModel {
  estimateId: string;
  type: ReportType;
  createdAt: Date;
  reportName?: string | undefined;
  displayName?: string | undefined;
}

export enum ReportType {
  Cost = 0,
  CostAndPrice = 1,
  EstimateRecap = 2
}

export abstract class EstimateHistoryBaseTable
  implements IEstimateHistoryBaseTable {
  id!: string;

  constructor(data?: IEstimateHistoryBaseTable) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
    }
  }

  static fromJS(data: any): EstimateHistoryBaseTable {
    data = typeof data === "object" ? data : {};
    throw new Error(
      "The abstract class 'EstimateHistoryBaseTable' cannot be instantiated."
    );
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    return data;
  }
}

export interface IEstimateHistoryBaseTable {
  id: string;
}

export class Estimate extends EstimateHistoryBaseTable implements IEstimate {
  partitionId!: string;
  code?: string | undefined;
  name?: string | undefined;
  blobUrl?: string | undefined;
  processedStatus!: StatusCode;
  description?: string | undefined;
  estimateVersion?: string | undefined;
  filters?: EstimateFilters | undefined;
  totals?: EstimateTotals | undefined;
  lastModified!: Date;
  lastProcessed?: Date | undefined;
  processedStatusFailureCode!: ProcessedEstimateFailureCode;
  isExcludedEstimate!: boolean;
  isActiveEstimate!: boolean;
  isDeleted!: boolean;
  empId?: string | undefined;
  deletedTimestamp?: Date | undefined;
  activeEstimateBackups?: ActiveEstimateBackup[] | undefined;
  rootDirectory?: string | undefined;

  constructor(data?: IEstimate) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.partitionId = _data["partitionId"];
      this.code = _data["code"];
      this.name = _data["name"];
      this.blobUrl = _data["blobUrl"];
      this.processedStatus = _data["processedStatus"];
      this.description = _data["description"];
      this.estimateVersion = _data["estimateVersion"];
      this.filters = _data["filters"]
        ? EstimateFilters.fromJS(_data["filters"])
        : <any>undefined;
      this.totals = _data["totals"]
        ? EstimateTotals.fromJS(_data["totals"])
        : <any>undefined;
      this.lastModified = _data["lastModified"]
        ? new Date(_data["lastModified"].toString())
        : <any>undefined;
      this.lastProcessed = _data["lastProcessed"]
        ? new Date(_data["lastProcessed"].toString())
        : <any>undefined;
      this.processedStatusFailureCode = _data["processedStatusFailureCode"];
      this.isExcludedEstimate = _data["isExcludedEstimate"];
      this.isActiveEstimate = _data["isActiveEstimate"];
      this.isDeleted = _data["isDeleted"];
      this.empId = _data["empId"];
      this.deletedTimestamp = _data["deletedTimestamp"]
        ? new Date(_data["deletedTimestamp"].toString())
        : <any>undefined;
      if (Array.isArray(_data["activeEstimateBackups"])) {
        this.activeEstimateBackups = [] as any;
        for (let item of _data["activeEstimateBackups"])
          this.activeEstimateBackups!.push(ActiveEstimateBackup.fromJS(item));
      }
      this.rootDirectory = _data["rootDirectory"];
    }
  }

  static fromJS(data: any): Estimate {
    data = typeof data === "object" ? data : {};
    let result = new Estimate();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["partitionId"] = this.partitionId;
    data["code"] = this.code;
    data["name"] = this.name;
    data["blobUrl"] = this.blobUrl;
    data["processedStatus"] = this.processedStatus;
    data["description"] = this.description;
    data["estimateVersion"] = this.estimateVersion;
    data["filters"] = this.filters ? this.filters.toJSON() : <any>undefined;
    data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
    data["lastModified"] = this.lastModified
      ? this.lastModified.toISOString()
      : <any>undefined;
    data["lastProcessed"] = this.lastProcessed
      ? this.lastProcessed.toISOString()
      : <any>undefined;
    data["processedStatusFailureCode"] = this.processedStatusFailureCode;
    data["isExcludedEstimate"] = this.isExcludedEstimate;
    data["isActiveEstimate"] = this.isActiveEstimate;
    data["isDeleted"] = this.isDeleted;
    data["empId"] = this.empId;
    data["deletedTimestamp"] = this.deletedTimestamp
      ? this.deletedTimestamp.toISOString()
      : <any>undefined;
    if (Array.isArray(this.activeEstimateBackups)) {
      data["activeEstimateBackups"] = [];
      for (let item of this.activeEstimateBackups)
        data["activeEstimateBackups"].push(item.toJSON());
    }
    data["rootDirectory"] = this.rootDirectory;
    super.toJSON(data);
    return data;
  }
}

export interface IEstimate extends IEstimateHistoryBaseTable {
  partitionId: string;
  code?: string | undefined;
  name?: string | undefined;
  blobUrl?: string | undefined;
  processedStatus: StatusCode;
  description?: string | undefined;
  estimateVersion?: string | undefined;
  filters?: EstimateFilters | undefined;
  totals?: EstimateTotals | undefined;
  lastModified: Date;
  lastProcessed?: Date | undefined;
  processedStatusFailureCode: ProcessedEstimateFailureCode;
  isExcludedEstimate: boolean;
  isActiveEstimate: boolean;
  isDeleted: boolean;
  empId?: string | undefined;
  deletedTimestamp?: Date | undefined;
  activeEstimateBackups?: ActiveEstimateBackup[] | undefined;
  rootDirectory?: string | undefined;
}

export class EstimateFilters implements IEstimateFilters {
  project_Name?: string | undefined;
  project_Number?: string | undefined;
  status?: string | undefined;
  engineer?: string | undefined;
  resp_Estimator?: string | undefined;
  owner?: string | undefined;
  bid_Date?: Date | undefined;
  start_Date?: Date | undefined;
  review_Date?: Date | undefined;
  created_Date?: Date | undefined;
  modified_Date?: Date | undefined;
  modified_Time?: number | undefined;
  bid_Amount?: number | undefined;
  takeoff_Amount?: number | undefined;
  profit_Bidquan?: number | undefined;
  profit_Takeoff?: number | undefined;
  tot_Cost?: number | undefined;
  wc_State?: string | undefined;
  type_Work?: string | undefined;
  filter_1?: string | undefined;
  filter_2?: string | undefined;
  filter_3?: string | undefined;
  filter_4?: string | undefined;
  filter_5?: string | undefined;
  filter_6?: string | undefined;
  user_Ascii1?: string | undefined;
  user_Ascii2?: string | undefined;
  user_Ascii3?: string | undefined;
  user_Ascii4?: string | undefined;
  user_Ascii5?: string | undefined;
  user_Ascii6?: string | undefined;
  user_Ascii7?: string | undefined;
  user_Ascii8?: string | undefined;
  user_Ascii9?: string | undefined;
  user_Ascii10?: string | undefined;
  user_Ascii11?: string | undefined;
  user_Ascii12?: string | undefined;
  user_Ascii13?: string | undefined;
  user_Ascii14?: string | undefined;
  user_Ascii15?: string | undefined;
  user_Ascii16?: string | undefined;
  user_Ascii17?: string | undefined;
  user_Ascii18?: string | undefined;
  user_Ascii19?: string | undefined;
  user_Ascii20?: string | undefined;
  user_Vendor1?: string | undefined;
  user_Vendor2?: string | undefined;
  user_Vendor3?: string | undefined;
  user_Vendor4?: string | undefined;
  user_Vendor5?: string | undefined;
  user_Vendor6?: string | undefined;
  user_Flag1?: string | undefined;
  user_Flag2?: string | undefined;
  user_Flag3?: string | undefined;
  user_Flag4?: string | undefined;
  user_Flag5?: string | undefined;
  user_Flag6?: string | undefined;
  user_Flag7?: string | undefined;
  user_Flag8?: string | undefined;
  user_Flag9?: string | undefined;
  user_Flag10?: string | undefined;
  user_Flag11?: string | undefined;
  user_Flag12?: string | undefined;
  user_Code1?: string | undefined;
  user_Name2?: string | undefined;
  user_Integer1?: number | undefined;
  user_Integer2?: number | undefined;
  user_Integer3?: number | undefined;
  user_Integer4?: number | undefined;
  user_Integer5?: number | undefined;
  user_Number1?: number | undefined;
  user_Number2?: number | undefined;
  user_Number3?: number | undefined;
  user_Number4?: number | undefined;
  user_Number5?: number | undefined;
  user_Number6?: number | undefined;
  user_Number7?: number | undefined;
  user_Number8?: number | undefined;
  user_Number9?: number | undefined;
  user_Number10?: number | undefined;
  user_Number11?: number | undefined;
  user_Number12?: number | undefined;
  user_Number13?: number | undefined;
  user_Number14?: number | undefined;
  user_Number15?: number | undefined;
  user_Number16?: number | undefined;
  user_Number17?: number | undefined;
  user_Number18?: number | undefined;
  user_Number19?: number | undefined;
  user_Number20?: number | undefined;
  user_Perc1?: number | undefined;
  user_Perc2?: number | undefined;
  user_Def_Date?: Date | undefined;
  user_Date2?: Date | undefined;
  user_Date3?: Date | undefined;
  user_Date4?: Date | undefined;
  user_Date5?: Date | undefined;
  user_Date6?: Date | undefined;
  user_Date7?: Date | undefined;
  user_Date8?: Date | undefined;
  user_Date9?: Date | undefined;
  user_Date10?: Date | undefined;
  user_Date11?: Date | undefined;
  address?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;

  constructor(data?: IEstimateFilters) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.project_Name = _data["project_Name"];
      this.project_Number = _data["project_Number"];
      this.status = _data["status"];
      this.engineer = _data["engineer"];
      this.resp_Estimator = _data["resp_Estimator"];
      this.owner = _data["owner"];
      this.bid_Date = _data["bid_Date"]
        ? new Date(_data["bid_Date"].toString())
        : <any>undefined;
      this.start_Date = _data["start_Date"]
        ? new Date(_data["start_Date"].toString())
        : <any>undefined;
      this.review_Date = _data["review_Date"]
        ? new Date(_data["review_Date"].toString())
        : <any>undefined;
      this.created_Date = _data["created_Date"]
        ? new Date(_data["created_Date"].toString())
        : <any>undefined;
      this.modified_Date = _data["modified_Date"]
        ? new Date(_data["modified_Date"].toString())
        : <any>undefined;
      this.modified_Time = _data["modified_Time"];
      this.bid_Amount = _data["bid_Amount"];
      this.takeoff_Amount = _data["takeoff_Amount"];
      this.profit_Bidquan = _data["profit_Bidquan"];
      this.profit_Takeoff = _data["profit_Takeoff"];
      this.tot_Cost = _data["tot_Cost"];
      this.wc_State = _data["wc_State"];
      this.type_Work = _data["type_Work"];
      this.filter_1 = _data["filter_1"];
      this.filter_2 = _data["filter_2"];
      this.filter_3 = _data["filter_3"];
      this.filter_4 = _data["filter_4"];
      this.filter_5 = _data["filter_5"];
      this.filter_6 = _data["filter_6"];
      this.user_Ascii1 = _data["user_Ascii1"];
      this.user_Ascii2 = _data["user_Ascii2"];
      this.user_Ascii3 = _data["user_Ascii3"];
      this.user_Ascii4 = _data["user_Ascii4"];
      this.user_Ascii5 = _data["user_Ascii5"];
      this.user_Ascii6 = _data["user_Ascii6"];
      this.user_Ascii7 = _data["user_Ascii7"];
      this.user_Ascii8 = _data["user_Ascii8"];
      this.user_Ascii9 = _data["user_Ascii9"];
      this.user_Ascii10 = _data["user_Ascii10"];
      this.user_Ascii11 = _data["user_Ascii11"];
      this.user_Ascii12 = _data["user_Ascii12"];
      this.user_Ascii13 = _data["user_Ascii13"];
      this.user_Ascii14 = _data["user_Ascii14"];
      this.user_Ascii15 = _data["user_Ascii15"];
      this.user_Ascii16 = _data["user_Ascii16"];
      this.user_Ascii17 = _data["user_Ascii17"];
      this.user_Ascii18 = _data["user_Ascii18"];
      this.user_Ascii19 = _data["user_Ascii19"];
      this.user_Ascii20 = _data["user_Ascii20"];
      this.user_Vendor1 = _data["user_Vendor1"];
      this.user_Vendor2 = _data["user_Vendor2"];
      this.user_Vendor3 = _data["user_Vendor3"];
      this.user_Vendor4 = _data["user_Vendor4"];
      this.user_Vendor5 = _data["user_Vendor5"];
      this.user_Vendor6 = _data["user_Vendor6"];
      this.user_Flag1 = _data["user_Flag1"];
      this.user_Flag2 = _data["user_Flag2"];
      this.user_Flag3 = _data["user_Flag3"];
      this.user_Flag4 = _data["user_Flag4"];
      this.user_Flag5 = _data["user_Flag5"];
      this.user_Flag6 = _data["user_Flag6"];
      this.user_Flag7 = _data["user_Flag7"];
      this.user_Flag8 = _data["user_Flag8"];
      this.user_Flag9 = _data["user_Flag9"];
      this.user_Flag10 = _data["user_Flag10"];
      this.user_Flag11 = _data["user_Flag11"];
      this.user_Flag12 = _data["user_Flag12"];
      this.user_Code1 = _data["user_Code1"];
      this.user_Name2 = _data["user_Name2"];
      this.user_Integer1 = _data["user_Integer1"];
      this.user_Integer2 = _data["user_Integer2"];
      this.user_Integer3 = _data["user_Integer3"];
      this.user_Integer4 = _data["user_Integer4"];
      this.user_Integer5 = _data["user_Integer5"];
      this.user_Number1 = _data["user_Number1"];
      this.user_Number2 = _data["user_Number2"];
      this.user_Number3 = _data["user_Number3"];
      this.user_Number4 = _data["user_Number4"];
      this.user_Number5 = _data["user_Number5"];
      this.user_Number6 = _data["user_Number6"];
      this.user_Number7 = _data["user_Number7"];
      this.user_Number8 = _data["user_Number8"];
      this.user_Number9 = _data["user_Number9"];
      this.user_Number10 = _data["user_Number10"];
      this.user_Number11 = _data["user_Number11"];
      this.user_Number12 = _data["user_Number12"];
      this.user_Number13 = _data["user_Number13"];
      this.user_Number14 = _data["user_Number14"];
      this.user_Number15 = _data["user_Number15"];
      this.user_Number16 = _data["user_Number16"];
      this.user_Number17 = _data["user_Number17"];
      this.user_Number18 = _data["user_Number18"];
      this.user_Number19 = _data["user_Number19"];
      this.user_Number20 = _data["user_Number20"];
      this.user_Perc1 = _data["user_Perc1"];
      this.user_Perc2 = _data["user_Perc2"];
      this.user_Def_Date = _data["user_Def_Date"]
        ? new Date(_data["user_Def_Date"].toString())
        : <any>undefined;
      this.user_Date2 = _data["user_Date2"]
        ? new Date(_data["user_Date2"].toString())
        : <any>undefined;
      this.user_Date3 = _data["user_Date3"]
        ? new Date(_data["user_Date3"].toString())
        : <any>undefined;
      this.user_Date4 = _data["user_Date4"]
        ? new Date(_data["user_Date4"].toString())
        : <any>undefined;
      this.user_Date5 = _data["user_Date5"]
        ? new Date(_data["user_Date5"].toString())
        : <any>undefined;
      this.user_Date6 = _data["user_Date6"]
        ? new Date(_data["user_Date6"].toString())
        : <any>undefined;
      this.user_Date7 = _data["user_Date7"]
        ? new Date(_data["user_Date7"].toString())
        : <any>undefined;
      this.user_Date8 = _data["user_Date8"]
        ? new Date(_data["user_Date8"].toString())
        : <any>undefined;
      this.user_Date9 = _data["user_Date9"]
        ? new Date(_data["user_Date9"].toString())
        : <any>undefined;
      this.user_Date10 = _data["user_Date10"]
        ? new Date(_data["user_Date10"].toString())
        : <any>undefined;
      this.user_Date11 = _data["user_Date11"]
        ? new Date(_data["user_Date11"].toString())
        : <any>undefined;
      this.address = _data["address"];
      this.latitude = _data["latitude"];
      this.longitude = _data["longitude"];
    }
  }

  static fromJS(data: any): EstimateFilters {
    data = typeof data === "object" ? data : {};
    let result = new EstimateFilters();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["project_Name"] = this.project_Name;
    data["project_Number"] = this.project_Number;
    data["status"] = this.status;
    data["engineer"] = this.engineer;
    data["resp_Estimator"] = this.resp_Estimator;
    data["owner"] = this.owner;
    data["bid_Date"] = this.bid_Date
      ? this.bid_Date.toISOString()
      : <any>undefined;
    data["start_Date"] = this.start_Date
      ? this.start_Date.toISOString()
      : <any>undefined;
    data["review_Date"] = this.review_Date
      ? this.review_Date.toISOString()
      : <any>undefined;
    data["created_Date"] = this.created_Date
      ? this.created_Date.toISOString()
      : <any>undefined;
    data["modified_Date"] = this.modified_Date
      ? this.modified_Date.toISOString()
      : <any>undefined;
    data["modified_Time"] = this.modified_Time;
    data["bid_Amount"] = this.bid_Amount;
    data["takeoff_Amount"] = this.takeoff_Amount;
    data["profit_Bidquan"] = this.profit_Bidquan;
    data["profit_Takeoff"] = this.profit_Takeoff;
    data["tot_Cost"] = this.tot_Cost;
    data["wc_State"] = this.wc_State;
    data["type_Work"] = this.type_Work;
    data["filter_1"] = this.filter_1;
    data["filter_2"] = this.filter_2;
    data["filter_3"] = this.filter_3;
    data["filter_4"] = this.filter_4;
    data["filter_5"] = this.filter_5;
    data["filter_6"] = this.filter_6;
    data["user_Ascii1"] = this.user_Ascii1;
    data["user_Ascii2"] = this.user_Ascii2;
    data["user_Ascii3"] = this.user_Ascii3;
    data["user_Ascii4"] = this.user_Ascii4;
    data["user_Ascii5"] = this.user_Ascii5;
    data["user_Ascii6"] = this.user_Ascii6;
    data["user_Ascii7"] = this.user_Ascii7;
    data["user_Ascii8"] = this.user_Ascii8;
    data["user_Ascii9"] = this.user_Ascii9;
    data["user_Ascii10"] = this.user_Ascii10;
    data["user_Ascii11"] = this.user_Ascii11;
    data["user_Ascii12"] = this.user_Ascii12;
    data["user_Ascii13"] = this.user_Ascii13;
    data["user_Ascii14"] = this.user_Ascii14;
    data["user_Ascii15"] = this.user_Ascii15;
    data["user_Ascii16"] = this.user_Ascii16;
    data["user_Ascii17"] = this.user_Ascii17;
    data["user_Ascii18"] = this.user_Ascii18;
    data["user_Ascii19"] = this.user_Ascii19;
    data["user_Ascii20"] = this.user_Ascii20;
    data["user_Vendor1"] = this.user_Vendor1;
    data["user_Vendor2"] = this.user_Vendor2;
    data["user_Vendor3"] = this.user_Vendor3;
    data["user_Vendor4"] = this.user_Vendor4;
    data["user_Vendor5"] = this.user_Vendor5;
    data["user_Vendor6"] = this.user_Vendor6;
    data["user_Flag1"] = this.user_Flag1;
    data["user_Flag2"] = this.user_Flag2;
    data["user_Flag3"] = this.user_Flag3;
    data["user_Flag4"] = this.user_Flag4;
    data["user_Flag5"] = this.user_Flag5;
    data["user_Flag6"] = this.user_Flag6;
    data["user_Flag7"] = this.user_Flag7;
    data["user_Flag8"] = this.user_Flag8;
    data["user_Flag9"] = this.user_Flag9;
    data["user_Flag10"] = this.user_Flag10;
    data["user_Flag11"] = this.user_Flag11;
    data["user_Flag12"] = this.user_Flag12;
    data["user_Code1"] = this.user_Code1;
    data["user_Name2"] = this.user_Name2;
    data["user_Integer1"] = this.user_Integer1;
    data["user_Integer2"] = this.user_Integer2;
    data["user_Integer3"] = this.user_Integer3;
    data["user_Integer4"] = this.user_Integer4;
    data["user_Integer5"] = this.user_Integer5;
    data["user_Number1"] = this.user_Number1;
    data["user_Number2"] = this.user_Number2;
    data["user_Number3"] = this.user_Number3;
    data["user_Number4"] = this.user_Number4;
    data["user_Number5"] = this.user_Number5;
    data["user_Number6"] = this.user_Number6;
    data["user_Number7"] = this.user_Number7;
    data["user_Number8"] = this.user_Number8;
    data["user_Number9"] = this.user_Number9;
    data["user_Number10"] = this.user_Number10;
    data["user_Number11"] = this.user_Number11;
    data["user_Number12"] = this.user_Number12;
    data["user_Number13"] = this.user_Number13;
    data["user_Number14"] = this.user_Number14;
    data["user_Number15"] = this.user_Number15;
    data["user_Number16"] = this.user_Number16;
    data["user_Number17"] = this.user_Number17;
    data["user_Number18"] = this.user_Number18;
    data["user_Number19"] = this.user_Number19;
    data["user_Number20"] = this.user_Number20;
    data["user_Perc1"] = this.user_Perc1;
    data["user_Perc2"] = this.user_Perc2;
    data["user_Def_Date"] = this.user_Def_Date
      ? this.user_Def_Date.toISOString()
      : <any>undefined;
    data["user_Date2"] = this.user_Date2
      ? this.user_Date2.toISOString()
      : <any>undefined;
    data["user_Date3"] = this.user_Date3
      ? this.user_Date3.toISOString()
      : <any>undefined;
    data["user_Date4"] = this.user_Date4
      ? this.user_Date4.toISOString()
      : <any>undefined;
    data["user_Date5"] = this.user_Date5
      ? this.user_Date5.toISOString()
      : <any>undefined;
    data["user_Date6"] = this.user_Date6
      ? this.user_Date6.toISOString()
      : <any>undefined;
    data["user_Date7"] = this.user_Date7
      ? this.user_Date7.toISOString()
      : <any>undefined;
    data["user_Date8"] = this.user_Date8
      ? this.user_Date8.toISOString()
      : <any>undefined;
    data["user_Date9"] = this.user_Date9
      ? this.user_Date9.toISOString()
      : <any>undefined;
    data["user_Date10"] = this.user_Date10
      ? this.user_Date10.toISOString()
      : <any>undefined;
    data["user_Date11"] = this.user_Date11
      ? this.user_Date11.toISOString()
      : <any>undefined;
    data["address"] = this.address;
    data["latitude"] = this.latitude;
    data["longitude"] = this.longitude;
    return data;
  }
}

export interface IEstimateFilters {
  project_Name?: string | undefined;
  project_Number?: string | undefined;
  status?: string | undefined;
  engineer?: string | undefined;
  resp_Estimator?: string | undefined;
  owner?: string | undefined;
  bid_Date?: Date | undefined;
  start_Date?: Date | undefined;
  review_Date?: Date | undefined;
  created_Date?: Date | undefined;
  modified_Date?: Date | undefined;
  modified_Time?: number | undefined;
  bid_Amount?: number | undefined;
  takeoff_Amount?: number | undefined;
  profit_Bidquan?: number | undefined;
  profit_Takeoff?: number | undefined;
  tot_Cost?: number | undefined;
  wc_State?: string | undefined;
  type_Work?: string | undefined;
  filter_1?: string | undefined;
  filter_2?: string | undefined;
  filter_3?: string | undefined;
  filter_4?: string | undefined;
  filter_5?: string | undefined;
  filter_6?: string | undefined;
  user_Ascii1?: string | undefined;
  user_Ascii2?: string | undefined;
  user_Ascii3?: string | undefined;
  user_Ascii4?: string | undefined;
  user_Ascii5?: string | undefined;
  user_Ascii6?: string | undefined;
  user_Ascii7?: string | undefined;
  user_Ascii8?: string | undefined;
  user_Ascii9?: string | undefined;
  user_Ascii10?: string | undefined;
  user_Ascii11?: string | undefined;
  user_Ascii12?: string | undefined;
  user_Ascii13?: string | undefined;
  user_Ascii14?: string | undefined;
  user_Ascii15?: string | undefined;
  user_Ascii16?: string | undefined;
  user_Ascii17?: string | undefined;
  user_Ascii18?: string | undefined;
  user_Ascii19?: string | undefined;
  user_Ascii20?: string | undefined;
  user_Vendor1?: string | undefined;
  user_Vendor2?: string | undefined;
  user_Vendor3?: string | undefined;
  user_Vendor4?: string | undefined;
  user_Vendor5?: string | undefined;
  user_Vendor6?: string | undefined;
  user_Flag1?: string | undefined;
  user_Flag2?: string | undefined;
  user_Flag3?: string | undefined;
  user_Flag4?: string | undefined;
  user_Flag5?: string | undefined;
  user_Flag6?: string | undefined;
  user_Flag7?: string | undefined;
  user_Flag8?: string | undefined;
  user_Flag9?: string | undefined;
  user_Flag10?: string | undefined;
  user_Flag11?: string | undefined;
  user_Flag12?: string | undefined;
  user_Code1?: string | undefined;
  user_Name2?: string | undefined;
  user_Integer1?: number | undefined;
  user_Integer2?: number | undefined;
  user_Integer3?: number | undefined;
  user_Integer4?: number | undefined;
  user_Integer5?: number | undefined;
  user_Number1?: number | undefined;
  user_Number2?: number | undefined;
  user_Number3?: number | undefined;
  user_Number4?: number | undefined;
  user_Number5?: number | undefined;
  user_Number6?: number | undefined;
  user_Number7?: number | undefined;
  user_Number8?: number | undefined;
  user_Number9?: number | undefined;
  user_Number10?: number | undefined;
  user_Number11?: number | undefined;
  user_Number12?: number | undefined;
  user_Number13?: number | undefined;
  user_Number14?: number | undefined;
  user_Number15?: number | undefined;
  user_Number16?: number | undefined;
  user_Number17?: number | undefined;
  user_Number18?: number | undefined;
  user_Number19?: number | undefined;
  user_Number20?: number | undefined;
  user_Perc1?: number | undefined;
  user_Perc2?: number | undefined;
  user_Def_Date?: Date | undefined;
  user_Date2?: Date | undefined;
  user_Date3?: Date | undefined;
  user_Date4?: Date | undefined;
  user_Date5?: Date | undefined;
  user_Date6?: Date | undefined;
  user_Date7?: Date | undefined;
  user_Date8?: Date | undefined;
  user_Date9?: Date | undefined;
  user_Date10?: Date | undefined;
  user_Date11?: Date | undefined;
  address?: string | undefined;
  latitude?: number | undefined;
  longitude?: number | undefined;
}

export class EstimateTotals implements IEstimateTotals {
  baseLabor_Direct!: number;
  baseLabor_Indirect!: number;
  baseLabor_Total!: number;
  burden_Direct!: number;
  burden_Indirect!: number;
  burden_Total!: number;
  totalLabor_Direct!: number;
  totalLabor_Indirect!: number;
  totalLabor_Total!: number;
  permanentMaterial_Direct!: number;
  permanentMaterial_Indirect!: number;
  permanentMaterial_Total!: number;
  constructionMaterial_Direct!: number;
  constructionMaterial_Indirect!: number;
  constructionMaterial_Total!: number;
  subcontract_Direct!: number;
  subcontract_Indirect!: number;
  subcontract_Total!: number;
  equipmentOperatingExpense_Direct!: number;
  equipmentOperatingExpense_Indirect!: number;
  equipmentOperatingExpense_Total!: number;
  companyEquipment_Direct!: number;
  companyEquipment_Indirect!: number;
  companyEquipment_Total!: number;
  rentedEquipment_Direct!: number;
  rentedEquipment_Indirect!: number;
  rentedEquipment_Total!: number;
  misc1_Direct!: number;
  misc1_Indirect!: number;
  misc1_Total!: number;
  misc2_Direct!: number;
  misc2_Indirect!: number;
  misc2_Total!: number;
  misc3_Direct!: number;
  misc3_Indirect!: number;
  misc3_Total!: number;
  totalEntryCost_Takeoff_Direct!: number;
  totalEntryCost_Takeoff_Indirect!: number;
  totalEntryCost_Takeoff_Total!: number;
  totalEntryCost_Bid_Direct!: number;
  totalEntryCost_Bid_Indirect!: number;
  totalEntryCost_Bid_Total!: number;
  balMarkup_Bid!: number;
  actualMarkup_Bid!: number;
  balancedBid_Bid!: number;
  bidTotal_Bid!: number;
  addonBondTotal!: number;
  totalEqp_Direct!: number;
  totalEqp_Indirect!: number;
  totalEqp_Total!: number;
  manhours_Direct!: number;
  manhours_Indirect!: number;
  manhours_Total!: number;
  addon_Cost!: number;
  bond!: number;
  addon_Markup!: number;
  addon_Total!: number;
  totalCost_Takeoff!: number;
  job_Duration!: number;
  balMarkup_Takeoff!: number;
  actualMarkup_Takeoff!: number;
  balancedBid_Takeoff!: number;
  passThrough_Cost!: number;
  passThrough_Adjustment!: number;
  passThrough_Total!: number;
  totalCost_Bid_LessPassThrough!: number;
  totalCost_Bid!: number;
  total_User_Adjustments!: number;
  total_User_Adjustments_Cost!: number;
  desired_Bid!: number;
  desired_Bid_Diff!: number;
  bidTotal_Takeoff!: number;
  totalCost_Takeoff_LessPassThrough!: number;
  markupPercentCost_Takeoff!: number;
  markupPercentCost_Bid!: number;
  markupPercentSales_Takeoff!: number;
  markupPercentSales_Bid!: number;
  totalCost_Takeoff_LessPassThroughAndAdjustments!: number;
  totalCost_Bid_LessPassThroughAndAdjustments!: number;
  totalEntryCost_Bid_Spread_Indirect!: number;
  addonBond_Cost_Bid_Spread_Total!: number;
  totalCost_Bid_Spread!: number;
  balMarkup_Bid_Spread!: number;
  actualMarkup_Bid_Spread!: number;
  actv_User_Quan1!: number;
  actv_User_Quan2!: number;
  actv_User_Quan3!: number;
  actv_User_Quan4!: number;
  open_Biditems!: number;
  minority_Goal_Percent!: number;
  minority_Goal_Total!: number;
  minority_Current_Percent!: number;
  minority_Current_Total!: number;

  constructor(data?: IEstimateTotals) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.baseLabor_Direct = _data["baseLabor_Direct"];
      this.baseLabor_Indirect = _data["baseLabor_Indirect"];
      this.baseLabor_Total = _data["baseLabor_Total"];
      this.burden_Direct = _data["burden_Direct"];
      this.burden_Indirect = _data["burden_Indirect"];
      this.burden_Total = _data["burden_Total"];
      this.totalLabor_Direct = _data["totalLabor_Direct"];
      this.totalLabor_Indirect = _data["totalLabor_Indirect"];
      this.totalLabor_Total = _data["totalLabor_Total"];
      this.permanentMaterial_Direct = _data["permanentMaterial_Direct"];
      this.permanentMaterial_Indirect = _data["permanentMaterial_Indirect"];
      this.permanentMaterial_Total = _data["permanentMaterial_Total"];
      this.constructionMaterial_Direct = _data["constructionMaterial_Direct"];
      this.constructionMaterial_Indirect =
        _data["constructionMaterial_Indirect"];
      this.constructionMaterial_Total = _data["constructionMaterial_Total"];
      this.subcontract_Direct = _data["subcontract_Direct"];
      this.subcontract_Indirect = _data["subcontract_Indirect"];
      this.subcontract_Total = _data["subcontract_Total"];
      this.equipmentOperatingExpense_Direct =
        _data["equipmentOperatingExpense_Direct"];
      this.equipmentOperatingExpense_Indirect =
        _data["equipmentOperatingExpense_Indirect"];
      this.equipmentOperatingExpense_Total =
        _data["equipmentOperatingExpense_Total"];
      this.companyEquipment_Direct = _data["companyEquipment_Direct"];
      this.companyEquipment_Indirect = _data["companyEquipment_Indirect"];
      this.companyEquipment_Total = _data["companyEquipment_Total"];
      this.rentedEquipment_Direct = _data["rentedEquipment_Direct"];
      this.rentedEquipment_Indirect = _data["rentedEquipment_Indirect"];
      this.rentedEquipment_Total = _data["rentedEquipment_Total"];
      this.misc1_Direct = _data["misc1_Direct"];
      this.misc1_Indirect = _data["misc1_Indirect"];
      this.misc1_Total = _data["misc1_Total"];
      this.misc2_Direct = _data["misc2_Direct"];
      this.misc2_Indirect = _data["misc2_Indirect"];
      this.misc2_Total = _data["misc2_Total"];
      this.misc3_Direct = _data["misc3_Direct"];
      this.misc3_Indirect = _data["misc3_Indirect"];
      this.misc3_Total = _data["misc3_Total"];
      this.totalEntryCost_Takeoff_Direct =
        _data["totalEntryCost_Takeoff_Direct"];
      this.totalEntryCost_Takeoff_Indirect =
        _data["totalEntryCost_Takeoff_Indirect"];
      this.totalEntryCost_Takeoff_Total = _data["totalEntryCost_Takeoff_Total"];
      this.totalEntryCost_Bid_Direct = _data["totalEntryCost_Bid_Direct"];
      this.totalEntryCost_Bid_Indirect = _data["totalEntryCost_Bid_Indirect"];
      this.totalEntryCost_Bid_Total = _data["totalEntryCost_Bid_Total"];
      this.balMarkup_Bid = _data["balMarkup_Bid"];
      this.actualMarkup_Bid = _data["actualMarkup_Bid"];
      this.balancedBid_Bid = _data["balancedBid_Bid"];
      this.bidTotal_Bid = _data["bidTotal_Bid"];
      this.addonBondTotal = _data["addonBondTotal"];
      this.totalEqp_Direct = _data["totalEqp_Direct"];
      this.totalEqp_Indirect = _data["totalEqp_Indirect"];
      this.totalEqp_Total = _data["totalEqp_Total"];
      this.manhours_Direct = _data["manhours_Direct"];
      this.manhours_Indirect = _data["manhours_Indirect"];
      this.manhours_Total = _data["manhours_Total"];
      this.addon_Cost = _data["addon_Cost"];
      this.bond = _data["bond"];
      this.addon_Markup = _data["addon_Markup"];
      this.addon_Total = _data["addon_Total"];
      this.totalCost_Takeoff = _data["totalCost_Takeoff"];
      this.job_Duration = _data["job_Duration"];
      this.balMarkup_Takeoff = _data["balMarkup_Takeoff"];
      this.actualMarkup_Takeoff = _data["actualMarkup_Takeoff"];
      this.balancedBid_Takeoff = _data["balancedBid_Takeoff"];
      this.passThrough_Cost = _data["passThrough_Cost"];
      this.passThrough_Adjustment = _data["passThrough_Adjustment"];
      this.passThrough_Total = _data["passThrough_Total"];
      this.totalCost_Bid_LessPassThrough =
        _data["totalCost_Bid_LessPassThrough"];
      this.totalCost_Bid = _data["totalCost_Bid"];
      this.total_User_Adjustments = _data["total_User_Adjustments"];
      this.total_User_Adjustments_Cost = _data["total_User_Adjustments_Cost"];
      this.desired_Bid = _data["desired_Bid"];
      this.desired_Bid_Diff = _data["desired_Bid_Diff"];
      this.bidTotal_Takeoff = _data["bidTotal_Takeoff"];
      this.totalCost_Takeoff_LessPassThrough =
        _data["totalCost_Takeoff_LessPassThrough"];
      this.markupPercentCost_Takeoff = _data["markupPercentCost_Takeoff"];
      this.markupPercentCost_Bid = _data["markupPercentCost_Bid"];
      this.markupPercentSales_Takeoff = _data["markupPercentSales_Takeoff"];
      this.markupPercentSales_Bid = _data["markupPercentSales_Bid"];
      this.totalCost_Takeoff_LessPassThroughAndAdjustments =
        _data["totalCost_Takeoff_LessPassThroughAndAdjustments"];
      this.totalCost_Bid_LessPassThroughAndAdjustments =
        _data["totalCost_Bid_LessPassThroughAndAdjustments"];
      this.totalEntryCost_Bid_Spread_Indirect =
        _data["totalEntryCost_Bid_Spread_Indirect"];
      this.addonBond_Cost_Bid_Spread_Total =
        _data["addonBond_Cost_Bid_Spread_Total"];
      this.totalCost_Bid_Spread = _data["totalCost_Bid_Spread"];
      this.balMarkup_Bid_Spread = _data["balMarkup_Bid_Spread"];
      this.actualMarkup_Bid_Spread = _data["actualMarkup_Bid_Spread"];
      this.actv_User_Quan1 = _data["actv_User_Quan1"];
      this.actv_User_Quan2 = _data["actv_User_Quan2"];
      this.actv_User_Quan3 = _data["actv_User_Quan3"];
      this.actv_User_Quan4 = _data["actv_User_Quan4"];
      this.open_Biditems = _data["open_Biditems"];
      this.minority_Goal_Percent = _data["minority_Goal_Percent"];
      this.minority_Goal_Total = _data["minority_Goal_Total"];
      this.minority_Current_Percent = _data["minority_Current_Percent"];
      this.minority_Current_Total = _data["minority_Current_Total"];
    }
  }

  static fromJS(data: any): EstimateTotals {
    data = typeof data === "object" ? data : {};
    let result = new EstimateTotals();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["baseLabor_Direct"] = this.baseLabor_Direct;
    data["baseLabor_Indirect"] = this.baseLabor_Indirect;
    data["baseLabor_Total"] = this.baseLabor_Total;
    data["burden_Direct"] = this.burden_Direct;
    data["burden_Indirect"] = this.burden_Indirect;
    data["burden_Total"] = this.burden_Total;
    data["totalLabor_Direct"] = this.totalLabor_Direct;
    data["totalLabor_Indirect"] = this.totalLabor_Indirect;
    data["totalLabor_Total"] = this.totalLabor_Total;
    data["permanentMaterial_Direct"] = this.permanentMaterial_Direct;
    data["permanentMaterial_Indirect"] = this.permanentMaterial_Indirect;
    data["permanentMaterial_Total"] = this.permanentMaterial_Total;
    data["constructionMaterial_Direct"] = this.constructionMaterial_Direct;
    data["constructionMaterial_Indirect"] = this.constructionMaterial_Indirect;
    data["constructionMaterial_Total"] = this.constructionMaterial_Total;
    data["subcontract_Direct"] = this.subcontract_Direct;
    data["subcontract_Indirect"] = this.subcontract_Indirect;
    data["subcontract_Total"] = this.subcontract_Total;
    data[
      "equipmentOperatingExpense_Direct"
    ] = this.equipmentOperatingExpense_Direct;
    data[
      "equipmentOperatingExpense_Indirect"
    ] = this.equipmentOperatingExpense_Indirect;
    data[
      "equipmentOperatingExpense_Total"
    ] = this.equipmentOperatingExpense_Total;
    data["companyEquipment_Direct"] = this.companyEquipment_Direct;
    data["companyEquipment_Indirect"] = this.companyEquipment_Indirect;
    data["companyEquipment_Total"] = this.companyEquipment_Total;
    data["rentedEquipment_Direct"] = this.rentedEquipment_Direct;
    data["rentedEquipment_Indirect"] = this.rentedEquipment_Indirect;
    data["rentedEquipment_Total"] = this.rentedEquipment_Total;
    data["misc1_Direct"] = this.misc1_Direct;
    data["misc1_Indirect"] = this.misc1_Indirect;
    data["misc1_Total"] = this.misc1_Total;
    data["misc2_Direct"] = this.misc2_Direct;
    data["misc2_Indirect"] = this.misc2_Indirect;
    data["misc2_Total"] = this.misc2_Total;
    data["misc3_Direct"] = this.misc3_Direct;
    data["misc3_Indirect"] = this.misc3_Indirect;
    data["misc3_Total"] = this.misc3_Total;
    data["totalEntryCost_Takeoff_Direct"] = this.totalEntryCost_Takeoff_Direct;
    data[
      "totalEntryCost_Takeoff_Indirect"
    ] = this.totalEntryCost_Takeoff_Indirect;
    data["totalEntryCost_Takeoff_Total"] = this.totalEntryCost_Takeoff_Total;
    data["totalEntryCost_Bid_Direct"] = this.totalEntryCost_Bid_Direct;
    data["totalEntryCost_Bid_Indirect"] = this.totalEntryCost_Bid_Indirect;
    data["totalEntryCost_Bid_Total"] = this.totalEntryCost_Bid_Total;
    data["balMarkup_Bid"] = this.balMarkup_Bid;
    data["actualMarkup_Bid"] = this.actualMarkup_Bid;
    data["balancedBid_Bid"] = this.balancedBid_Bid;
    data["bidTotal_Bid"] = this.bidTotal_Bid;
    data["addonBondTotal"] = this.addonBondTotal;
    data["totalEqp_Direct"] = this.totalEqp_Direct;
    data["totalEqp_Indirect"] = this.totalEqp_Indirect;
    data["totalEqp_Total"] = this.totalEqp_Total;
    data["manhours_Direct"] = this.manhours_Direct;
    data["manhours_Indirect"] = this.manhours_Indirect;
    data["manhours_Total"] = this.manhours_Total;
    data["addon_Cost"] = this.addon_Cost;
    data["bond"] = this.bond;
    data["addon_Markup"] = this.addon_Markup;
    data["addon_Total"] = this.addon_Total;
    data["totalCost_Takeoff"] = this.totalCost_Takeoff;
    data["job_Duration"] = this.job_Duration;
    data["balMarkup_Takeoff"] = this.balMarkup_Takeoff;
    data["actualMarkup_Takeoff"] = this.actualMarkup_Takeoff;
    data["balancedBid_Takeoff"] = this.balancedBid_Takeoff;
    data["passThrough_Cost"] = this.passThrough_Cost;
    data["passThrough_Adjustment"] = this.passThrough_Adjustment;
    data["passThrough_Total"] = this.passThrough_Total;
    data["totalCost_Bid_LessPassThrough"] = this.totalCost_Bid_LessPassThrough;
    data["totalCost_Bid"] = this.totalCost_Bid;
    data["total_User_Adjustments"] = this.total_User_Adjustments;
    data["total_User_Adjustments_Cost"] = this.total_User_Adjustments_Cost;
    data["desired_Bid"] = this.desired_Bid;
    data["desired_Bid_Diff"] = this.desired_Bid_Diff;
    data["bidTotal_Takeoff"] = this.bidTotal_Takeoff;
    data[
      "totalCost_Takeoff_LessPassThrough"
    ] = this.totalCost_Takeoff_LessPassThrough;
    data["markupPercentCost_Takeoff"] = this.markupPercentCost_Takeoff;
    data["markupPercentCost_Bid"] = this.markupPercentCost_Bid;
    data["markupPercentSales_Takeoff"] = this.markupPercentSales_Takeoff;
    data["markupPercentSales_Bid"] = this.markupPercentSales_Bid;
    data[
      "totalCost_Takeoff_LessPassThroughAndAdjustments"
    ] = this.totalCost_Takeoff_LessPassThroughAndAdjustments;
    data[
      "totalCost_Bid_LessPassThroughAndAdjustments"
    ] = this.totalCost_Bid_LessPassThroughAndAdjustments;
    data[
      "totalEntryCost_Bid_Spread_Indirect"
    ] = this.totalEntryCost_Bid_Spread_Indirect;
    data[
      "addonBond_Cost_Bid_Spread_Total"
    ] = this.addonBond_Cost_Bid_Spread_Total;
    data["totalCost_Bid_Spread"] = this.totalCost_Bid_Spread;
    data["balMarkup_Bid_Spread"] = this.balMarkup_Bid_Spread;
    data["actualMarkup_Bid_Spread"] = this.actualMarkup_Bid_Spread;
    data["actv_User_Quan1"] = this.actv_User_Quan1;
    data["actv_User_Quan2"] = this.actv_User_Quan2;
    data["actv_User_Quan3"] = this.actv_User_Quan3;
    data["actv_User_Quan4"] = this.actv_User_Quan4;
    data["open_Biditems"] = this.open_Biditems;
    data["minority_Goal_Percent"] = this.minority_Goal_Percent;
    data["minority_Goal_Total"] = this.minority_Goal_Total;
    data["minority_Current_Percent"] = this.minority_Current_Percent;
    data["minority_Current_Total"] = this.minority_Current_Total;
    return data;
  }
}

export interface IEstimateTotals {
  baseLabor_Direct: number;
  baseLabor_Indirect: number;
  baseLabor_Total: number;
  burden_Direct: number;
  burden_Indirect: number;
  burden_Total: number;
  totalLabor_Direct: number;
  totalLabor_Indirect: number;
  totalLabor_Total: number;
  permanentMaterial_Direct: number;
  permanentMaterial_Indirect: number;
  permanentMaterial_Total: number;
  constructionMaterial_Direct: number;
  constructionMaterial_Indirect: number;
  constructionMaterial_Total: number;
  subcontract_Direct: number;
  subcontract_Indirect: number;
  subcontract_Total: number;
  equipmentOperatingExpense_Direct: number;
  equipmentOperatingExpense_Indirect: number;
  equipmentOperatingExpense_Total: number;
  companyEquipment_Direct: number;
  companyEquipment_Indirect: number;
  companyEquipment_Total: number;
  rentedEquipment_Direct: number;
  rentedEquipment_Indirect: number;
  rentedEquipment_Total: number;
  misc1_Direct: number;
  misc1_Indirect: number;
  misc1_Total: number;
  misc2_Direct: number;
  misc2_Indirect: number;
  misc2_Total: number;
  misc3_Direct: number;
  misc3_Indirect: number;
  misc3_Total: number;
  totalEntryCost_Takeoff_Direct: number;
  totalEntryCost_Takeoff_Indirect: number;
  totalEntryCost_Takeoff_Total: number;
  totalEntryCost_Bid_Direct: number;
  totalEntryCost_Bid_Indirect: number;
  totalEntryCost_Bid_Total: number;
  balMarkup_Bid: number;
  actualMarkup_Bid: number;
  balancedBid_Bid: number;
  bidTotal_Bid: number;
  addonBondTotal: number;
  totalEqp_Direct: number;
  totalEqp_Indirect: number;
  totalEqp_Total: number;
  manhours_Direct: number;
  manhours_Indirect: number;
  manhours_Total: number;
  addon_Cost: number;
  bond: number;
  addon_Markup: number;
  addon_Total: number;
  totalCost_Takeoff: number;
  job_Duration: number;
  balMarkup_Takeoff: number;
  actualMarkup_Takeoff: number;
  balancedBid_Takeoff: number;
  passThrough_Cost: number;
  passThrough_Adjustment: number;
  passThrough_Total: number;
  totalCost_Bid_LessPassThrough: number;
  totalCost_Bid: number;
  total_User_Adjustments: number;
  total_User_Adjustments_Cost: number;
  desired_Bid: number;
  desired_Bid_Diff: number;
  bidTotal_Takeoff: number;
  totalCost_Takeoff_LessPassThrough: number;
  markupPercentCost_Takeoff: number;
  markupPercentCost_Bid: number;
  markupPercentSales_Takeoff: number;
  markupPercentSales_Bid: number;
  totalCost_Takeoff_LessPassThroughAndAdjustments: number;
  totalCost_Bid_LessPassThroughAndAdjustments: number;
  totalEntryCost_Bid_Spread_Indirect: number;
  addonBond_Cost_Bid_Spread_Total: number;
  totalCost_Bid_Spread: number;
  balMarkup_Bid_Spread: number;
  actualMarkup_Bid_Spread: number;
  actv_User_Quan1: number;
  actv_User_Quan2: number;
  actv_User_Quan3: number;
  actv_User_Quan4: number;
  open_Biditems: number;
  minority_Goal_Percent: number;
  minority_Goal_Total: number;
  minority_Current_Percent: number;
  minority_Current_Total: number;
}

export class ActiveEstimateBackup extends EstimateHistoryBaseTable
  implements IActiveEstimateBackup {
  estimateId!: string;
  blobUrl?: string | undefined;
  uploadedTimestamp!: Date;

  constructor(data?: IActiveEstimateBackup) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.estimateId = _data["estimateId"];
      this.blobUrl = _data["blobUrl"];
      this.uploadedTimestamp = _data["uploadedTimestamp"]
        ? new Date(_data["uploadedTimestamp"].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): ActiveEstimateBackup {
    data = typeof data === "object" ? data : {};
    let result = new ActiveEstimateBackup();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["estimateId"] = this.estimateId;
    data["blobUrl"] = this.blobUrl;
    data["uploadedTimestamp"] = this.uploadedTimestamp
      ? this.uploadedTimestamp.toISOString()
      : <any>undefined;
    super.toJSON(data);
    return data;
  }
}

export interface IActiveEstimateBackup extends IEstimateHistoryBaseTable {
  estimateId: string;
  blobUrl?: string | undefined;
  uploadedTimestamp: Date;
}

export class EstimateExcluded implements IEstimateExcluded {
  estimateId!: string;
  excluded!: boolean;

  constructor(data?: IEstimateExcluded) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.estimateId = _data["estimateId"];
      this.excluded = _data["excluded"];
    }
  }

  static fromJS(data: any): EstimateExcluded {
    data = typeof data === "object" ? data : {};
    let result = new EstimateExcluded();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["estimateId"] = this.estimateId;
    data["excluded"] = this.excluded;
    return data;
  }
}

export interface IEstimateExcluded {
  estimateId: string;
  excluded: boolean;
}

export class DeleteEstimateViewModel implements IDeleteEstimateViewModel {
  found!: boolean;
  success!: boolean;
  id!: string;
  deletionError?: string | undefined;

  constructor(data?: IDeleteEstimateViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.found = _data["found"];
      this.success = _data["success"];
      this.id = _data["id"];
      this.deletionError = _data["deletionError"];
    }
  }

  static fromJS(data: any): DeleteEstimateViewModel {
    data = typeof data === "object" ? data : {};
    let result = new DeleteEstimateViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["found"] = this.found;
    data["success"] = this.success;
    data["id"] = this.id;
    data["deletionError"] = this.deletionError;
    return data;
  }
}

export interface IDeleteEstimateViewModel {
  found: boolean;
  success: boolean;
  id: string;
  deletionError?: string | undefined;
}

export class EstimateExistViewModel implements IEstimateExistViewModel {
  code?: string | undefined;
  exist!: boolean;

  constructor(data?: IEstimateExistViewModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.exist = _data["exist"];
    }
  }

  static fromJS(data: any): EstimateExistViewModel {
    data = typeof data === "object" ? data : {};
    let result = new EstimateExistViewModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["exist"] = this.exist;
    return data;
  }
}

export interface IEstimateExistViewModel {
  code?: string | undefined;
  exist: boolean;
}

export class EstimateIndex implements IEstimateIndex {
  index!: number;

  constructor(data?: IEstimateIndex) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.index = _data["index"];
    }
  }

  static fromJS(data: any): EstimateIndex {
    data = typeof data === "object" ? data : {};
    let result = new EstimateIndex();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["index"] = this.index;
    return data;
  }
}

export interface IEstimateIndex {
  index: number;
}

export class EstimateFlattened implements IEstimateFlattened {
  id!: string;
  processedStatus!: StatusCode;
  partitionId!: string;
  lastModified!: Date;
  lastProcessed?: Date | undefined;
  code?: string | undefined;
  name?: string | undefined;
  blobUrl?: string | undefined;
  description?: string | undefined;
  estimateVersion?: string | undefined;
  businessUnitCode?: string | undefined;
  isExcludedEstimate!: boolean;
  isActiveEstimate!: boolean;
  filters_Project_Name?: string | undefined;
  filters_Project_Number?: string | undefined;
  filters_Address?: string | undefined;
  filters_Latitude?: number | undefined;
  filters_Longitude?: number | undefined;
  filters_Status?: string | undefined;
  filters_Engineer?: string | undefined;
  filters_Resp_Estimator?: string | undefined;
  filters_Owner?: string | undefined;
  filters_Bid_Date?: Date | undefined;
  filters_Start_Date?: Date | undefined;
  filters_Review_Date?: Date | undefined;
  filters_Created_Date?: Date | undefined;
  filters_Modified_Date?: Date | undefined;
  filters_Modified_Time?: number | undefined;
  filters_Bid_Amount?: number | undefined;
  filters_Takeoff_Amount?: number | undefined;
  filters_Profit_Bidquan?: number | undefined;
  filters_Profit_Takeoff?: number | undefined;
  filters_Tot_Cost?: number | undefined;
  filters_Wc_State?: string | undefined;
  filters_Type_Work?: string | undefined;
  filters_Filter_1?: string | undefined;
  filters_Filter_2?: string | undefined;
  filters_Filter_3?: string | undefined;
  filters_Filter_4?: string | undefined;
  filters_Filter_5?: string | undefined;
  filters_Filter_6?: string | undefined;
  filters_User_Ascii1?: string | undefined;
  filters_User_Ascii2?: string | undefined;
  filters_User_Ascii3?: string | undefined;
  filters_User_Ascii4?: string | undefined;
  filters_User_Ascii5?: string | undefined;
  filters_User_Ascii6?: string | undefined;
  filters_User_Ascii7?: string | undefined;
  filters_User_Ascii8?: string | undefined;
  filters_User_Ascii9?: string | undefined;
  filters_User_Ascii10?: string | undefined;
  filters_User_Ascii11?: string | undefined;
  filters_User_Ascii12?: string | undefined;
  filters_User_Ascii13?: string | undefined;
  filters_User_Ascii14?: string | undefined;
  filters_User_Ascii15?: string | undefined;
  filters_User_Ascii16?: string | undefined;
  filters_User_Ascii17?: string | undefined;
  filters_User_Ascii18?: string | undefined;
  filters_User_Ascii19?: string | undefined;
  filters_User_Ascii20?: string | undefined;
  filters_User_Vendor1?: string | undefined;
  filters_User_Vendor2?: string | undefined;
  filters_User_Vendor3?: string | undefined;
  filters_User_Vendor4?: string | undefined;
  filters_User_Vendor5?: string | undefined;
  filters_User_Vendor6?: string | undefined;
  filters_User_Flag1?: string | undefined;
  filters_User_Flag2?: string | undefined;
  filters_User_Flag3?: string | undefined;
  filters_User_Flag4?: string | undefined;
  filters_User_Flag5?: string | undefined;
  filters_User_Flag6?: string | undefined;
  filters_User_Flag7?: string | undefined;
  filters_User_Flag8?: string | undefined;
  filters_User_Flag9?: string | undefined;
  filters_User_Flag10?: string | undefined;
  filters_User_Flag11?: string | undefined;
  filters_User_Flag12?: string | undefined;
  filters_User_Code1?: string | undefined;
  filters_User_Name2?: string | undefined;
  filters_User_Integer1?: number | undefined;
  filters_User_Integer2?: number | undefined;
  filters_User_Integer3?: number | undefined;
  filters_User_Integer4?: number | undefined;
  filters_User_Integer5?: number | undefined;
  filters_User_Number1?: number | undefined;
  filters_User_Number2?: number | undefined;
  filters_User_Number3?: number | undefined;
  filters_User_Number4?: number | undefined;
  filters_User_Number5?: number | undefined;
  filters_User_Number6?: number | undefined;
  filters_User_Number7?: number | undefined;
  filters_User_Number8?: number | undefined;
  filters_User_Number9?: number | undefined;
  filters_User_Number10?: number | undefined;
  filters_User_Number11?: number | undefined;
  filters_User_Number12?: number | undefined;
  filters_User_Number13?: number | undefined;
  filters_User_Number14?: number | undefined;
  filters_User_Number15?: number | undefined;
  filters_User_Number16?: number | undefined;
  filters_User_Number17?: number | undefined;
  filters_User_Number18?: number | undefined;
  filters_User_Number19?: number | undefined;
  filters_User_Number20?: number | undefined;
  filters_User_Perc1?: number | undefined;
  filters_User_Perc2?: number | undefined;
  filters_User_Def_Date?: Date | undefined;
  filters_User_Date2?: Date | undefined;
  filters_User_Date3?: Date | undefined;
  filters_User_Date4?: Date | undefined;
  filters_User_Date5?: Date | undefined;
  filters_User_Date6?: Date | undefined;
  filters_User_Date7?: Date | undefined;
  filters_User_Date8?: Date | undefined;
  filters_User_Date9?: Date | undefined;
  filters_User_Date10?: Date | undefined;
  filters_User_Date11?: Date | undefined;
  totals_BaseLabor_Direct!: number;
  totals_BaseLabor_Indirect!: number;
  totals_BaseLabor_Total!: number;
  totals_Burden_Direct!: number;
  totals_Burden_Indirect!: number;
  totals_Burden_Total!: number;
  totals_TotalLabor_Direct!: number;
  totals_TotalLabor_Indirect!: number;
  totals_TotalLabor_Total!: number;
  totals_PermanentMaterial_Direct!: number;
  totals_PermanentMaterial_Indirect!: number;
  totals_PermanentMaterial_Total!: number;
  totals_ConstructionMaterial_Direct!: number;
  totals_ConstructionMaterial_Indirect!: number;
  totals_ConstructionMaterial_Total!: number;
  totals_Subcontract_Direct!: number;
  totals_Subcontract_Indirect!: number;
  totals_Subcontract_Total!: number;
  totals_EquipmentOperatingExpense_Direct!: number;
  totals_EquipmentOperatingExpense_Indirect!: number;
  totals_EquipmentOperatingExpense_Total!: number;
  totals_CompanyEquipment_Direct!: number;
  totals_CompanyEquipment_Indirect!: number;
  totals_CompanyEquipment_Total!: number;
  totals_RentedEquipment_Direct!: number;
  totals_RentedEquipment_Indirect!: number;
  totals_RentedEquipment_Total!: number;
  totals_Misc1_Direct!: number;
  totals_Misc1_Indirect!: number;
  totals_Misc1_Total!: number;
  totals_Misc2_Direct!: number;
  totals_Misc2_Indirect!: number;
  totals_Misc2_Total!: number;
  totals_Misc3_Direct!: number;
  totals_Misc3_Indirect!: number;
  totals_Misc3_Total!: number;
  totals_TotalEntryCost_Takeoff_Direct!: number;
  totals_TotalEntryCost_Takeoff_Indirect!: number;
  totals_TotalEntryCost_Takeoff_Total!: number;
  totals_TotalEntryCost_Bid_Direct!: number;
  totals_TotalEntryCost_Bid_Indirect!: number;
  totals_TotalEntryCost_Bid_Total!: number;
  totals_BalMarkup_Bid!: number;
  totals_ActualMarkup_Bid!: number;
  totals_BalancedBid_Bid!: number;
  totals_BidTotal_Bid!: number;
  totals_AddonBondTotal!: number;
  totals_TotalEqp_Direct!: number;
  totals_TotalEqp_Indirect!: number;
  totals_TotalEqp_Total!: number;
  totals_Manhours_Direct!: number;
  totals_Manhours_Indirect!: number;
  totals_Manhours_Total!: number;
  totals_Addon_Cost!: number;
  totals_Bond!: number;
  totals_Addon_Markup!: number;
  totals_Addon_Total!: number;
  totals_TotalCost_Takeoff!: number;
  totals_Job_Duration!: number;
  totals_BalMarkup_Takeoff!: number;
  totals_ActualMarkup_Takeoff!: number;
  totals_BalancedBid_Takeoff!: number;
  totals_PassThrough_Cost!: number;
  totals_PassThrough_Adjustment!: number;
  totals_PassThrough_Total!: number;
  totals_TotalCost_Bid_LessPassThrough!: number;
  totals_TotalCost_Bid!: number;
  totals_Total_User_Adjustments!: number;
  totals_Total_User_Adjustments_Cost!: number;
  totals_Desired_Bid!: number;
  totals_Desired_Bid_Diff!: number;
  totals_BidTotal_Takeoff!: number;
  totals_TotalCost_Takeoff_LessPassThrough!: number;
  totals_MarkupPercentCost_Takeoff!: number;
  totals_MarkupPercentCost_Bid!: number;
  totals_MarkupPercentSales_Takeoff!: number;
  totals_MarkupPercentSales_Bid!: number;
  totals_TotalCost_Takeoff_LessPassThroughAndAdjustments!: number;
  totals_TotalCost_Bid_LessPassThroughAndAdjustments!: number;
  totals_TotalEntryCost_Bid_Spread_Indirect!: number;
  totals_AddonBond_Cost_Bid_Spread_Total!: number;
  totals_TotalCost_Bid_Spread!: number;
  totals_BalMarkup_Bid_Spread!: number;
  totals_ActualMarkup_Bid_Spread!: number;
  totals_Actv_User_Quan1!: number;
  totals_Actv_User_Quan2!: number;
  totals_Actv_User_Quan3!: number;
  totals_Actv_User_Quan4!: number;
  totals_Open_Biditems!: number;
  totals_Minority_Goal_Percent!: number;
  totals_Minority_Goal_Total!: number;
  totals_Minority_Current_Percent!: number;
  totals_Minority_Current_Total!: number;
  empId?: string | undefined;

  constructor(data?: IEstimateFlattened) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.processedStatus = _data["processedStatus"];
      this.partitionId = _data["partitionId"];
      this.lastModified = _data["lastModified"]
        ? new Date(_data["lastModified"].toString())
        : <any>undefined;
      this.lastProcessed = _data["lastProcessed"]
        ? new Date(_data["lastProcessed"].toString())
        : <any>undefined;
      this.code = _data["code"];
      this.name = _data["name"];
      this.blobUrl = _data["blobUrl"];
      this.description = _data["description"];
      this.estimateVersion = _data["estimateVersion"];
      this.businessUnitCode = _data["businessUnitCode"];
      this.isExcludedEstimate = _data["isExcludedEstimate"];
      this.isActiveEstimate = _data["isActiveEstimate"];
      this.filters_Project_Name = _data["filters_Project_Name"];
      this.filters_Project_Number = _data["filters_Project_Number"];
      this.filters_Address = _data["filters_Address"];
      this.filters_Latitude = _data["filters_Latitude"];
      this.filters_Longitude = _data["filters_Longitude"];
      this.filters_Status = _data["filters_Status"];
      this.filters_Engineer = _data["filters_Engineer"];
      this.filters_Resp_Estimator = _data["filters_Resp_Estimator"];
      this.filters_Owner = _data["filters_Owner"];
      this.filters_Bid_Date = _data["filters_Bid_Date"]
        ? new Date(_data["filters_Bid_Date"].toString())
        : <any>undefined;
      this.filters_Start_Date = _data["filters_Start_Date"]
        ? new Date(_data["filters_Start_Date"].toString())
        : <any>undefined;
      this.filters_Review_Date = _data["filters_Review_Date"]
        ? new Date(_data["filters_Review_Date"].toString())
        : <any>undefined;
      this.filters_Created_Date = _data["filters_Created_Date"]
        ? new Date(_data["filters_Created_Date"].toString())
        : <any>undefined;
      this.filters_Modified_Date = _data["filters_Modified_Date"]
        ? new Date(_data["filters_Modified_Date"].toString())
        : <any>undefined;
      this.filters_Modified_Time = _data["filters_Modified_Time"];
      this.filters_Bid_Amount = _data["filters_Bid_Amount"];
      this.filters_Takeoff_Amount = _data["filters_Takeoff_Amount"];
      this.filters_Profit_Bidquan = _data["filters_Profit_Bidquan"];
      this.filters_Profit_Takeoff = _data["filters_Profit_Takeoff"];
      this.filters_Tot_Cost = _data["filters_Tot_Cost"];
      this.filters_Wc_State = _data["filters_Wc_State"];
      this.filters_Type_Work = _data["filters_Type_Work"];
      this.filters_Filter_1 = _data["filters_Filter_1"];
      this.filters_Filter_2 = _data["filters_Filter_2"];
      this.filters_Filter_3 = _data["filters_Filter_3"];
      this.filters_Filter_4 = _data["filters_Filter_4"];
      this.filters_Filter_5 = _data["filters_Filter_5"];
      this.filters_Filter_6 = _data["filters_Filter_6"];
      this.filters_User_Ascii1 = _data["filters_User_Ascii1"];
      this.filters_User_Ascii2 = _data["filters_User_Ascii2"];
      this.filters_User_Ascii3 = _data["filters_User_Ascii3"];
      this.filters_User_Ascii4 = _data["filters_User_Ascii4"];
      this.filters_User_Ascii5 = _data["filters_User_Ascii5"];
      this.filters_User_Ascii6 = _data["filters_User_Ascii6"];
      this.filters_User_Ascii7 = _data["filters_User_Ascii7"];
      this.filters_User_Ascii8 = _data["filters_User_Ascii8"];
      this.filters_User_Ascii9 = _data["filters_User_Ascii9"];
      this.filters_User_Ascii10 = _data["filters_User_Ascii10"];
      this.filters_User_Ascii11 = _data["filters_User_Ascii11"];
      this.filters_User_Ascii12 = _data["filters_User_Ascii12"];
      this.filters_User_Ascii13 = _data["filters_User_Ascii13"];
      this.filters_User_Ascii14 = _data["filters_User_Ascii14"];
      this.filters_User_Ascii15 = _data["filters_User_Ascii15"];
      this.filters_User_Ascii16 = _data["filters_User_Ascii16"];
      this.filters_User_Ascii17 = _data["filters_User_Ascii17"];
      this.filters_User_Ascii18 = _data["filters_User_Ascii18"];
      this.filters_User_Ascii19 = _data["filters_User_Ascii19"];
      this.filters_User_Ascii20 = _data["filters_User_Ascii20"];
      this.filters_User_Vendor1 = _data["filters_User_Vendor1"];
      this.filters_User_Vendor2 = _data["filters_User_Vendor2"];
      this.filters_User_Vendor3 = _data["filters_User_Vendor3"];
      this.filters_User_Vendor4 = _data["filters_User_Vendor4"];
      this.filters_User_Vendor5 = _data["filters_User_Vendor5"];
      this.filters_User_Vendor6 = _data["filters_User_Vendor6"];
      this.filters_User_Flag1 = _data["filters_User_Flag1"];
      this.filters_User_Flag2 = _data["filters_User_Flag2"];
      this.filters_User_Flag3 = _data["filters_User_Flag3"];
      this.filters_User_Flag4 = _data["filters_User_Flag4"];
      this.filters_User_Flag5 = _data["filters_User_Flag5"];
      this.filters_User_Flag6 = _data["filters_User_Flag6"];
      this.filters_User_Flag7 = _data["filters_User_Flag7"];
      this.filters_User_Flag8 = _data["filters_User_Flag8"];
      this.filters_User_Flag9 = _data["filters_User_Flag9"];
      this.filters_User_Flag10 = _data["filters_User_Flag10"];
      this.filters_User_Flag11 = _data["filters_User_Flag11"];
      this.filters_User_Flag12 = _data["filters_User_Flag12"];
      this.filters_User_Code1 = _data["filters_User_Code1"];
      this.filters_User_Name2 = _data["filters_User_Name2"];
      this.filters_User_Integer1 = _data["filters_User_Integer1"];
      this.filters_User_Integer2 = _data["filters_User_Integer2"];
      this.filters_User_Integer3 = _data["filters_User_Integer3"];
      this.filters_User_Integer4 = _data["filters_User_Integer4"];
      this.filters_User_Integer5 = _data["filters_User_Integer5"];
      this.filters_User_Number1 = _data["filters_User_Number1"];
      this.filters_User_Number2 = _data["filters_User_Number2"];
      this.filters_User_Number3 = _data["filters_User_Number3"];
      this.filters_User_Number4 = _data["filters_User_Number4"];
      this.filters_User_Number5 = _data["filters_User_Number5"];
      this.filters_User_Number6 = _data["filters_User_Number6"];
      this.filters_User_Number7 = _data["filters_User_Number7"];
      this.filters_User_Number8 = _data["filters_User_Number8"];
      this.filters_User_Number9 = _data["filters_User_Number9"];
      this.filters_User_Number10 = _data["filters_User_Number10"];
      this.filters_User_Number11 = _data["filters_User_Number11"];
      this.filters_User_Number12 = _data["filters_User_Number12"];
      this.filters_User_Number13 = _data["filters_User_Number13"];
      this.filters_User_Number14 = _data["filters_User_Number14"];
      this.filters_User_Number15 = _data["filters_User_Number15"];
      this.filters_User_Number16 = _data["filters_User_Number16"];
      this.filters_User_Number17 = _data["filters_User_Number17"];
      this.filters_User_Number18 = _data["filters_User_Number18"];
      this.filters_User_Number19 = _data["filters_User_Number19"];
      this.filters_User_Number20 = _data["filters_User_Number20"];
      this.filters_User_Perc1 = _data["filters_User_Perc1"];
      this.filters_User_Perc2 = _data["filters_User_Perc2"];
      this.filters_User_Def_Date = _data["filters_User_Def_Date"]
        ? new Date(_data["filters_User_Def_Date"].toString())
        : <any>undefined;
      this.filters_User_Date2 = _data["filters_User_Date2"]
        ? new Date(_data["filters_User_Date2"].toString())
        : <any>undefined;
      this.filters_User_Date3 = _data["filters_User_Date3"]
        ? new Date(_data["filters_User_Date3"].toString())
        : <any>undefined;
      this.filters_User_Date4 = _data["filters_User_Date4"]
        ? new Date(_data["filters_User_Date4"].toString())
        : <any>undefined;
      this.filters_User_Date5 = _data["filters_User_Date5"]
        ? new Date(_data["filters_User_Date5"].toString())
        : <any>undefined;
      this.filters_User_Date6 = _data["filters_User_Date6"]
        ? new Date(_data["filters_User_Date6"].toString())
        : <any>undefined;
      this.filters_User_Date7 = _data["filters_User_Date7"]
        ? new Date(_data["filters_User_Date7"].toString())
        : <any>undefined;
      this.filters_User_Date8 = _data["filters_User_Date8"]
        ? new Date(_data["filters_User_Date8"].toString())
        : <any>undefined;
      this.filters_User_Date9 = _data["filters_User_Date9"]
        ? new Date(_data["filters_User_Date9"].toString())
        : <any>undefined;
      this.filters_User_Date10 = _data["filters_User_Date10"]
        ? new Date(_data["filters_User_Date10"].toString())
        : <any>undefined;
      this.filters_User_Date11 = _data["filters_User_Date11"]
        ? new Date(_data["filters_User_Date11"].toString())
        : <any>undefined;
      this.totals_BaseLabor_Direct = _data["totals_BaseLabor_Direct"];
      this.totals_BaseLabor_Indirect = _data["totals_BaseLabor_Indirect"];
      this.totals_BaseLabor_Total = _data["totals_BaseLabor_Total"];
      this.totals_Burden_Direct = _data["totals_Burden_Direct"];
      this.totals_Burden_Indirect = _data["totals_Burden_Indirect"];
      this.totals_Burden_Total = _data["totals_Burden_Total"];
      this.totals_TotalLabor_Direct = _data["totals_TotalLabor_Direct"];
      this.totals_TotalLabor_Indirect = _data["totals_TotalLabor_Indirect"];
      this.totals_TotalLabor_Total = _data["totals_TotalLabor_Total"];
      this.totals_PermanentMaterial_Direct =
        _data["totals_PermanentMaterial_Direct"];
      this.totals_PermanentMaterial_Indirect =
        _data["totals_PermanentMaterial_Indirect"];
      this.totals_PermanentMaterial_Total =
        _data["totals_PermanentMaterial_Total"];
      this.totals_ConstructionMaterial_Direct =
        _data["totals_ConstructionMaterial_Direct"];
      this.totals_ConstructionMaterial_Indirect =
        _data["totals_ConstructionMaterial_Indirect"];
      this.totals_ConstructionMaterial_Total =
        _data["totals_ConstructionMaterial_Total"];
      this.totals_Subcontract_Direct = _data["totals_Subcontract_Direct"];
      this.totals_Subcontract_Indirect = _data["totals_Subcontract_Indirect"];
      this.totals_Subcontract_Total = _data["totals_Subcontract_Total"];
      this.totals_EquipmentOperatingExpense_Direct =
        _data["totals_EquipmentOperatingExpense_Direct"];
      this.totals_EquipmentOperatingExpense_Indirect =
        _data["totals_EquipmentOperatingExpense_Indirect"];
      this.totals_EquipmentOperatingExpense_Total =
        _data["totals_EquipmentOperatingExpense_Total"];
      this.totals_CompanyEquipment_Direct =
        _data["totals_CompanyEquipment_Direct"];
      this.totals_CompanyEquipment_Indirect =
        _data["totals_CompanyEquipment_Indirect"];
      this.totals_CompanyEquipment_Total =
        _data["totals_CompanyEquipment_Total"];
      this.totals_RentedEquipment_Direct =
        _data["totals_RentedEquipment_Direct"];
      this.totals_RentedEquipment_Indirect =
        _data["totals_RentedEquipment_Indirect"];
      this.totals_RentedEquipment_Total = _data["totals_RentedEquipment_Total"];
      this.totals_Misc1_Direct = _data["totals_Misc1_Direct"];
      this.totals_Misc1_Indirect = _data["totals_Misc1_Indirect"];
      this.totals_Misc1_Total = _data["totals_Misc1_Total"];
      this.totals_Misc2_Direct = _data["totals_Misc2_Direct"];
      this.totals_Misc2_Indirect = _data["totals_Misc2_Indirect"];
      this.totals_Misc2_Total = _data["totals_Misc2_Total"];
      this.totals_Misc3_Direct = _data["totals_Misc3_Direct"];
      this.totals_Misc3_Indirect = _data["totals_Misc3_Indirect"];
      this.totals_Misc3_Total = _data["totals_Misc3_Total"];
      this.totals_TotalEntryCost_Takeoff_Direct =
        _data["totals_TotalEntryCost_Takeoff_Direct"];
      this.totals_TotalEntryCost_Takeoff_Indirect =
        _data["totals_TotalEntryCost_Takeoff_Indirect"];
      this.totals_TotalEntryCost_Takeoff_Total =
        _data["totals_TotalEntryCost_Takeoff_Total"];
      this.totals_TotalEntryCost_Bid_Direct =
        _data["totals_TotalEntryCost_Bid_Direct"];
      this.totals_TotalEntryCost_Bid_Indirect =
        _data["totals_TotalEntryCost_Bid_Indirect"];
      this.totals_TotalEntryCost_Bid_Total =
        _data["totals_TotalEntryCost_Bid_Total"];
      this.totals_BalMarkup_Bid = _data["totals_BalMarkup_Bid"];
      this.totals_ActualMarkup_Bid = _data["totals_ActualMarkup_Bid"];
      this.totals_BalancedBid_Bid = _data["totals_BalancedBid_Bid"];
      this.totals_BidTotal_Bid = _data["totals_BidTotal_Bid"];
      this.totals_AddonBondTotal = _data["totals_AddonBondTotal"];
      this.totals_TotalEqp_Direct = _data["totals_TotalEqp_Direct"];
      this.totals_TotalEqp_Indirect = _data["totals_TotalEqp_Indirect"];
      this.totals_TotalEqp_Total = _data["totals_TotalEqp_Total"];
      this.totals_Manhours_Direct = _data["totals_Manhours_Direct"];
      this.totals_Manhours_Indirect = _data["totals_Manhours_Indirect"];
      this.totals_Manhours_Total = _data["totals_Manhours_Total"];
      this.totals_Addon_Cost = _data["totals_Addon_Cost"];
      this.totals_Bond = _data["totals_Bond"];
      this.totals_Addon_Markup = _data["totals_Addon_Markup"];
      this.totals_Addon_Total = _data["totals_Addon_Total"];
      this.totals_TotalCost_Takeoff = _data["totals_TotalCost_Takeoff"];
      this.totals_Job_Duration = _data["totals_Job_Duration"];
      this.totals_BalMarkup_Takeoff = _data["totals_BalMarkup_Takeoff"];
      this.totals_ActualMarkup_Takeoff = _data["totals_ActualMarkup_Takeoff"];
      this.totals_BalancedBid_Takeoff = _data["totals_BalancedBid_Takeoff"];
      this.totals_PassThrough_Cost = _data["totals_PassThrough_Cost"];
      this.totals_PassThrough_Adjustment =
        _data["totals_PassThrough_Adjustment"];
      this.totals_PassThrough_Total = _data["totals_PassThrough_Total"];
      this.totals_TotalCost_Bid_LessPassThrough =
        _data["totals_TotalCost_Bid_LessPassThrough"];
      this.totals_TotalCost_Bid = _data["totals_TotalCost_Bid"];
      this.totals_Total_User_Adjustments =
        _data["totals_Total_User_Adjustments"];
      this.totals_Total_User_Adjustments_Cost =
        _data["totals_Total_User_Adjustments_Cost"];
      this.totals_Desired_Bid = _data["totals_Desired_Bid"];
      this.totals_Desired_Bid_Diff = _data["totals_Desired_Bid_Diff"];
      this.totals_BidTotal_Takeoff = _data["totals_BidTotal_Takeoff"];
      this.totals_TotalCost_Takeoff_LessPassThrough =
        _data["totals_TotalCost_Takeoff_LessPassThrough"];
      this.totals_MarkupPercentCost_Takeoff =
        _data["totals_MarkupPercentCost_Takeoff"];
      this.totals_MarkupPercentCost_Bid = _data["totals_MarkupPercentCost_Bid"];
      this.totals_MarkupPercentSales_Takeoff =
        _data["totals_MarkupPercentSales_Takeoff"];
      this.totals_MarkupPercentSales_Bid =
        _data["totals_MarkupPercentSales_Bid"];
      this.totals_TotalCost_Takeoff_LessPassThroughAndAdjustments =
        _data["totals_TotalCost_Takeoff_LessPassThroughAndAdjustments"];
      this.totals_TotalCost_Bid_LessPassThroughAndAdjustments =
        _data["totals_TotalCost_Bid_LessPassThroughAndAdjustments"];
      this.totals_TotalEntryCost_Bid_Spread_Indirect =
        _data["totals_TotalEntryCost_Bid_Spread_Indirect"];
      this.totals_AddonBond_Cost_Bid_Spread_Total =
        _data["totals_AddonBond_Cost_Bid_Spread_Total"];
      this.totals_TotalCost_Bid_Spread = _data["totals_TotalCost_Bid_Spread"];
      this.totals_BalMarkup_Bid_Spread = _data["totals_BalMarkup_Bid_Spread"];
      this.totals_ActualMarkup_Bid_Spread =
        _data["totals_ActualMarkup_Bid_Spread"];
      this.totals_Actv_User_Quan1 = _data["totals_Actv_User_Quan1"];
      this.totals_Actv_User_Quan2 = _data["totals_Actv_User_Quan2"];
      this.totals_Actv_User_Quan3 = _data["totals_Actv_User_Quan3"];
      this.totals_Actv_User_Quan4 = _data["totals_Actv_User_Quan4"];
      this.totals_Open_Biditems = _data["totals_Open_Biditems"];
      this.totals_Minority_Goal_Percent = _data["totals_Minority_Goal_Percent"];
      this.totals_Minority_Goal_Total = _data["totals_Minority_Goal_Total"];
      this.totals_Minority_Current_Percent =
        _data["totals_Minority_Current_Percent"];
      this.totals_Minority_Current_Total =
        _data["totals_Minority_Current_Total"];
      this.empId = _data["empId"];
    }
  }

  static fromJS(data: any): EstimateFlattened {
    data = typeof data === "object" ? data : {};
    let result = new EstimateFlattened();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["processedStatus"] = this.processedStatus;
    data["partitionId"] = this.partitionId;
    data["lastModified"] = this.lastModified
      ? this.lastModified.toISOString()
      : <any>undefined;
    data["lastProcessed"] = this.lastProcessed
      ? this.lastProcessed.toISOString()
      : <any>undefined;
    data["code"] = this.code;
    data["name"] = this.name;
    data["blobUrl"] = this.blobUrl;
    data["description"] = this.description;
    data["estimateVersion"] = this.estimateVersion;
    data["businessUnitCode"] = this.businessUnitCode;
    data["isExcludedEstimate"] = this.isExcludedEstimate;
    data["isActiveEstimate"] = this.isActiveEstimate;
    data["filters_Project_Name"] = this.filters_Project_Name;
    data["filters_Project_Number"] = this.filters_Project_Number;
    data["filters_Address"] = this.filters_Address;
    data["filters_Latitude"] = this.filters_Latitude;
    data["filters_Longitude"] = this.filters_Longitude;
    data["filters_Status"] = this.filters_Status;
    data["filters_Engineer"] = this.filters_Engineer;
    data["filters_Resp_Estimator"] = this.filters_Resp_Estimator;
    data["filters_Owner"] = this.filters_Owner;
    data["filters_Bid_Date"] = this.filters_Bid_Date
      ? this.filters_Bid_Date.toISOString()
      : <any>undefined;
    data["filters_Start_Date"] = this.filters_Start_Date
      ? this.filters_Start_Date.toISOString()
      : <any>undefined;
    data["filters_Review_Date"] = this.filters_Review_Date
      ? this.filters_Review_Date.toISOString()
      : <any>undefined;
    data["filters_Created_Date"] = this.filters_Created_Date
      ? this.filters_Created_Date.toISOString()
      : <any>undefined;
    data["filters_Modified_Date"] = this.filters_Modified_Date
      ? this.filters_Modified_Date.toISOString()
      : <any>undefined;
    data["filters_Modified_Time"] = this.filters_Modified_Time;
    data["filters_Bid_Amount"] = this.filters_Bid_Amount;
    data["filters_Takeoff_Amount"] = this.filters_Takeoff_Amount;
    data["filters_Profit_Bidquan"] = this.filters_Profit_Bidquan;
    data["filters_Profit_Takeoff"] = this.filters_Profit_Takeoff;
    data["filters_Tot_Cost"] = this.filters_Tot_Cost;
    data["filters_Wc_State"] = this.filters_Wc_State;
    data["filters_Type_Work"] = this.filters_Type_Work;
    data["filters_Filter_1"] = this.filters_Filter_1;
    data["filters_Filter_2"] = this.filters_Filter_2;
    data["filters_Filter_3"] = this.filters_Filter_3;
    data["filters_Filter_4"] = this.filters_Filter_4;
    data["filters_Filter_5"] = this.filters_Filter_5;
    data["filters_Filter_6"] = this.filters_Filter_6;
    data["filters_User_Ascii1"] = this.filters_User_Ascii1;
    data["filters_User_Ascii2"] = this.filters_User_Ascii2;
    data["filters_User_Ascii3"] = this.filters_User_Ascii3;
    data["filters_User_Ascii4"] = this.filters_User_Ascii4;
    data["filters_User_Ascii5"] = this.filters_User_Ascii5;
    data["filters_User_Ascii6"] = this.filters_User_Ascii6;
    data["filters_User_Ascii7"] = this.filters_User_Ascii7;
    data["filters_User_Ascii8"] = this.filters_User_Ascii8;
    data["filters_User_Ascii9"] = this.filters_User_Ascii9;
    data["filters_User_Ascii10"] = this.filters_User_Ascii10;
    data["filters_User_Ascii11"] = this.filters_User_Ascii11;
    data["filters_User_Ascii12"] = this.filters_User_Ascii12;
    data["filters_User_Ascii13"] = this.filters_User_Ascii13;
    data["filters_User_Ascii14"] = this.filters_User_Ascii14;
    data["filters_User_Ascii15"] = this.filters_User_Ascii15;
    data["filters_User_Ascii16"] = this.filters_User_Ascii16;
    data["filters_User_Ascii17"] = this.filters_User_Ascii17;
    data["filters_User_Ascii18"] = this.filters_User_Ascii18;
    data["filters_User_Ascii19"] = this.filters_User_Ascii19;
    data["filters_User_Ascii20"] = this.filters_User_Ascii20;
    data["filters_User_Vendor1"] = this.filters_User_Vendor1;
    data["filters_User_Vendor2"] = this.filters_User_Vendor2;
    data["filters_User_Vendor3"] = this.filters_User_Vendor3;
    data["filters_User_Vendor4"] = this.filters_User_Vendor4;
    data["filters_User_Vendor5"] = this.filters_User_Vendor5;
    data["filters_User_Vendor6"] = this.filters_User_Vendor6;
    data["filters_User_Flag1"] = this.filters_User_Flag1;
    data["filters_User_Flag2"] = this.filters_User_Flag2;
    data["filters_User_Flag3"] = this.filters_User_Flag3;
    data["filters_User_Flag4"] = this.filters_User_Flag4;
    data["filters_User_Flag5"] = this.filters_User_Flag5;
    data["filters_User_Flag6"] = this.filters_User_Flag6;
    data["filters_User_Flag7"] = this.filters_User_Flag7;
    data["filters_User_Flag8"] = this.filters_User_Flag8;
    data["filters_User_Flag9"] = this.filters_User_Flag9;
    data["filters_User_Flag10"] = this.filters_User_Flag10;
    data["filters_User_Flag11"] = this.filters_User_Flag11;
    data["filters_User_Flag12"] = this.filters_User_Flag12;
    data["filters_User_Code1"] = this.filters_User_Code1;
    data["filters_User_Name2"] = this.filters_User_Name2;
    data["filters_User_Integer1"] = this.filters_User_Integer1;
    data["filters_User_Integer2"] = this.filters_User_Integer2;
    data["filters_User_Integer3"] = this.filters_User_Integer3;
    data["filters_User_Integer4"] = this.filters_User_Integer4;
    data["filters_User_Integer5"] = this.filters_User_Integer5;
    data["filters_User_Number1"] = this.filters_User_Number1;
    data["filters_User_Number2"] = this.filters_User_Number2;
    data["filters_User_Number3"] = this.filters_User_Number3;
    data["filters_User_Number4"] = this.filters_User_Number4;
    data["filters_User_Number5"] = this.filters_User_Number5;
    data["filters_User_Number6"] = this.filters_User_Number6;
    data["filters_User_Number7"] = this.filters_User_Number7;
    data["filters_User_Number8"] = this.filters_User_Number8;
    data["filters_User_Number9"] = this.filters_User_Number9;
    data["filters_User_Number10"] = this.filters_User_Number10;
    data["filters_User_Number11"] = this.filters_User_Number11;
    data["filters_User_Number12"] = this.filters_User_Number12;
    data["filters_User_Number13"] = this.filters_User_Number13;
    data["filters_User_Number14"] = this.filters_User_Number14;
    data["filters_User_Number15"] = this.filters_User_Number15;
    data["filters_User_Number16"] = this.filters_User_Number16;
    data["filters_User_Number17"] = this.filters_User_Number17;
    data["filters_User_Number18"] = this.filters_User_Number18;
    data["filters_User_Number19"] = this.filters_User_Number19;
    data["filters_User_Number20"] = this.filters_User_Number20;
    data["filters_User_Perc1"] = this.filters_User_Perc1;
    data["filters_User_Perc2"] = this.filters_User_Perc2;
    data["filters_User_Def_Date"] = this.filters_User_Def_Date
      ? this.filters_User_Def_Date.toISOString()
      : <any>undefined;
    data["filters_User_Date2"] = this.filters_User_Date2
      ? this.filters_User_Date2.toISOString()
      : <any>undefined;
    data["filters_User_Date3"] = this.filters_User_Date3
      ? this.filters_User_Date3.toISOString()
      : <any>undefined;
    data["filters_User_Date4"] = this.filters_User_Date4
      ? this.filters_User_Date4.toISOString()
      : <any>undefined;
    data["filters_User_Date5"] = this.filters_User_Date5
      ? this.filters_User_Date5.toISOString()
      : <any>undefined;
    data["filters_User_Date6"] = this.filters_User_Date6
      ? this.filters_User_Date6.toISOString()
      : <any>undefined;
    data["filters_User_Date7"] = this.filters_User_Date7
      ? this.filters_User_Date7.toISOString()
      : <any>undefined;
    data["filters_User_Date8"] = this.filters_User_Date8
      ? this.filters_User_Date8.toISOString()
      : <any>undefined;
    data["filters_User_Date9"] = this.filters_User_Date9
      ? this.filters_User_Date9.toISOString()
      : <any>undefined;
    data["filters_User_Date10"] = this.filters_User_Date10
      ? this.filters_User_Date10.toISOString()
      : <any>undefined;
    data["filters_User_Date11"] = this.filters_User_Date11
      ? this.filters_User_Date11.toISOString()
      : <any>undefined;
    data["totals_BaseLabor_Direct"] = this.totals_BaseLabor_Direct;
    data["totals_BaseLabor_Indirect"] = this.totals_BaseLabor_Indirect;
    data["totals_BaseLabor_Total"] = this.totals_BaseLabor_Total;
    data["totals_Burden_Direct"] = this.totals_Burden_Direct;
    data["totals_Burden_Indirect"] = this.totals_Burden_Indirect;
    data["totals_Burden_Total"] = this.totals_Burden_Total;
    data["totals_TotalLabor_Direct"] = this.totals_TotalLabor_Direct;
    data["totals_TotalLabor_Indirect"] = this.totals_TotalLabor_Indirect;
    data["totals_TotalLabor_Total"] = this.totals_TotalLabor_Total;
    data[
      "totals_PermanentMaterial_Direct"
    ] = this.totals_PermanentMaterial_Direct;
    data[
      "totals_PermanentMaterial_Indirect"
    ] = this.totals_PermanentMaterial_Indirect;
    data[
      "totals_PermanentMaterial_Total"
    ] = this.totals_PermanentMaterial_Total;
    data[
      "totals_ConstructionMaterial_Direct"
    ] = this.totals_ConstructionMaterial_Direct;
    data[
      "totals_ConstructionMaterial_Indirect"
    ] = this.totals_ConstructionMaterial_Indirect;
    data[
      "totals_ConstructionMaterial_Total"
    ] = this.totals_ConstructionMaterial_Total;
    data["totals_Subcontract_Direct"] = this.totals_Subcontract_Direct;
    data["totals_Subcontract_Indirect"] = this.totals_Subcontract_Indirect;
    data["totals_Subcontract_Total"] = this.totals_Subcontract_Total;
    data[
      "totals_EquipmentOperatingExpense_Direct"
    ] = this.totals_EquipmentOperatingExpense_Direct;
    data[
      "totals_EquipmentOperatingExpense_Indirect"
    ] = this.totals_EquipmentOperatingExpense_Indirect;
    data[
      "totals_EquipmentOperatingExpense_Total"
    ] = this.totals_EquipmentOperatingExpense_Total;
    data[
      "totals_CompanyEquipment_Direct"
    ] = this.totals_CompanyEquipment_Direct;
    data[
      "totals_CompanyEquipment_Indirect"
    ] = this.totals_CompanyEquipment_Indirect;
    data["totals_CompanyEquipment_Total"] = this.totals_CompanyEquipment_Total;
    data["totals_RentedEquipment_Direct"] = this.totals_RentedEquipment_Direct;
    data[
      "totals_RentedEquipment_Indirect"
    ] = this.totals_RentedEquipment_Indirect;
    data["totals_RentedEquipment_Total"] = this.totals_RentedEquipment_Total;
    data["totals_Misc1_Direct"] = this.totals_Misc1_Direct;
    data["totals_Misc1_Indirect"] = this.totals_Misc1_Indirect;
    data["totals_Misc1_Total"] = this.totals_Misc1_Total;
    data["totals_Misc2_Direct"] = this.totals_Misc2_Direct;
    data["totals_Misc2_Indirect"] = this.totals_Misc2_Indirect;
    data["totals_Misc2_Total"] = this.totals_Misc2_Total;
    data["totals_Misc3_Direct"] = this.totals_Misc3_Direct;
    data["totals_Misc3_Indirect"] = this.totals_Misc3_Indirect;
    data["totals_Misc3_Total"] = this.totals_Misc3_Total;
    data[
      "totals_TotalEntryCost_Takeoff_Direct"
    ] = this.totals_TotalEntryCost_Takeoff_Direct;
    data[
      "totals_TotalEntryCost_Takeoff_Indirect"
    ] = this.totals_TotalEntryCost_Takeoff_Indirect;
    data[
      "totals_TotalEntryCost_Takeoff_Total"
    ] = this.totals_TotalEntryCost_Takeoff_Total;
    data[
      "totals_TotalEntryCost_Bid_Direct"
    ] = this.totals_TotalEntryCost_Bid_Direct;
    data[
      "totals_TotalEntryCost_Bid_Indirect"
    ] = this.totals_TotalEntryCost_Bid_Indirect;
    data[
      "totals_TotalEntryCost_Bid_Total"
    ] = this.totals_TotalEntryCost_Bid_Total;
    data["totals_BalMarkup_Bid"] = this.totals_BalMarkup_Bid;
    data["totals_ActualMarkup_Bid"] = this.totals_ActualMarkup_Bid;
    data["totals_BalancedBid_Bid"] = this.totals_BalancedBid_Bid;
    data["totals_BidTotal_Bid"] = this.totals_BidTotal_Bid;
    data["totals_AddonBondTotal"] = this.totals_AddonBondTotal;
    data["totals_TotalEqp_Direct"] = this.totals_TotalEqp_Direct;
    data["totals_TotalEqp_Indirect"] = this.totals_TotalEqp_Indirect;
    data["totals_TotalEqp_Total"] = this.totals_TotalEqp_Total;
    data["totals_Manhours_Direct"] = this.totals_Manhours_Direct;
    data["totals_Manhours_Indirect"] = this.totals_Manhours_Indirect;
    data["totals_Manhours_Total"] = this.totals_Manhours_Total;
    data["totals_Addon_Cost"] = this.totals_Addon_Cost;
    data["totals_Bond"] = this.totals_Bond;
    data["totals_Addon_Markup"] = this.totals_Addon_Markup;
    data["totals_Addon_Total"] = this.totals_Addon_Total;
    data["totals_TotalCost_Takeoff"] = this.totals_TotalCost_Takeoff;
    data["totals_Job_Duration"] = this.totals_Job_Duration;
    data["totals_BalMarkup_Takeoff"] = this.totals_BalMarkup_Takeoff;
    data["totals_ActualMarkup_Takeoff"] = this.totals_ActualMarkup_Takeoff;
    data["totals_BalancedBid_Takeoff"] = this.totals_BalancedBid_Takeoff;
    data["totals_PassThrough_Cost"] = this.totals_PassThrough_Cost;
    data["totals_PassThrough_Adjustment"] = this.totals_PassThrough_Adjustment;
    data["totals_PassThrough_Total"] = this.totals_PassThrough_Total;
    data[
      "totals_TotalCost_Bid_LessPassThrough"
    ] = this.totals_TotalCost_Bid_LessPassThrough;
    data["totals_TotalCost_Bid"] = this.totals_TotalCost_Bid;
    data["totals_Total_User_Adjustments"] = this.totals_Total_User_Adjustments;
    data[
      "totals_Total_User_Adjustments_Cost"
    ] = this.totals_Total_User_Adjustments_Cost;
    data["totals_Desired_Bid"] = this.totals_Desired_Bid;
    data["totals_Desired_Bid_Diff"] = this.totals_Desired_Bid_Diff;
    data["totals_BidTotal_Takeoff"] = this.totals_BidTotal_Takeoff;
    data[
      "totals_TotalCost_Takeoff_LessPassThrough"
    ] = this.totals_TotalCost_Takeoff_LessPassThrough;
    data[
      "totals_MarkupPercentCost_Takeoff"
    ] = this.totals_MarkupPercentCost_Takeoff;
    data["totals_MarkupPercentCost_Bid"] = this.totals_MarkupPercentCost_Bid;
    data[
      "totals_MarkupPercentSales_Takeoff"
    ] = this.totals_MarkupPercentSales_Takeoff;
    data["totals_MarkupPercentSales_Bid"] = this.totals_MarkupPercentSales_Bid;
    data[
      "totals_TotalCost_Takeoff_LessPassThroughAndAdjustments"
    ] = this.totals_TotalCost_Takeoff_LessPassThroughAndAdjustments;
    data[
      "totals_TotalCost_Bid_LessPassThroughAndAdjustments"
    ] = this.totals_TotalCost_Bid_LessPassThroughAndAdjustments;
    data[
      "totals_TotalEntryCost_Bid_Spread_Indirect"
    ] = this.totals_TotalEntryCost_Bid_Spread_Indirect;
    data[
      "totals_AddonBond_Cost_Bid_Spread_Total"
    ] = this.totals_AddonBond_Cost_Bid_Spread_Total;
    data["totals_TotalCost_Bid_Spread"] = this.totals_TotalCost_Bid_Spread;
    data["totals_BalMarkup_Bid_Spread"] = this.totals_BalMarkup_Bid_Spread;
    data[
      "totals_ActualMarkup_Bid_Spread"
    ] = this.totals_ActualMarkup_Bid_Spread;
    data["totals_Actv_User_Quan1"] = this.totals_Actv_User_Quan1;
    data["totals_Actv_User_Quan2"] = this.totals_Actv_User_Quan2;
    data["totals_Actv_User_Quan3"] = this.totals_Actv_User_Quan3;
    data["totals_Actv_User_Quan4"] = this.totals_Actv_User_Quan4;
    data["totals_Open_Biditems"] = this.totals_Open_Biditems;
    data["totals_Minority_Goal_Percent"] = this.totals_Minority_Goal_Percent;
    data["totals_Minority_Goal_Total"] = this.totals_Minority_Goal_Total;
    data[
      "totals_Minority_Current_Percent"
    ] = this.totals_Minority_Current_Percent;
    data["totals_Minority_Current_Total"] = this.totals_Minority_Current_Total;
    data["empId"] = this.empId;
    return data;
  }
}

export interface IEstimateFlattened {
  id: string;
  processedStatus: StatusCode;
  partitionId: string;
  lastModified: Date;
  lastProcessed?: Date | undefined;
  code?: string | undefined;
  name?: string | undefined;
  blobUrl?: string | undefined;
  description?: string | undefined;
  estimateVersion?: string | undefined;
  businessUnitCode?: string | undefined;
  isExcludedEstimate: boolean;
  isActiveEstimate: boolean;
  filters_Project_Name?: string | undefined;
  filters_Project_Number?: string | undefined;
  filters_Address?: string | undefined;
  filters_Latitude?: number | undefined;
  filters_Longitude?: number | undefined;
  filters_Status?: string | undefined;
  filters_Engineer?: string | undefined;
  filters_Resp_Estimator?: string | undefined;
  filters_Owner?: string | undefined;
  filters_Bid_Date?: Date | undefined;
  filters_Start_Date?: Date | undefined;
  filters_Review_Date?: Date | undefined;
  filters_Created_Date?: Date | undefined;
  filters_Modified_Date?: Date | undefined;
  filters_Modified_Time?: number | undefined;
  filters_Bid_Amount?: number | undefined;
  filters_Takeoff_Amount?: number | undefined;
  filters_Profit_Bidquan?: number | undefined;
  filters_Profit_Takeoff?: number | undefined;
  filters_Tot_Cost?: number | undefined;
  filters_Wc_State?: string | undefined;
  filters_Type_Work?: string | undefined;
  filters_Filter_1?: string | undefined;
  filters_Filter_2?: string | undefined;
  filters_Filter_3?: string | undefined;
  filters_Filter_4?: string | undefined;
  filters_Filter_5?: string | undefined;
  filters_Filter_6?: string | undefined;
  filters_User_Ascii1?: string | undefined;
  filters_User_Ascii2?: string | undefined;
  filters_User_Ascii3?: string | undefined;
  filters_User_Ascii4?: string | undefined;
  filters_User_Ascii5?: string | undefined;
  filters_User_Ascii6?: string | undefined;
  filters_User_Ascii7?: string | undefined;
  filters_User_Ascii8?: string | undefined;
  filters_User_Ascii9?: string | undefined;
  filters_User_Ascii10?: string | undefined;
  filters_User_Ascii11?: string | undefined;
  filters_User_Ascii12?: string | undefined;
  filters_User_Ascii13?: string | undefined;
  filters_User_Ascii14?: string | undefined;
  filters_User_Ascii15?: string | undefined;
  filters_User_Ascii16?: string | undefined;
  filters_User_Ascii17?: string | undefined;
  filters_User_Ascii18?: string | undefined;
  filters_User_Ascii19?: string | undefined;
  filters_User_Ascii20?: string | undefined;
  filters_User_Vendor1?: string | undefined;
  filters_User_Vendor2?: string | undefined;
  filters_User_Vendor3?: string | undefined;
  filters_User_Vendor4?: string | undefined;
  filters_User_Vendor5?: string | undefined;
  filters_User_Vendor6?: string | undefined;
  filters_User_Flag1?: string | undefined;
  filters_User_Flag2?: string | undefined;
  filters_User_Flag3?: string | undefined;
  filters_User_Flag4?: string | undefined;
  filters_User_Flag5?: string | undefined;
  filters_User_Flag6?: string | undefined;
  filters_User_Flag7?: string | undefined;
  filters_User_Flag8?: string | undefined;
  filters_User_Flag9?: string | undefined;
  filters_User_Flag10?: string | undefined;
  filters_User_Flag11?: string | undefined;
  filters_User_Flag12?: string | undefined;
  filters_User_Code1?: string | undefined;
  filters_User_Name2?: string | undefined;
  filters_User_Integer1?: number | undefined;
  filters_User_Integer2?: number | undefined;
  filters_User_Integer3?: number | undefined;
  filters_User_Integer4?: number | undefined;
  filters_User_Integer5?: number | undefined;
  filters_User_Number1?: number | undefined;
  filters_User_Number2?: number | undefined;
  filters_User_Number3?: number | undefined;
  filters_User_Number4?: number | undefined;
  filters_User_Number5?: number | undefined;
  filters_User_Number6?: number | undefined;
  filters_User_Number7?: number | undefined;
  filters_User_Number8?: number | undefined;
  filters_User_Number9?: number | undefined;
  filters_User_Number10?: number | undefined;
  filters_User_Number11?: number | undefined;
  filters_User_Number12?: number | undefined;
  filters_User_Number13?: number | undefined;
  filters_User_Number14?: number | undefined;
  filters_User_Number15?: number | undefined;
  filters_User_Number16?: number | undefined;
  filters_User_Number17?: number | undefined;
  filters_User_Number18?: number | undefined;
  filters_User_Number19?: number | undefined;
  filters_User_Number20?: number | undefined;
  filters_User_Perc1?: number | undefined;
  filters_User_Perc2?: number | undefined;
  filters_User_Def_Date?: Date | undefined;
  filters_User_Date2?: Date | undefined;
  filters_User_Date3?: Date | undefined;
  filters_User_Date4?: Date | undefined;
  filters_User_Date5?: Date | undefined;
  filters_User_Date6?: Date | undefined;
  filters_User_Date7?: Date | undefined;
  filters_User_Date8?: Date | undefined;
  filters_User_Date9?: Date | undefined;
  filters_User_Date10?: Date | undefined;
  filters_User_Date11?: Date | undefined;
  totals_BaseLabor_Direct: number;
  totals_BaseLabor_Indirect: number;
  totals_BaseLabor_Total: number;
  totals_Burden_Direct: number;
  totals_Burden_Indirect: number;
  totals_Burden_Total: number;
  totals_TotalLabor_Direct: number;
  totals_TotalLabor_Indirect: number;
  totals_TotalLabor_Total: number;
  totals_PermanentMaterial_Direct: number;
  totals_PermanentMaterial_Indirect: number;
  totals_PermanentMaterial_Total: number;
  totals_ConstructionMaterial_Direct: number;
  totals_ConstructionMaterial_Indirect: number;
  totals_ConstructionMaterial_Total: number;
  totals_Subcontract_Direct: number;
  totals_Subcontract_Indirect: number;
  totals_Subcontract_Total: number;
  totals_EquipmentOperatingExpense_Direct: number;
  totals_EquipmentOperatingExpense_Indirect: number;
  totals_EquipmentOperatingExpense_Total: number;
  totals_CompanyEquipment_Direct: number;
  totals_CompanyEquipment_Indirect: number;
  totals_CompanyEquipment_Total: number;
  totals_RentedEquipment_Direct: number;
  totals_RentedEquipment_Indirect: number;
  totals_RentedEquipment_Total: number;
  totals_Misc1_Direct: number;
  totals_Misc1_Indirect: number;
  totals_Misc1_Total: number;
  totals_Misc2_Direct: number;
  totals_Misc2_Indirect: number;
  totals_Misc2_Total: number;
  totals_Misc3_Direct: number;
  totals_Misc3_Indirect: number;
  totals_Misc3_Total: number;
  totals_TotalEntryCost_Takeoff_Direct: number;
  totals_TotalEntryCost_Takeoff_Indirect: number;
  totals_TotalEntryCost_Takeoff_Total: number;
  totals_TotalEntryCost_Bid_Direct: number;
  totals_TotalEntryCost_Bid_Indirect: number;
  totals_TotalEntryCost_Bid_Total: number;
  totals_BalMarkup_Bid: number;
  totals_ActualMarkup_Bid: number;
  totals_BalancedBid_Bid: number;
  totals_BidTotal_Bid: number;
  totals_AddonBondTotal: number;
  totals_TotalEqp_Direct: number;
  totals_TotalEqp_Indirect: number;
  totals_TotalEqp_Total: number;
  totals_Manhours_Direct: number;
  totals_Manhours_Indirect: number;
  totals_Manhours_Total: number;
  totals_Addon_Cost: number;
  totals_Bond: number;
  totals_Addon_Markup: number;
  totals_Addon_Total: number;
  totals_TotalCost_Takeoff: number;
  totals_Job_Duration: number;
  totals_BalMarkup_Takeoff: number;
  totals_ActualMarkup_Takeoff: number;
  totals_BalancedBid_Takeoff: number;
  totals_PassThrough_Cost: number;
  totals_PassThrough_Adjustment: number;
  totals_PassThrough_Total: number;
  totals_TotalCost_Bid_LessPassThrough: number;
  totals_TotalCost_Bid: number;
  totals_Total_User_Adjustments: number;
  totals_Total_User_Adjustments_Cost: number;
  totals_Desired_Bid: number;
  totals_Desired_Bid_Diff: number;
  totals_BidTotal_Takeoff: number;
  totals_TotalCost_Takeoff_LessPassThrough: number;
  totals_MarkupPercentCost_Takeoff: number;
  totals_MarkupPercentCost_Bid: number;
  totals_MarkupPercentSales_Takeoff: number;
  totals_MarkupPercentSales_Bid: number;
  totals_TotalCost_Takeoff_LessPassThroughAndAdjustments: number;
  totals_TotalCost_Bid_LessPassThroughAndAdjustments: number;
  totals_TotalEntryCost_Bid_Spread_Indirect: number;
  totals_AddonBond_Cost_Bid_Spread_Total: number;
  totals_TotalCost_Bid_Spread: number;
  totals_BalMarkup_Bid_Spread: number;
  totals_ActualMarkup_Bid_Spread: number;
  totals_Actv_User_Quan1: number;
  totals_Actv_User_Quan2: number;
  totals_Actv_User_Quan3: number;
  totals_Actv_User_Quan4: number;
  totals_Open_Biditems: number;
  totals_Minority_Goal_Percent: number;
  totals_Minority_Goal_Total: number;
  totals_Minority_Current_Percent: number;
  totals_Minority_Current_Total: number;
  empId?: string | undefined;
}

export class ODataQueryOptionsOfEstimateFlattened extends ODataQueryOptions
  implements IODataQueryOptionsOfEstimateFlattened {
  ifMatch?: ETagOfEstimateFlattened | undefined;
  ifNoneMatch?: ETagOfEstimateFlattened | undefined;

  constructor(data?: IODataQueryOptionsOfEstimateFlattened) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
    if (_data) {
      this.ifMatch = _data["ifMatch"]
        ? ETagOfEstimateFlattened.fromJS(_data["ifMatch"])
        : <any>undefined;
      this.ifNoneMatch = _data["ifNoneMatch"]
        ? ETagOfEstimateFlattened.fromJS(_data["ifNoneMatch"])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ODataQueryOptionsOfEstimateFlattened {
    data = typeof data === "object" ? data : {};
    let result = new ODataQueryOptionsOfEstimateFlattened();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["ifMatch"] = this.ifMatch ? this.ifMatch.toJSON() : <any>undefined;
    data["ifNoneMatch"] = this.ifNoneMatch
      ? this.ifNoneMatch.toJSON()
      : <any>undefined;
    super.toJSON(data);
    return data;
  }
}

export interface IODataQueryOptionsOfEstimateFlattened
  extends IODataQueryOptions {
  ifMatch?: ETagOfEstimateFlattened | undefined;
  ifNoneMatch?: ETagOfEstimateFlattened | undefined;
}

export class ETagOfEstimateFlattened extends ETag
  implements IETagOfEstimateFlattened {
  constructor(data?: IETagOfEstimateFlattened) {
    super(data);
  }

  init(_data?: any) {
    super.init(_data);
  }

  static fromJS(data: any): ETagOfEstimateFlattened {
    data = typeof data === "object" ? data : {};
    let result = new ETagOfEstimateFlattened();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    super.toJSON(data);
    return data;
  }
}

export interface IETagOfEstimateFlattened extends IETag {}

export class ReportsDto implements IReportsDto {
  reports?: ReportViewModel[] | undefined;

  constructor(data?: IReportsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["reports"])) {
        this.reports = [] as any;
        for (let item of _data["reports"])
          this.reports!.push(ReportViewModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ReportsDto {
    data = typeof data === "object" ? data : {};
    let result = new ReportsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.reports)) {
      data["reports"] = [];
      for (let item of this.reports) data["reports"].push(item.toJSON());
    }
    return data;
  }
}

export interface IReportsDto {
  reports?: ReportViewModel[] | undefined;
}

export class UniqueEstimateFilters implements IUniqueEstimateFilters {
  businessUnitCode?: string[] | undefined;
  filter1?: string[] | undefined;
  filter2?: string[] | undefined;
  filter3?: string[] | undefined;
  filter4?: string[] | undefined;
  filter5?: string[] | undefined;
  filter6?: string[] | undefined;
  estimator?: string[] | undefined;
  status?: string[] | undefined;
  owner?: string[] | undefined;
  wcState?: string[] | undefined;
  typeWork?: string[] | undefined;
  engineer?: string[] | undefined;
  projectName?: string[] | undefined;
  projectNumber?: string[] | undefined;

  constructor(data?: IUniqueEstimateFilters) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data["businessUnitCode"])) {
        this.businessUnitCode = [] as any;
        for (let item of _data["businessUnitCode"])
          this.businessUnitCode!.push(item);
      }
      if (Array.isArray(_data["filter1"])) {
        this.filter1 = [] as any;
        for (let item of _data["filter1"]) this.filter1!.push(item);
      }
      if (Array.isArray(_data["filter2"])) {
        this.filter2 = [] as any;
        for (let item of _data["filter2"]) this.filter2!.push(item);
      }
      if (Array.isArray(_data["filter3"])) {
        this.filter3 = [] as any;
        for (let item of _data["filter3"]) this.filter3!.push(item);
      }
      if (Array.isArray(_data["filter4"])) {
        this.filter4 = [] as any;
        for (let item of _data["filter4"]) this.filter4!.push(item);
      }
      if (Array.isArray(_data["filter5"])) {
        this.filter5 = [] as any;
        for (let item of _data["filter5"]) this.filter5!.push(item);
      }
      if (Array.isArray(_data["filter6"])) {
        this.filter6 = [] as any;
        for (let item of _data["filter6"]) this.filter6!.push(item);
      }
      if (Array.isArray(_data["estimator"])) {
        this.estimator = [] as any;
        for (let item of _data["estimator"]) this.estimator!.push(item);
      }
      if (Array.isArray(_data["status"])) {
        this.status = [] as any;
        for (let item of _data["status"]) this.status!.push(item);
      }
      if (Array.isArray(_data["owner"])) {
        this.owner = [] as any;
        for (let item of _data["owner"]) this.owner!.push(item);
      }
      if (Array.isArray(_data["wcState"])) {
        this.wcState = [] as any;
        for (let item of _data["wcState"]) this.wcState!.push(item);
      }
      if (Array.isArray(_data["typeWork"])) {
        this.typeWork = [] as any;
        for (let item of _data["typeWork"]) this.typeWork!.push(item);
      }
      if (Array.isArray(_data["engineer"])) {
        this.engineer = [] as any;
        for (let item of _data["engineer"]) this.engineer!.push(item);
      }
      if (Array.isArray(_data["projectName"])) {
        this.projectName = [] as any;
        for (let item of _data["projectName"]) this.projectName!.push(item);
      }
      if (Array.isArray(_data["projectNumber"])) {
        this.projectNumber = [] as any;
        for (let item of _data["projectNumber"]) this.projectNumber!.push(item);
      }
    }
  }

  static fromJS(data: any): UniqueEstimateFilters {
    data = typeof data === "object" ? data : {};
    let result = new UniqueEstimateFilters();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    if (Array.isArray(this.businessUnitCode)) {
      data["businessUnitCode"] = [];
      for (let item of this.businessUnitCode)
        data["businessUnitCode"].push(item);
    }
    if (Array.isArray(this.filter1)) {
      data["filter1"] = [];
      for (let item of this.filter1) data["filter1"].push(item);
    }
    if (Array.isArray(this.filter2)) {
      data["filter2"] = [];
      for (let item of this.filter2) data["filter2"].push(item);
    }
    if (Array.isArray(this.filter3)) {
      data["filter3"] = [];
      for (let item of this.filter3) data["filter3"].push(item);
    }
    if (Array.isArray(this.filter4)) {
      data["filter4"] = [];
      for (let item of this.filter4) data["filter4"].push(item);
    }
    if (Array.isArray(this.filter5)) {
      data["filter5"] = [];
      for (let item of this.filter5) data["filter5"].push(item);
    }
    if (Array.isArray(this.filter6)) {
      data["filter6"] = [];
      for (let item of this.filter6) data["filter6"].push(item);
    }
    if (Array.isArray(this.estimator)) {
      data["estimator"] = [];
      for (let item of this.estimator) data["estimator"].push(item);
    }
    if (Array.isArray(this.status)) {
      data["status"] = [];
      for (let item of this.status) data["status"].push(item);
    }
    if (Array.isArray(this.owner)) {
      data["owner"] = [];
      for (let item of this.owner) data["owner"].push(item);
    }
    if (Array.isArray(this.wcState)) {
      data["wcState"] = [];
      for (let item of this.wcState) data["wcState"].push(item);
    }
    if (Array.isArray(this.typeWork)) {
      data["typeWork"] = [];
      for (let item of this.typeWork) data["typeWork"].push(item);
    }
    if (Array.isArray(this.engineer)) {
      data["engineer"] = [];
      for (let item of this.engineer) data["engineer"].push(item);
    }
    if (Array.isArray(this.projectName)) {
      data["projectName"] = [];
      for (let item of this.projectName) data["projectName"].push(item);
    }
    if (Array.isArray(this.projectNumber)) {
      data["projectNumber"] = [];
      for (let item of this.projectNumber) data["projectNumber"].push(item);
    }
    return data;
  }
}

export interface IUniqueEstimateFilters {
  businessUnitCode?: string[] | undefined;
  filter1?: string[] | undefined;
  filter2?: string[] | undefined;
  filter3?: string[] | undefined;
  filter4?: string[] | undefined;
  filter5?: string[] | undefined;
  filter6?: string[] | undefined;
  estimator?: string[] | undefined;
  status?: string[] | undefined;
  owner?: string[] | undefined;
  wcState?: string[] | undefined;
  typeWork?: string[] | undefined;
  engineer?: string[] | undefined;
  projectName?: string[] | undefined;
  projectNumber?: string[] | undefined;
}

export class QuoteFolderSummaryDto implements IQuoteFolderSummaryDto {
  id!: string;
  folder!: string;
  description?: string | undefined;
  type?: string | undefined;
  estimatorInitials?: string | undefined;
  selectedVendor?: string | undefined;
  folderTotal!: number;
  hasPluggedPrices!: boolean;

  constructor(data?: IQuoteFolderSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.folder = _data["folder"];
      this.description = _data["description"];
      this.type = _data["type"];
      this.estimatorInitials = _data["estimatorInitials"];
      this.selectedVendor = _data["selectedVendor"];
      this.folderTotal = _data["folderTotal"];
      this.hasPluggedPrices = _data["hasPluggedPrices"];
    }
  }

  static fromJS(data: any): QuoteFolderSummaryDto {
    data = typeof data === "object" ? data : {};
    let result = new QuoteFolderSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["folder"] = this.folder;
    data["description"] = this.description;
    data["type"] = this.type;
    data["estimatorInitials"] = this.estimatorInitials;
    data["selectedVendor"] = this.selectedVendor;
    data["folderTotal"] = this.folderTotal;
    data["hasPluggedPrices"] = this.hasPluggedPrices;
    return data;
  }
}

export interface IQuoteFolderSummaryDto {
  id: string;
  folder: string;
  description?: string | undefined;
  type?: string | undefined;
  estimatorInitials?: string | undefined;
  selectedVendor?: string | undefined;
  folderTotal: number;
  hasPluggedPrices: boolean;
}

export class QuoteFolderDto implements IQuoteFolderDto {
  id!: string;
  quoteMasterId!: string;
  folder!: string;
  description?: string | undefined;
  type?: string | undefined;
  estimatorInitials?: string | undefined;
  notes?: string | undefined;
  breakout?: string | undefined;
  selectedVendor?: string | undefined;
  showBiditem?: string | undefined;
  showActivity?: string | undefined;
  showResource?: string | undefined;
  useSelfPerform?: string | undefined;
  totalAdditiveFactored!: number;
  totalAdditiveNonFactored!: number;
  totalNonAdditiveFactored!: number;
  totalNonAdditiveNonFactored!: number;
  updatedSelectedVendorTotal!: number;
  syncRequired!: boolean;
  folderTotal!: number;
  quoteItems!: QuoteItemDto[];
  quoteVendors!: QuoteVendorDto[];
  adHocAdjustmentItems!: QuoteItemDto[];

  constructor(data?: IQuoteFolderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.quoteItems = [];
      this.quoteVendors = [];
      this.adHocAdjustmentItems = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.quoteMasterId = _data["quoteMasterId"];
      this.folder = _data["folder"];
      this.description = _data["description"];
      this.type = _data["type"];
      this.estimatorInitials = _data["estimatorInitials"];
      this.notes = _data["notes"];
      this.breakout = _data["breakout"];
      this.selectedVendor = _data["selectedVendor"];
      this.showBiditem = _data["showBiditem"];
      this.showActivity = _data["showActivity"];
      this.showResource = _data["showResource"];
      this.useSelfPerform = _data["useSelfPerform"];
      this.totalAdditiveFactored = _data["totalAdditiveFactored"];
      this.totalAdditiveNonFactored = _data["totalAdditiveNonFactored"];
      this.totalNonAdditiveFactored = _data["totalNonAdditiveFactored"];
      this.totalNonAdditiveNonFactored = _data["totalNonAdditiveNonFactored"];
      this.updatedSelectedVendorTotal = _data["updatedSelectedVendorTotal"];
      this.syncRequired = _data["syncRequired"];
      this.folderTotal = _data["folderTotal"];
      if (Array.isArray(_data["quoteItems"])) {
        this.quoteItems = [] as any;
        for (let item of _data["quoteItems"])
          this.quoteItems!.push(QuoteItemDto.fromJS(item));
      }
      if (Array.isArray(_data["quoteVendors"])) {
        this.quoteVendors = [] as any;
        for (let item of _data["quoteVendors"])
          this.quoteVendors!.push(QuoteVendorDto.fromJS(item));
      }
      if (Array.isArray(_data["adHocAdjustmentItems"])) {
        this.adHocAdjustmentItems = [] as any;
        for (let item of _data["adHocAdjustmentItems"])
          this.adHocAdjustmentItems!.push(QuoteItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuoteFolderDto {
    data = typeof data === "object" ? data : {};
    let result = new QuoteFolderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["quoteMasterId"] = this.quoteMasterId;
    data["folder"] = this.folder;
    data["description"] = this.description;
    data["type"] = this.type;
    data["estimatorInitials"] = this.estimatorInitials;
    data["notes"] = this.notes;
    data["breakout"] = this.breakout;
    data["selectedVendor"] = this.selectedVendor;
    data["showBiditem"] = this.showBiditem;
    data["showActivity"] = this.showActivity;
    data["showResource"] = this.showResource;
    data["useSelfPerform"] = this.useSelfPerform;
    data["totalAdditiveFactored"] = this.totalAdditiveFactored;
    data["totalAdditiveNonFactored"] = this.totalAdditiveNonFactored;
    data["totalNonAdditiveFactored"] = this.totalNonAdditiveFactored;
    data["totalNonAdditiveNonFactored"] = this.totalNonAdditiveNonFactored;
    data["updatedSelectedVendorTotal"] = this.updatedSelectedVendorTotal;
    data["syncRequired"] = this.syncRequired;
    data["folderTotal"] = this.folderTotal;
    if (Array.isArray(this.quoteItems)) {
      data["quoteItems"] = [];
      for (let item of this.quoteItems) data["quoteItems"].push(item.toJSON());
    }
    if (Array.isArray(this.quoteVendors)) {
      data["quoteVendors"] = [];
      for (let item of this.quoteVendors)
        data["quoteVendors"].push(item.toJSON());
    }
    if (Array.isArray(this.adHocAdjustmentItems)) {
      data["adHocAdjustmentItems"] = [];
      for (let item of this.adHocAdjustmentItems)
        data["adHocAdjustmentItems"].push(item.toJSON());
    }
    return data;
  }
}

export interface IQuoteFolderDto {
  id: string;
  quoteMasterId: string;
  folder: string;
  description?: string | undefined;
  type?: string | undefined;
  estimatorInitials?: string | undefined;
  notes?: string | undefined;
  breakout?: string | undefined;
  selectedVendor?: string | undefined;
  showBiditem?: string | undefined;
  showActivity?: string | undefined;
  showResource?: string | undefined;
  useSelfPerform?: string | undefined;
  totalAdditiveFactored: number;
  totalAdditiveNonFactored: number;
  totalNonAdditiveFactored: number;
  totalNonAdditiveNonFactored: number;
  updatedSelectedVendorTotal: number;
  syncRequired: boolean;
  folderTotal: number;
  quoteItems: QuoteItemDto[];
  quoteVendors: QuoteVendorDto[];
  adHocAdjustmentItems: QuoteItemDto[];
}

export class QuoteItemDto implements IQuoteItemDto {
  id!: string;
  quoteFolderId!: string;
  biditem!: string;
  activity!: string;
  resource!: string;
  plugPrice!: number;
  unit?: string | undefined;
  quantityAdditiveFactored!: number;
  quantityAdditiveNonFactored!: number;
  quantityNonAdditiveFactored!: number;
  quantityNonAdditiveNonFactored!: number;
  currency?: string | undefined;
  isSelfPerform?: string | undefined;
  selfAmount!: number;
  selectedVendor?: string | undefined;
  alternateSort?: string | undefined;
  alternateDescription?: string | undefined;
  addendumNumber?: string | undefined;
  actualPlug!: number;
  alternateQuantity!: number;
  unitCostInEstimate!: number;
  clientNo?: string | undefined;
  isAdhocAdjustmentItem!: boolean;
  syncRequired!: boolean;
  quotes!: QuoteDto[];

  constructor(data?: IQuoteItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.quotes = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.quoteFolderId = _data["quoteFolderId"];
      this.biditem = _data["biditem"];
      this.activity = _data["activity"];
      this.resource = _data["resource"];
      this.plugPrice = _data["plugPrice"];
      this.unit = _data["unit"];
      this.quantityAdditiveFactored = _data["quantityAdditiveFactored"];
      this.quantityAdditiveNonFactored = _data["quantityAdditiveNonFactored"];
      this.quantityNonAdditiveFactored = _data["quantityNonAdditiveFactored"];
      this.quantityNonAdditiveNonFactored =
        _data["quantityNonAdditiveNonFactored"];
      this.currency = _data["currency"];
      this.isSelfPerform = _data["isSelfPerform"];
      this.selfAmount = _data["selfAmount"];
      this.selectedVendor = _data["selectedVendor"];
      this.alternateSort = _data["alternateSort"];
      this.alternateDescription = _data["alternateDescription"];
      this.addendumNumber = _data["addendumNumber"];
      this.actualPlug = _data["actualPlug"];
      this.alternateQuantity = _data["alternateQuantity"];
      this.unitCostInEstimate = _data["unitCostInEstimate"];
      this.clientNo = _data["clientNo"];
      this.isAdhocAdjustmentItem = _data["isAdhocAdjustmentItem"];
      this.syncRequired = _data["syncRequired"];
      if (Array.isArray(_data["quotes"])) {
        this.quotes = [] as any;
        for (let item of _data["quotes"])
          this.quotes!.push(QuoteDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuoteItemDto {
    data = typeof data === "object" ? data : {};
    let result = new QuoteItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["quoteFolderId"] = this.quoteFolderId;
    data["biditem"] = this.biditem;
    data["activity"] = this.activity;
    data["resource"] = this.resource;
    data["plugPrice"] = this.plugPrice;
    data["unit"] = this.unit;
    data["quantityAdditiveFactored"] = this.quantityAdditiveFactored;
    data["quantityAdditiveNonFactored"] = this.quantityAdditiveNonFactored;
    data["quantityNonAdditiveFactored"] = this.quantityNonAdditiveFactored;
    data[
      "quantityNonAdditiveNonFactored"
    ] = this.quantityNonAdditiveNonFactored;
    data["currency"] = this.currency;
    data["isSelfPerform"] = this.isSelfPerform;
    data["selfAmount"] = this.selfAmount;
    data["selectedVendor"] = this.selectedVendor;
    data["alternateSort"] = this.alternateSort;
    data["alternateDescription"] = this.alternateDescription;
    data["addendumNumber"] = this.addendumNumber;
    data["actualPlug"] = this.actualPlug;
    data["alternateQuantity"] = this.alternateQuantity;
    data["unitCostInEstimate"] = this.unitCostInEstimate;
    data["clientNo"] = this.clientNo;
    data["isAdhocAdjustmentItem"] = this.isAdhocAdjustmentItem;
    data["syncRequired"] = this.syncRequired;
    if (Array.isArray(this.quotes)) {
      data["quotes"] = [];
      for (let item of this.quotes) data["quotes"].push(item.toJSON());
    }
    return data;
  }
}

export interface IQuoteItemDto {
  id: string;
  quoteFolderId: string;
  biditem: string;
  activity: string;
  resource: string;
  plugPrice: number;
  unit?: string | undefined;
  quantityAdditiveFactored: number;
  quantityAdditiveNonFactored: number;
  quantityNonAdditiveFactored: number;
  quantityNonAdditiveNonFactored: number;
  currency?: string | undefined;
  isSelfPerform?: string | undefined;
  selfAmount: number;
  selectedVendor?: string | undefined;
  alternateSort?: string | undefined;
  alternateDescription?: string | undefined;
  addendumNumber?: string | undefined;
  actualPlug: number;
  alternateQuantity: number;
  unitCostInEstimate: number;
  clientNo?: string | undefined;
  isAdhocAdjustmentItem: boolean;
  syncRequired: boolean;
  quotes: QuoteDto[];
}

export class QuoteDto implements IQuoteDto {
  id!: string;
  quoteItemId!: string;
  quoteVendorId!: string;
  quoteVendorCode!: string;
  plugIndicator?: string | undefined;
  previousPrice!: number;
  previousUnit?: string | undefined;
  quantityAdditiveFactored!: number;
  quantityAdditiveNonFactored!: number;
  quantityNonAdditiveFactored!: number;
  quantityNonAdditiveNonFactored!: number;
  totalAdditiveFactored!: number;
  totalAdditiveNonFactored!: number;
  totalNonAdditiveFactored!: number;
  totalNonAdditiveNonFactored!: number;
  quoteUnit?: string | undefined;
  quotePrice!: number;
  quoteCurrency?: string | undefined;
  lastModified!: Date;
  syncRequired!: boolean;

  constructor(data?: IQuoteDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.quoteItemId = _data["quoteItemId"];
      this.quoteVendorId = _data["quoteVendorId"];
      this.quoteVendorCode = _data["quoteVendorCode"];
      this.plugIndicator = _data["plugIndicator"];
      this.previousPrice = _data["previousPrice"];
      this.previousUnit = _data["previousUnit"];
      this.quantityAdditiveFactored = _data["quantityAdditiveFactored"];
      this.quantityAdditiveNonFactored = _data["quantityAdditiveNonFactored"];
      this.quantityNonAdditiveFactored = _data["quantityNonAdditiveFactored"];
      this.quantityNonAdditiveNonFactored =
        _data["quantityNonAdditiveNonFactored"];
      this.totalAdditiveFactored = _data["totalAdditiveFactored"];
      this.totalAdditiveNonFactored = _data["totalAdditiveNonFactored"];
      this.totalNonAdditiveFactored = _data["totalNonAdditiveFactored"];
      this.totalNonAdditiveNonFactored = _data["totalNonAdditiveNonFactored"];
      this.quoteUnit = _data["quoteUnit"];
      this.quotePrice = _data["quotePrice"];
      this.quoteCurrency = _data["quoteCurrency"];
      this.lastModified = _data["lastModified"]
        ? new Date(_data["lastModified"].toString())
        : <any>undefined;
      this.syncRequired = _data["syncRequired"];
    }
  }

  static fromJS(data: any): QuoteDto {
    data = typeof data === "object" ? data : {};
    let result = new QuoteDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["quoteItemId"] = this.quoteItemId;
    data["quoteVendorId"] = this.quoteVendorId;
    data["quoteVendorCode"] = this.quoteVendorCode;
    data["plugIndicator"] = this.plugIndicator;
    data["previousPrice"] = this.previousPrice;
    data["previousUnit"] = this.previousUnit;
    data["quantityAdditiveFactored"] = this.quantityAdditiveFactored;
    data["quantityAdditiveNonFactored"] = this.quantityAdditiveNonFactored;
    data["quantityNonAdditiveFactored"] = this.quantityNonAdditiveFactored;
    data[
      "quantityNonAdditiveNonFactored"
    ] = this.quantityNonAdditiveNonFactored;
    data["totalAdditiveFactored"] = this.totalAdditiveFactored;
    data["totalAdditiveNonFactored"] = this.totalAdditiveNonFactored;
    data["totalNonAdditiveFactored"] = this.totalNonAdditiveFactored;
    data["totalNonAdditiveNonFactored"] = this.totalNonAdditiveNonFactored;
    data["quoteUnit"] = this.quoteUnit;
    data["quotePrice"] = this.quotePrice;
    data["quoteCurrency"] = this.quoteCurrency;
    data["lastModified"] = this.lastModified
      ? this.lastModified.toISOString()
      : <any>undefined;
    data["syncRequired"] = this.syncRequired;
    return data;
  }
}

export interface IQuoteDto {
  id: string;
  quoteItemId: string;
  quoteVendorId: string;
  quoteVendorCode: string;
  plugIndicator?: string | undefined;
  previousPrice: number;
  previousUnit?: string | undefined;
  quantityAdditiveFactored: number;
  quantityAdditiveNonFactored: number;
  quantityNonAdditiveFactored: number;
  quantityNonAdditiveNonFactored: number;
  totalAdditiveFactored: number;
  totalAdditiveNonFactored: number;
  totalNonAdditiveFactored: number;
  totalNonAdditiveNonFactored: number;
  quoteUnit?: string | undefined;
  quotePrice: number;
  quoteCurrency?: string | undefined;
  lastModified: Date;
  syncRequired: boolean;
}

export class QuoteVendorDto implements IQuoteVendorDto {
  id!: string;
  quoteFolderId!: string;
  code!: string;
  name?: string | undefined;
  totalAdditiveFactored!: number;
  totalAdditiveNonFactored!: number;
  totalNonAdditiveFactored!: number;
  totalNonAdditiveNonFactored!: number;
  plugAdditiveFactored!: number;
  plugAdditiveNonFactored!: number;
  plugNonAdditiveFactored!: number;
  plugNonAdditiveNonFactored!: number;
  adHocAdditiveFactored!: number;
  adHocAdditiveNonFactored!: number;
  adHocNonAdditiveFactored!: number;
  adHocNonAdditiveNonFactored!: number;
  vendorContact?: string | undefined;
  jobTitle?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  cellPhone?: string | undefined;
  fax?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  address3?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zip?: string | undefined;
  bondable?: string | undefined;
  bondRate!: number;
  mobilizationAmount!: number;
  adjustmentPercent!: number;
  adjustmentAmount!: number;
  minorityStatuses?: MinorityClass[] | undefined;
  minority1?: MinorityClass | undefined;
  minority2?: MinorityClass | undefined;
  minority3?: MinorityClass | undefined;
  minority4?: MinorityClass | undefined;
  minority5?: MinorityClass | undefined;
  excluded?: string | undefined;
  notes?: string | undefined;
  pluggedAmount!: number;
  quotedAmount!: number;
  totalAdditive!: number;
  syncRequired!: boolean;
  lastModified!: Date;
  totalAdjustments!: number;
  vendorTotal!: number;

  constructor(data?: IQuoteVendorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.quoteFolderId = _data["quoteFolderId"];
      this.code = _data["code"];
      this.name = _data["name"];
      this.totalAdditiveFactored = _data["totalAdditiveFactored"];
      this.totalAdditiveNonFactored = _data["totalAdditiveNonFactored"];
      this.totalNonAdditiveFactored = _data["totalNonAdditiveFactored"];
      this.totalNonAdditiveNonFactored = _data["totalNonAdditiveNonFactored"];
      this.plugAdditiveFactored = _data["plugAdditiveFactored"];
      this.plugAdditiveNonFactored = _data["plugAdditiveNonFactored"];
      this.plugNonAdditiveFactored = _data["plugNonAdditiveFactored"];
      this.plugNonAdditiveNonFactored = _data["plugNonAdditiveNonFactored"];
      this.adHocAdditiveFactored = _data["adHocAdditiveFactored"];
      this.adHocAdditiveNonFactored = _data["adHocAdditiveNonFactored"];
      this.adHocNonAdditiveFactored = _data["adHocNonAdditiveFactored"];
      this.adHocNonAdditiveNonFactored = _data["adHocNonAdditiveNonFactored"];
      this.vendorContact = _data["vendorContact"];
      this.jobTitle = _data["jobTitle"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.email = _data["email"];
      this.phone = _data["phone"];
      this.cellPhone = _data["cellPhone"];
      this.fax = _data["fax"];
      this.address1 = _data["address1"];
      this.address2 = _data["address2"];
      this.address3 = _data["address3"];
      this.city = _data["city"];
      this.state = _data["state"];
      this.zip = _data["zip"];
      this.bondable = _data["bondable"];
      this.bondRate = _data["bondRate"];
      this.mobilizationAmount = _data["mobilizationAmount"];
      this.adjustmentPercent = _data["adjustmentPercent"];
      this.adjustmentAmount = _data["adjustmentAmount"];
      if (Array.isArray(_data["minorityStatuses"])) {
        this.minorityStatuses = [] as any;
        for (let item of _data["minorityStatuses"])
          this.minorityStatuses!.push(MinorityClass.fromJS(item));
      }
      this.minority1 = _data["minority1"]
        ? MinorityClass.fromJS(_data["minority1"])
        : <any>undefined;
      this.minority2 = _data["minority2"]
        ? MinorityClass.fromJS(_data["minority2"])
        : <any>undefined;
      this.minority3 = _data["minority3"]
        ? MinorityClass.fromJS(_data["minority3"])
        : <any>undefined;
      this.minority4 = _data["minority4"]
        ? MinorityClass.fromJS(_data["minority4"])
        : <any>undefined;
      this.minority5 = _data["minority5"]
        ? MinorityClass.fromJS(_data["minority5"])
        : <any>undefined;
      this.excluded = _data["excluded"];
      this.notes = _data["notes"];
      this.pluggedAmount = _data["pluggedAmount"];
      this.quotedAmount = _data["quotedAmount"];
      this.totalAdditive = _data["totalAdditive"];
      this.syncRequired = _data["syncRequired"];
      this.lastModified = _data["lastModified"]
        ? new Date(_data["lastModified"].toString())
        : <any>undefined;
      this.totalAdjustments = _data["totalAdjustments"];
      this.vendorTotal = _data["vendorTotal"];
    }
  }

  static fromJS(data: any): QuoteVendorDto {
    data = typeof data === "object" ? data : {};
    let result = new QuoteVendorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["quoteFolderId"] = this.quoteFolderId;
    data["code"] = this.code;
    data["name"] = this.name;
    data["totalAdditiveFactored"] = this.totalAdditiveFactored;
    data["totalAdditiveNonFactored"] = this.totalAdditiveNonFactored;
    data["totalNonAdditiveFactored"] = this.totalNonAdditiveFactored;
    data["totalNonAdditiveNonFactored"] = this.totalNonAdditiveNonFactored;
    data["plugAdditiveFactored"] = this.plugAdditiveFactored;
    data["plugAdditiveNonFactored"] = this.plugAdditiveNonFactored;
    data["plugNonAdditiveFactored"] = this.plugNonAdditiveFactored;
    data["plugNonAdditiveNonFactored"] = this.plugNonAdditiveNonFactored;
    data["adHocAdditiveFactored"] = this.adHocAdditiveFactored;
    data["adHocAdditiveNonFactored"] = this.adHocAdditiveNonFactored;
    data["adHocNonAdditiveFactored"] = this.adHocNonAdditiveFactored;
    data["adHocNonAdditiveNonFactored"] = this.adHocNonAdditiveNonFactored;
    data["vendorContact"] = this.vendorContact;
    data["jobTitle"] = this.jobTitle;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["email"] = this.email;
    data["phone"] = this.phone;
    data["cellPhone"] = this.cellPhone;
    data["fax"] = this.fax;
    data["address1"] = this.address1;
    data["address2"] = this.address2;
    data["address3"] = this.address3;
    data["city"] = this.city;
    data["state"] = this.state;
    data["zip"] = this.zip;
    data["bondable"] = this.bondable;
    data["bondRate"] = this.bondRate;
    data["mobilizationAmount"] = this.mobilizationAmount;
    data["adjustmentPercent"] = this.adjustmentPercent;
    data["adjustmentAmount"] = this.adjustmentAmount;
    if (Array.isArray(this.minorityStatuses)) {
      data["minorityStatuses"] = [];
      for (let item of this.minorityStatuses)
        data["minorityStatuses"].push(item.toJSON());
    }
    data["minority1"] = this.minority1
      ? this.minority1.toJSON()
      : <any>undefined;
    data["minority2"] = this.minority2
      ? this.minority2.toJSON()
      : <any>undefined;
    data["minority3"] = this.minority3
      ? this.minority3.toJSON()
      : <any>undefined;
    data["minority4"] = this.minority4
      ? this.minority4.toJSON()
      : <any>undefined;
    data["minority5"] = this.minority5
      ? this.minority5.toJSON()
      : <any>undefined;
    data["excluded"] = this.excluded;
    data["notes"] = this.notes;
    data["pluggedAmount"] = this.pluggedAmount;
    data["quotedAmount"] = this.quotedAmount;
    data["totalAdditive"] = this.totalAdditive;
    data["syncRequired"] = this.syncRequired;
    data["lastModified"] = this.lastModified
      ? this.lastModified.toISOString()
      : <any>undefined;
    data["totalAdjustments"] = this.totalAdjustments;
    data["vendorTotal"] = this.vendorTotal;
    return data;
  }
}

export interface IQuoteVendorDto {
  id: string;
  quoteFolderId: string;
  code: string;
  name?: string | undefined;
  totalAdditiveFactored: number;
  totalAdditiveNonFactored: number;
  totalNonAdditiveFactored: number;
  totalNonAdditiveNonFactored: number;
  plugAdditiveFactored: number;
  plugAdditiveNonFactored: number;
  plugNonAdditiveFactored: number;
  plugNonAdditiveNonFactored: number;
  adHocAdditiveFactored: number;
  adHocAdditiveNonFactored: number;
  adHocNonAdditiveFactored: number;
  adHocNonAdditiveNonFactored: number;
  vendorContact?: string | undefined;
  jobTitle?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  cellPhone?: string | undefined;
  fax?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  address3?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zip?: string | undefined;
  bondable?: string | undefined;
  bondRate: number;
  mobilizationAmount: number;
  adjustmentPercent: number;
  adjustmentAmount: number;
  minorityStatuses?: MinorityClass[] | undefined;
  minority1?: MinorityClass | undefined;
  minority2?: MinorityClass | undefined;
  minority3?: MinorityClass | undefined;
  minority4?: MinorityClass | undefined;
  minority5?: MinorityClass | undefined;
  excluded?: string | undefined;
  notes?: string | undefined;
  pluggedAmount: number;
  quotedAmount: number;
  totalAdditive: number;
  syncRequired: boolean;
  lastModified: Date;
  totalAdjustments: number;
  vendorTotal: number;
}

export class MinorityClass implements IMinorityClass {
  code?: string | undefined;
  percent!: number;
  certificateNumber?: string | undefined;

  constructor(data?: IMinorityClass) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data["code"];
      this.percent = _data["percent"];
      this.certificateNumber = _data["certificateNumber"];
    }
  }

  static fromJS(data: any): MinorityClass {
    data = typeof data === "object" ? data : {};
    let result = new MinorityClass();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["code"] = this.code;
    data["percent"] = this.percent;
    data["certificateNumber"] = this.certificateNumber;
    return data;
  }
}

export interface IMinorityClass {
  code?: string | undefined;
  percent: number;
  certificateNumber?: string | undefined;
}

export class QuoteMasterDto implements IQuoteMasterDto {
  id!: string;
  estimateId!: string;
  adjustToBidQuantity?: string | undefined;
  syncRequired!: boolean;
  quoteFolders!: QuoteFolderDto[];

  constructor(data?: IQuoteMasterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.quoteFolders = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.estimateId = _data["estimateId"];
      this.adjustToBidQuantity = _data["adjustToBidQuantity"];
      this.syncRequired = _data["syncRequired"];
      if (Array.isArray(_data["quoteFolders"])) {
        this.quoteFolders = [] as any;
        for (let item of _data["quoteFolders"])
          this.quoteFolders!.push(QuoteFolderDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): QuoteMasterDto {
    data = typeof data === "object" ? data : {};
    let result = new QuoteMasterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["estimateId"] = this.estimateId;
    data["adjustToBidQuantity"] = this.adjustToBidQuantity;
    data["syncRequired"] = this.syncRequired;
    if (Array.isArray(this.quoteFolders)) {
      data["quoteFolders"] = [];
      for (let item of this.quoteFolders)
        data["quoteFolders"].push(item.toJSON());
    }
    return data;
  }
}

export interface IQuoteMasterDto {
  id: string;
  estimateId: string;
  adjustToBidQuantity?: string | undefined;
  syncRequired: boolean;
  quoteFolders: QuoteFolderDto[];
}

export class GenericResponse implements IGenericResponse {
  success!: boolean;
  errorMessage?: string | undefined;

  constructor(data?: IGenericResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.success = _data["success"];
      this.errorMessage = _data["errorMessage"];
    }
  }

  static fromJS(data: any): GenericResponse {
    data = typeof data === "object" ? data : {};
    let result = new GenericResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["success"] = this.success;
    data["errorMessage"] = this.errorMessage;
    return data;
  }
}

export interface IGenericResponse {
  success: boolean;
  errorMessage?: string | undefined;
}

export class AcceptQuoteDto implements IAcceptQuoteDto {
  estimateId!: string;
  vendorCode!: string;
  prices!: QuotePriceDto[];
  adhocAdjustments!: QuoteAdhocAdjustmentDto[];
  notes!: QuoteVendorNotesDto[];

  constructor(data?: IAcceptQuoteDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.prices = [];
      this.adhocAdjustments = [];
      this.notes = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      this.estimateId = _data["estimateId"];
      this.vendorCode = _data["vendorCode"];
      if (Array.isArray(_data["prices"])) {
        this.prices = [] as any;
        for (let item of _data["prices"])
          this.prices!.push(QuotePriceDto.fromJS(item));
      }
      if (Array.isArray(_data["adhocAdjustments"])) {
        this.adhocAdjustments = [] as any;
        for (let item of _data["adhocAdjustments"])
          this.adhocAdjustments!.push(QuoteAdhocAdjustmentDto.fromJS(item));
      }
      if (Array.isArray(_data["notes"])) {
        this.notes = [] as any;
        for (let item of _data["notes"])
          this.notes!.push(QuoteVendorNotesDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AcceptQuoteDto {
    data = typeof data === "object" ? data : {};
    let result = new AcceptQuoteDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["estimateId"] = this.estimateId;
    data["vendorCode"] = this.vendorCode;
    if (Array.isArray(this.prices)) {
      data["prices"] = [];
      for (let item of this.prices) data["prices"].push(item.toJSON());
    }
    if (Array.isArray(this.adhocAdjustments)) {
      data["adhocAdjustments"] = [];
      for (let item of this.adhocAdjustments)
        data["adhocAdjustments"].push(item.toJSON());
    }
    if (Array.isArray(this.notes)) {
      data["notes"] = [];
      for (let item of this.notes) data["notes"].push(item.toJSON());
    }
    return data;
  }
}

export interface IAcceptQuoteDto {
  estimateId: string;
  vendorCode: string;
  prices: QuotePriceDto[];
  adhocAdjustments: QuoteAdhocAdjustmentDto[];
  notes: QuoteVendorNotesDto[];
}

export class QuotePriceDto implements IQuotePriceDto {
  quoteItemId!: string;
  quoteFolderId!: string;
  quotePrice!: number;

  constructor(data?: IQuotePriceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.quoteItemId = _data["quoteItemId"];
      this.quoteFolderId = _data["quoteFolderId"];
      this.quotePrice = _data["quotePrice"];
    }
  }

  static fromJS(data: any): QuotePriceDto {
    data = typeof data === "object" ? data : {};
    let result = new QuotePriceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["quoteItemId"] = this.quoteItemId;
    data["quoteFolderId"] = this.quoteFolderId;
    data["quotePrice"] = this.quotePrice;
    return data;
  }
}

export interface IQuotePriceDto {
  quoteItemId: string;
  quoteFolderId: string;
  quotePrice: number;
}

export class QuoteAdhocAdjustmentDto implements IQuoteAdhocAdjustmentDto {
  id!: string;
  quoteFolderId!: string;
  description?: string | undefined;
  total!: number;

  constructor(data?: IQuoteAdhocAdjustmentDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.quoteFolderId = _data["quoteFolderId"];
      this.description = _data["description"];
      this.total = _data["total"];
    }
  }

  static fromJS(data: any): QuoteAdhocAdjustmentDto {
    data = typeof data === "object" ? data : {};
    let result = new QuoteAdhocAdjustmentDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["quoteFolderId"] = this.quoteFolderId;
    data["description"] = this.description;
    data["total"] = this.total;
    return data;
  }
}

export interface IQuoteAdhocAdjustmentDto {
  id: string;
  quoteFolderId: string;
  description?: string | undefined;
  total: number;
}

export class QuoteVendorNotesDto implements IQuoteVendorNotesDto {
  quoteFolderId!: string;
  notes?: string | undefined;

  constructor(data?: IQuoteVendorNotesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.quoteFolderId = _data["quoteFolderId"];
      this.notes = _data["notes"];
    }
  }

  static fromJS(data: any): QuoteVendorNotesDto {
    data = typeof data === "object" ? data : {};
    let result = new QuoteVendorNotesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["quoteFolderId"] = this.quoteFolderId;
    data["notes"] = this.notes;
    return data;
  }
}

export interface IQuoteVendorNotesDto {
  quoteFolderId: string;
  notes?: string | undefined;
}

export class EstimateSyncStatusDto implements IEstimateSyncStatusDto {
  estimateId!: string;
  lastSyncedPrices!: Date;

  constructor(data?: IEstimateSyncStatusDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.estimateId = _data["estimateId"];
      this.lastSyncedPrices = _data["lastSyncedPrices"];
    }
  }

  static fromJS(data: any): EstimateSyncStatusDto {
    data = typeof data === "object" ? data : {};
    let result = new EstimateSyncStatusDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["estimateId"] = this.estimateId;
    data["lastSyncedPrices"] = this.lastSyncedPrices;

    return data;
  }
}
export interface IEstimateSyncStatusDto {
  estimateId: string;
  lastSyncedPrices: Date;
}
export class QuoteVendorSummaryDto implements IQuoteVendorSummaryDto {
  id!: string;
  quoteFolderId!: string;
  code!: string;
  name?: string | undefined;
  vendorContact?: string | undefined;
  jobTitle?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  cellPhone?: string | undefined;
  fax?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  address3?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zip?: string | undefined;
  adjustmentPercent!: number;
  adjustmentAmount!: number;
  minorityStatuses?: MinorityClass[] | undefined;
  pluggedAmount!: number;
  quotedAmount!: number;
  totalAdditive!: number;

  constructor(data?: IQuoteVendorSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data["id"];
      this.quoteFolderId = _data["quoteFolderId"];
      this.code = _data["code"];
      this.name = _data["name"];
      this.vendorContact = _data["vendorContact"];
      this.jobTitle = _data["jobTitle"];
      this.firstName = _data["firstName"];
      this.lastName = _data["lastName"];
      this.email = _data["email"];
      this.phone = _data["phone"];
      this.cellPhone = _data["cellPhone"];
      this.fax = _data["fax"];
      this.address1 = _data["address1"];
      this.address2 = _data["address2"];
      this.address3 = _data["address3"];
      this.city = _data["city"];
      this.state = _data["state"];
      this.zip = _data["zip"];
      this.adjustmentPercent = _data["adjustmentPercent"];
      this.adjustmentAmount = _data["adjustmentAmount"];
      if (Array.isArray(_data["minorityStatuses"])) {
        this.minorityStatuses = [] as any;
        for (let item of _data["minorityStatuses"])
          this.minorityStatuses!.push(MinorityClass.fromJS(item));
      }
      this.pluggedAmount = _data["pluggedAmount"];
      this.quotedAmount = _data["quotedAmount"];
      this.totalAdditive = _data["totalAdditive"];
    }
  }

  static fromJS(data: any): QuoteVendorSummaryDto {
    data = typeof data === "object" ? data : {};
    let result = new QuoteVendorSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["id"] = this.id;
    data["quoteFolderId"] = this.quoteFolderId;
    data["code"] = this.code;
    data["name"] = this.name;
    data["vendorContact"] = this.vendorContact;
    data["jobTitle"] = this.jobTitle;
    data["firstName"] = this.firstName;
    data["lastName"] = this.lastName;
    data["email"] = this.email;
    data["phone"] = this.phone;
    data["cellPhone"] = this.cellPhone;
    data["fax"] = this.fax;
    data["address1"] = this.address1;
    data["address2"] = this.address2;
    data["address3"] = this.address3;
    data["city"] = this.city;
    data["state"] = this.state;
    data["zip"] = this.zip;
    data["adjustmentPercent"] = this.adjustmentPercent;
    data["adjustmentAmount"] = this.adjustmentAmount;
    if (Array.isArray(this.minorityStatuses)) {
      data["minorityStatuses"] = [];
      for (let item of this.minorityStatuses)
        data["minorityStatuses"].push(item.toJSON());
    }
    data["pluggedAmount"] = this.pluggedAmount;
    data["quotedAmount"] = this.quotedAmount;
    data["totalAdditive"] = this.totalAdditive;
    return data;
  }
}

export interface IQuoteVendorSummaryDto {
  id: string;
  quoteFolderId: string;
  code: string;
  name?: string | undefined;
  vendorContact?: string | undefined;
  jobTitle?: string | undefined;
  firstName?: string | undefined;
  lastName?: string | undefined;
  email?: string | undefined;
  phone?: string | undefined;
  cellPhone?: string | undefined;
  fax?: string | undefined;
  address1?: string | undefined;
  address2?: string | undefined;
  address3?: string | undefined;
  city?: string | undefined;
  state?: string | undefined;
  zip?: string | undefined;
  adjustmentPercent: number;
  adjustmentAmount: number;
  minorityStatuses?: MinorityClass[] | undefined;
  pluggedAmount: number;
  quotedAmount: number;
  totalAdditive: number;
}

export interface FileResponse {
  data: Blob;
  status: number;
  fileName?: string;
  headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new SwaggerException(message, status, response, headers, null);
}
